function _get(target, property, receiver) {
  return (
    typeof Reflect < "u" && Reflect.get
      ? (_get = Reflect.get)
      : (_get = function (target2, property2, receiver2) {
          var base = _superPropBase(target2, property2);
          if (base) {
            var desc = Object.getOwnPropertyDescriptor(base, property2);
            return desc.get ? desc.get.call(receiver2) : desc.value;
          }
        }),
    _get(target, property, receiver || target)
  );
}
function _superPropBase(object, property) {
  for (
    ;
    !Object.prototype.hasOwnProperty.call(object, property) &&
    ((object = _getPrototypeOf(object)), object !== null);

  );
  return object;
}
function _inherits(subClass, superClass) {
  if (typeof superClass != "function" && superClass !== null)
    throw new TypeError("Super expression must either be null or a function");
  (subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: { value: subClass, writable: !0, configurable: !0 },
  })),
    superClass && _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  return (
    (_setPrototypeOf =
      Object.setPrototypeOf ||
      function (o2, p2) {
        return (o2.__proto__ = p2), o2;
      }),
    _setPrototypeOf(o, p)
  );
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function () {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else result = Super.apply(this, arguments);
    return _possibleConstructorReturn(this, result);
  };
}
function _possibleConstructorReturn(self, call) {
  return call && (_typeof(call) === "object" || typeof call == "function")
    ? call
    : _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0)
    throw new ReferenceError(
      "this hasn't been initialised - super() hasn't been called"
    );
  return self;
}
function _isNativeReflectConstruct() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return (
      Boolean.prototype.valueOf.call(
        Reflect.construct(Boolean, [], function () {})
      ),
      !0
    );
  } catch {
    return !1;
  }
}
function _getPrototypeOf(o) {
  return (
    (_getPrototypeOf = Object.setPrototypeOf
      ? Object.getPrototypeOf
      : function (o2) {
          return o2.__proto__ || Object.getPrototypeOf(o2);
        }),
    _getPrototypeOf(o)
  );
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    (descriptor.enumerable = descriptor.enumerable || !1),
      (descriptor.configurable = !0),
      "value" in descriptor && (descriptor.writable = !0),
      Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  return (
    protoProps && _defineProperties(Constructor.prototype, protoProps),
    staticProps && _defineProperties(Constructor, staticProps),
    Constructor
  );
}
function _typeof(obj) {
  "@babel/helpers - typeof";
  return (
    typeof Symbol == "function" && typeof Symbol.iterator == "symbol"
      ? (_typeof = function (obj2) {
          return typeof obj2;
        })
      : (_typeof = function (obj2) {
          return obj2 &&
            typeof Symbol == "function" &&
            obj2.constructor === Symbol &&
            obj2 !== Symbol.prototype
            ? "symbol"
            : typeof obj2;
        }),
    _typeof(obj)
  );
}
(function ($) {
  var $ = (jQuery = $),
    cc = { sections: [] };
  (theme.cartNoteMonitor = {
    load: function ($notes) {
      $notes.on(
        "change.themeCartNoteMonitor paste.themeCartNoteMonitor keyup.themeCartNoteMonitor",
        function () {
          theme.cartNoteMonitor.postUpdate($(this).val());
        }
      );
    },
    unload: function ($notes) {
      $notes.off(".themeCartNoteMonitor");
    },
    updateThrottleTimeoutId: -1,
    updateThrottleInterval: 500,
    postUpdate: function (val) {
      clearTimeout(theme.cartNoteMonitor.updateThrottleTimeoutId),
        (theme.cartNoteMonitor.updateThrottleTimeoutId = setTimeout(
          function () {
            $.post(
              theme.routes.cart_url + "/update.js",
              { note: val },
              function (data) {},
              "json"
            );
          },
          theme.cartNoteMonitor.updateThrottleInterval
        ));
    },
  }),
    ($.fn.clickyBoxes = function (prefix) {
      if (prefix == "destroy")
        $(this).off(".clickyboxes"),
          $(this).next(".clickyboxes").off(".clickyboxes");
      else
        return $(this)
          .filter("select:not(.clickybox-replaced)")
          .addClass("clickybox-replaced")
          .each(function () {
            var prefix2 = prefix2 || $(this).attr("id"),
              $optCont = $('<ul class="clickyboxes"/>')
                .attr("id", "clickyboxes-" + prefix2)
                .data("select", $(this))
                .insertAfter(this),
              $label;
            $(this).is("[id]")
              ? ($label = $('label[for="' + $(this).attr("id") + '"]'))
              : ($label = $(this).siblings("label")),
              $label.length > 0 &&
                $optCont.addClass(
                  "options-" +
                    removeDiacritics($label.text())
                      .toLowerCase()
                      .replace(/'/g, "")
                      .replace(/[^a-z0-9]+/g, "-")
                      .replace(/-+/g, "-")
                      .replace(/-*$/, "")
                );
            var colorSect = document.getElementById(
              "clickyboxes-SingleOptionSelector-1"
            );
            if (
              ($(this)
                .find("option")
                .each(function () {
                  if (colorSect != null) {
                    var barcode = $(this).data("barcode").toLowerCase(),
                      color = $(this).val().toLowerCase(),
                      url = document.URL,
                      splt = url.split("-");
                    splt[splt.length - 3].toLowerCase() ==
                    splt[splt.length - 1].toLowerCase()
                      ? ((splt[splt.length - 1] = color),
                        (splt[splt.length - 3] = color),
                        (splt[splt.length - 2] = barcode.substring(
                          barcode.length - 6,
                          barcode.length
                        )))
                      : ((splt[splt.length - 1] = color.replace(" ", "-")),
                        (splt[splt.length - 2] = barcode.substring(
                          barcode.length - 6,
                          barcode.length
                        ))),
                      (url = splt.join("-")),
                      $("<li/>")
                        .appendTo($optCont)
                        .append(
                          $('<a href="' + url + '"/>')
                            .attr("data-value", $(this).val())
                            .attr("title", $(this).val())
                            .html($(this).html())
                            .addClass(
                              "opt--" +
                                removeDiacritics($(this).text())
                                  .toLowerCase()
                                  .replace(/'/g, "")
                                  .replace(/[^a-z0-9]+/g, "-")
                                  .replace(/-+/g, "-")
                                  .replace(/-*$/, "")
                            )
                        );
                  } else
                    $("<li/>")
                      .appendTo($optCont)
                      .append(
                        $('<a href="#"/>')
                          .attr("data-value", $(this).val())
                          .html($(this).html())
                          .addClass(
                            "opt--" +
                              removeDiacritics($(this).text())
                                .toLowerCase()
                                .replace(/'/g, "")
                                .replace(/[^a-z0-9]+/g, "-")
                                .replace(/-+/g, "-")
                                .replace(/-*$/, "")
                          )
                      );
                }),
              $(this)
                .hide()
                .addClass("replaced")
                .on("change.clickyboxes keyup.clickyboxes", function () {
                  var val = $(this).val();
                  $optCont
                    .find("a")
                    .removeClass("active")
                    .filter(function () {
                      return $(this).attr("data-value") == val;
                    })
                    .addClass("active");
                })
                .trigger("keyup"),
              colorSect != null)
            )
              for (
                colorSect
                  .getElementsByTagName("a")[0]
                  .setAttribute("href", "#"),
                  x = 0;
                x < colorSect.getElementsByTagName("a").length;
                x++
              )
                colorSect.getElementsByTagName("a")[x].textContent = "";
            $optCont.on("click.clickyboxes", "a", function () {
              if (!$(this).hasClass("active")) {
                var $clicky = $(this).closest(".clickyboxes");
                $clicky
                  .data("select")
                  .val($(this).data("value"))
                  .trigger("change"),
                  $clicky.trigger("change");
              }
              var newUrl = $(this)[0].getAttribute("href");
              return (
                newUrl != "#" &&
                  (window.history.pushState(null, "", newUrl),
                  $("#main_product_section").load(
                    newUrl + " #main_product_section",
                    function () {
                      $.getScript(
                        "https://assets.smartwishlist.webmarked.net/static/v6/smartwishlist.js?shop=delami-the-executive.myshopify.com"
                      ),
                        reloadPageProduct(),
                        setTimeout(theme.initAnimateOnScroll, 0);
                    }
                  )),
                !1
              );
            });
          });
    }),
    (theme.Shopify = {
      formatMoney: function (t, r) {
        function e(t2, r2) {
          return t2 === void 0 ? r2 : t2;
        }
        function a(t2, r2, a2, o2) {
          if (
            ((r2 = e(r2, 2)),
            (a2 = e(a2, ",")),
            (o2 = e(o2, ".")),
            isNaN(t2) || t2 == null)
          )
            return 0;
          t2 = (t2 / 100).toFixed(r2);
          var n2 = t2.split(".");
          return (
            n2[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + a2) +
            (n2[1] ? o2 + n2[1] : "")
          );
        }
        typeof t == "string" && (t = t.replace(".", ""));
        var o = "",
          n = /\{\{\s*(\w+)\s*\}\}/,
          i = r || this.money_format;
        switch (i.match(n)[1]) {
          case "amount":
            o = a(t, 2);
            break;
          case "amount_no_decimals":
            o = a(t, 0);
            break;
          case "amount_with_comma_separator":
            o = a(t, 2, ".", ",");
            break;
          case "amount_with_space_separator":
            o = a(t, 2, " ", ",");
            break;
          case "amount_with_period_and_space_separator":
            o = a(t, 2, " ", ".");
            break;
          case "amount_no_decimals_with_comma_separator":
            o = a(t, 0, ".", ",");
            break;
          case "amount_no_decimals_with_space_separator":
            o = a(t, 0, " ", "");
            break;
          case "amount_with_apostrophe_separator":
            o = a(t, 2, "'", ".");
            break;
          case "amount_with_decimal_separator":
            o = a(t, 2, ".", ".");
        }
        return i.replace(n, o);
      },
      formatImage: function (originalImageUrl, format) {
        return originalImageUrl
          ? originalImageUrl.replace(
              /^(.*)\.([^\.]*)$/g,
              "$1_" + format + ".$2"
            )
          : "";
      },
      Image: {
        imageSize: function (t) {
          var e = t.match(
            /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/
          );
          return e !== null ? e[1] : null;
        },
        getSizedImageUrl: function (t, e) {
          if (e == null) return t;
          if (e == "master") return this.removeProtocol(t);
          var o = t.match(
            /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
          );
          if (o != null) {
            var i = t.split(o[0]),
              r = o[0];
            return this.removeProtocol(i[0] + "_" + e + r);
          }
          return null;
        },
        removeProtocol: function (t) {
          return t.replace(/http(s)?:/, "");
        },
      },
    }),
    (theme.Disclosure = (function () {
      var selectors = {
          disclosureList: "[data-disclosure-list]",
          disclosureToggle: "[data-disclosure-toggle]",
          disclosureInput: "[data-disclosure-input]",
          disclosureOptions: "[data-disclosure-option]",
        },
        classes = { listVisible: "disclosure-list--visible" };
      function Disclosure($disclosure) {
        (this.$container = $disclosure),
          (this.cache = {}),
          this._cacheSelectors(),
          this._connectOptions(),
          this._connectToggle(),
          this._onFocusOut();
      }
      return (
        (Disclosure.prototype = $.extend({}, Disclosure.prototype, {
          _cacheSelectors: function () {
            this.cache = {
              $disclosureList: this.$container.find(selectors.disclosureList),
              $disclosureToggle: this.$container.find(
                selectors.disclosureToggle
              ),
              $disclosureInput: this.$container.find(selectors.disclosureInput),
              $disclosureOptions: this.$container.find(
                selectors.disclosureOptions
              ),
            };
          },
          _connectToggle: function () {
            this.cache.$disclosureToggle.on(
              "click",
              function (evt) {
                var ariaExpanded =
                  $(evt.currentTarget).attr("aria-expanded") === "true";
                $(evt.currentTarget).attr("aria-expanded", !ariaExpanded),
                  this.cache.$disclosureList.toggleClass(classes.listVisible);
              }.bind(this)
            );
          },
          _connectOptions: function () {
            this.cache.$disclosureOptions.on(
              "click",
              function (evt) {
                evt.preventDefault(),
                  this._submitForm($(evt.currentTarget).data("value"));
              }.bind(this)
            );
          },
          _onFocusOut: function () {
            this.cache.$disclosureToggle.on(
              "focusout",
              function (evt) {
                var disclosureLostFocus =
                  this.$container.has(evt.relatedTarget).length === 0;
                disclosureLostFocus && this._hideList();
              }.bind(this)
            ),
              this.cache.$disclosureList.on(
                "focusout",
                function (evt) {
                  var childInFocus =
                      $(evt.currentTarget).has(evt.relatedTarget).length > 0,
                    isVisible = this.cache.$disclosureList.hasClass(
                      classes.listVisible
                    );
                  isVisible && !childInFocus && this._hideList();
                }.bind(this)
              ),
              this.$container.on(
                "keyup",
                function (evt) {
                  evt.which === 27 &&
                    (this._hideList(), this.cache.$disclosureToggle.focus());
                }.bind(this)
              ),
              (this.bodyOnClick = function (evt) {
                var isOption = this.$container.has(evt.target).length > 0,
                  isVisible = this.cache.$disclosureList.hasClass(
                    classes.listVisible
                  );
                isVisible && !isOption && this._hideList();
              }.bind(this)),
              $("body").on("click", this.bodyOnClick);
          },
          _submitForm: function (value) {
            this.cache.$disclosureInput.val(value),
              this.$container.parents("form").submit();
          },
          _hideList: function () {
            this.cache.$disclosureList.removeClass(classes.listVisible),
              this.cache.$disclosureToggle.attr("aria-expanded", !1);
          },
          unload: function () {
            $("body").off("click", this.bodyOnClick),
              this.cache.$disclosureOptions.off(),
              this.cache.$disclosureToggle.off(),
              this.cache.$disclosureList.off(),
              this.$container.off();
          },
        })),
        Disclosure
      );
    })()),
    (function () {
      function throttle(callback, threshold) {
        var debounceTimeoutId = -1,
          tick = !1;
        return function () {
          clearTimeout(debounceTimeoutId),
            (debounceTimeoutId = setTimeout(callback, threshold)),
            tick ||
              (callback.call(),
              (tick = !0),
              setTimeout(function () {
                tick = !1;
              }, threshold));
        };
      }
      var scrollEvent = document.createEvent("Event");
      scrollEvent.initEvent("throttled-scroll", !0, !0),
        window.addEventListener(
          "scroll",
          throttle(function () {
            window.dispatchEvent(scrollEvent);
          }, 200)
        );
    })(),
    (theme.debounce = function (func) {
      var wait =
          arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 700,
        immediate = arguments.length > 2 ? arguments[2] : void 0,
        timeout;
      return function () {
        var context = this,
          args = arguments,
          later = function () {
            (timeout = null), immediate || func.apply(context, args);
          },
          callNow = immediate && !timeout;
        clearTimeout(timeout),
          (timeout = setTimeout(later, wait)),
          callNow && func.apply(context, args);
      };
    }),
    (theme.Sections = new (function () {
      var _ = this;
      (_._instances = []),
        (_._deferredSectionTargets = []),
        (_._sections = []),
        (_._deferredLoadViewportExcess = 300),
        (_._deferredWatcherRunning = !1),
        (_.init = function () {
          $(document)
            .on("shopify:section:load", function (e) {
              var target = _._themeSectionTargetFromShopifySectionTarget(
                e.target
              );
              target && _.sectionLoad(target);
            })
            .on("shopify:section:unload", function (e) {
              var target = _._themeSectionTargetFromShopifySectionTarget(
                e.target
              );
              target && _.sectionUnload(target);
            }),
            $(window).on(
              "throttled-scroll.themeSectionDeferredLoader debouncedresize.themeSectionDeferredLoader",
              _._processDeferredSections
            ),
            (_._deferredWatcherRunning = !0);
        }),
        (_.register = function (type, section, options) {
          _._sections.push({
            type,
            section,
            afterSectionLoadCallback: options ? options.afterLoad : null,
            afterSectionUnloadCallback: options ? options.afterUnload : null,
          }),
            $('[data-section-type="' + type + '"]').each(function () {
              Shopify.designMode ||
              (options && options.deferredLoad === !1) ||
              !_._deferredWatcherRunning
                ? _.sectionLoad(this)
                : _.sectionDeferredLoad(this, options);
            });
        }),
        (_.sectionDeferredLoad = function (target, options) {
          _._deferredSectionTargets.push({
            target,
            deferredLoadViewportExcess:
              options && options.deferredLoadViewportExcess
                ? options.deferredLoadViewportExcess
                : _._deferredLoadViewportExcess,
          }),
            _._processDeferredSections(!0);
        }),
        (_._processDeferredSections = function (firstRunCheck) {
          if (_._deferredSectionTargets.length)
            for (
              var viewportTop = $(window).scrollTop(),
                viewportBottom = viewportTop + $(window).height(),
                loopStart =
                  firstRunCheck === !0
                    ? _._deferredSectionTargets.length - 1
                    : 0,
                i = loopStart;
              i < _._deferredSectionTargets.length;
              i++
            ) {
              var target = _._deferredSectionTargets[i].target,
                viewportExcess =
                  _._deferredSectionTargets[i].deferredLoadViewportExcess,
                sectionTop = $(target).offset().top - viewportExcess,
                doLoad =
                  sectionTop > viewportTop && sectionTop < viewportBottom;
              if (!doLoad) {
                var sectionBottom =
                  sectionTop + $(target).outerHeight() + viewportExcess * 2;
                doLoad =
                  sectionBottom > viewportTop && sectionBottom < viewportBottom;
              }
              (doLoad ||
                (sectionTop < viewportTop && sectionBottom > viewportBottom)) &&
                (_.sectionLoad(target),
                _._deferredSectionTargets.splice(i, 1),
                i--);
            }
          firstRunCheck !== !0 &&
            _._deferredSectionTargets.length === 0 &&
            ((_._deferredWatcherRunning = !1),
            $(window).off(".themeSectionDeferredLoader"));
        }),
        (_.sectionLoad = function (target) {
          var target = target,
            sectionObj = _._sectionForTarget(target),
            section = !1;
          if (
            (sectionObj.section
              ? (section = sectionObj.section)
              : (section = sectionObj),
            section !== !1)
          ) {
            var instance = {
              target,
              section,
              $shopifySectionContainer: $(target).closest(".shopify-section"),
              thisContext: {
                functions: section.functions,
                registeredEventListeners: [],
              },
            };
            if (
              ((instance.thisContext.registerEventListener =
                _._registerEventListener.bind(instance.thisContext)),
              _._instances.push(instance),
              $(target).data("components"))
            ) {
              var components = $(target).data("components").split(",");
              components.forEach(function (component) {
                $(document).trigger("cc:component:load", [component, target]);
              });
            }
            _._callSectionWith(
              section,
              "onSectionLoad",
              target,
              instance.thisContext
            ),
              _._callSectionWith(
                section,
                "afterSectionLoadCallback",
                target,
                instance.thisContext
              ),
              section.onSectionSelect &&
                instance.$shopifySectionContainer.on(
                  "shopify:section:select",
                  function (e) {
                    _._callSectionWith(
                      section,
                      "onSectionSelect",
                      e.target,
                      instance.thisContext
                    );
                  }
                ),
              section.onSectionDeselect &&
                instance.$shopifySectionContainer.on(
                  "shopify:section:deselect",
                  function (e) {
                    _._callSectionWith(
                      section,
                      "onSectionDeselect",
                      e.target,
                      instance.thisContext
                    );
                  }
                ),
              section.onBlockSelect &&
                $(target).on("shopify:block:select", function (e) {
                  _._callSectionWith(
                    section,
                    "onBlockSelect",
                    e.target,
                    instance.thisContext
                  );
                }),
              section.onBlockDeselect &&
                $(target).on("shopify:block:deselect", function (e) {
                  _._callSectionWith(
                    section,
                    "onBlockDeselect",
                    e.target,
                    instance.thisContext
                  );
                });
          }
        }),
        (_.sectionUnload = function (target) {
          for (
            var sectionObj = _._sectionForTarget(target),
              instanceIndex = -1,
              i = 0;
            i < _._instances.length;
            i++
          )
            _._instances[i].target == target && (instanceIndex = i);
          if (instanceIndex > -1) {
            var instance = _._instances[instanceIndex];
            if (
              ($(target).off("shopify:block:select shopify:block:deselect"),
              instance.$shopifySectionContainer.off(
                "shopify:section:select shopify:section:deselect"
              ),
              _._callSectionWith(
                instance.section,
                "onSectionUnload",
                target,
                instance.thisContext
              ),
              _._unloadRegisteredEventListeners(
                instance.thisContext.registeredEventListeners
              ),
              _._callSectionWith(
                sectionObj,
                "afterSectionUnloadCallback",
                target,
                instance.thisContext
              ),
              _._instances.splice(instanceIndex),
              $(target).data("components"))
            ) {
              var components = $(target).data("components").split(",");
              components.forEach(function (component) {
                $(document).trigger("cc:component:unload", [component, target]);
              });
            }
          } else
            for (var i = 0; i < _._deferredSectionTargets.length; i++)
              if (_._deferredSectionTargets[i].target == target) {
                _._deferredSectionTargets[i].splice(i, 1);
                break;
              }
        }),
        (_._registerEventListener = function (element, eventType, callback) {
          element.addEventListener(eventType, callback),
            this.registeredEventListeners.push({
              element,
              eventType,
              callback,
            });
        }),
        (_._unloadRegisteredEventListeners = function (
          registeredEventListeners
        ) {
          registeredEventListeners.forEach(function (rel) {
            rel.element.removeEventListener(rel.eventType, rel.callback);
          });
        }),
        (_._callSectionWith = function (
          section,
          method,
          container2,
          thisContext
        ) {
          if (typeof section[method] == "function")
            try {
              thisContext
                ? section[method].bind(thisContext)(container2)
                : section[method](container2);
            } catch (ex) {
              var sectionType = container2.dataset.sectionType;
              console.warn(
                "Theme warning: '"
                  .concat(method, "' failed for section '")
                  .concat(sectionType, "'")
              ),
                console.debug(container2, ex);
            }
        }),
        (_._themeSectionTargetFromShopifySectionTarget = function (target) {
          var $target = $("[data-section-type]:first", target);
          return $target.length > 0 ? $target[0] : !1;
        }),
        (_._sectionForTarget = function (target) {
          for (
            var type = $(target).attr("data-section-type"), i = 0;
            i < _._sections.length;
            i++
          )
            if (_._sections[i].type == type) return _._sections[i];
          return !1;
        }),
        (_._sectionAlreadyRegistered = function (type) {
          for (var i = 0; i < _._sections.length; i++)
            if (_._sections[i].type == type) return !0;
          return !1;
        });
    })()),
    (theme.scriptsLoaded = {}),
    (theme.loadScriptOnce = function (src, callback, beforeRun, sync) {
      if (typeof theme.scriptsLoaded[src] > "u") {
        theme.scriptsLoaded[src] = [];
        var tag = document.createElement("script");
        (tag.src = src),
          (sync || beforeRun) && (tag.async = !1),
          beforeRun && beforeRun(),
          typeof callback == "function" &&
            (theme.scriptsLoaded[src].push(callback),
            tag.readyState
              ? (tag.onreadystatechange = function () {
                  if (
                    tag.readyState == "loaded" ||
                    tag.readyState == "complete"
                  ) {
                    tag.onreadystatechange = null;
                    for (var i = 0; i < theme.scriptsLoaded[this].length; i++)
                      theme.scriptsLoaded[this][i]();
                    theme.scriptsLoaded[this] = !0;
                  }
                }.bind(src))
              : (tag.onload = function () {
                  for (var i = 0; i < theme.scriptsLoaded[this].length; i++)
                    theme.scriptsLoaded[this][i]();
                  theme.scriptsLoaded[this] = !0;
                }.bind(src)));
        var firstScriptTag = document.getElementsByTagName("script")[0];
        return firstScriptTag.parentNode.insertBefore(tag, firstScriptTag), !0;
      } else if (
        _typeof(theme.scriptsLoaded[src]) === "object" &&
        typeof callback == "function"
      )
        theme.scriptsLoaded[src].push(callback);
      else return typeof callback == "function" && callback(), !1;
    }),
    (theme.loadStyleOnce = function (src) {
      var srcWithoutProtocol = src.replace(/^https?:/, "");
      if (
        !document.querySelector(
          'link[href="' + encodeURI(srcWithoutProtocol) + '"]'
        )
      ) {
        var tag = document.createElement("link");
        (tag.href = srcWithoutProtocol),
          (tag.rel = "stylesheet"),
          (tag.type = "text/css");
        var firstTag = document.getElementsByTagName("link")[0];
        firstTag.parentNode.insertBefore(tag, firstTag);
      }
    }),
    (theme.showQuickPopup = function (message, $origin) {
      var $popup = $('<div class="simple-popup"/>'),
        offs = $origin.offset();
      $popup.html(message).css({ left: offs.left, top: offs.top }).hide(),
        $("body").append($popup),
        $popup.css({
          marginTop: -$popup.outerHeight() - 10,
          marginLeft: -($popup.outerWidth() - $origin.outerWidth()) / 2,
        }),
        $popup
          .fadeIn(200)
          .delay(3500)
          .fadeOut(400, function () {
            $(this).remove();
          });
    });
  var ccComponent = (function () {
    "use strict";
    function ccComponent2(name) {
      var cssSelector =
        arguments.length > 1 && arguments[1] !== void 0
          ? arguments[1]
          : ".cc-".concat(name);
      _classCallCheck(this, ccComponent2);
      var _this = this;
      (this.instances = []),
        $(document).on(
          "cc:component:load",
          function (event, component, target) {
            component === name &&
              $(target)
                .find("".concat(cssSelector, ":not(.cc-initialized)"))
                .each(function () {
                  _this.init(this);
                });
          }
        ),
        $(document).on(
          "cc:component:unload",
          function (event, component, target) {
            component === name &&
              $(target)
                .find(cssSelector)
                .each(function () {
                  _this.destroy(this);
                });
          }
        ),
        $(cssSelector).each(function () {
          _this.init(this);
        });
    }
    return (
      _createClass(ccComponent2, [
        {
          key: "init",
          value: function (container2) {
            $(container2).addClass("cc-initialized");
          },
        },
        {
          key: "destroy",
          value: function (container2) {
            $(container2).removeClass("cc-initialized");
          },
        },
        {
          key: "registerInstance",
          value: function (container2, instance) {
            this.instances.push({ container: container2, instance });
          },
        },
        {
          key: "destroyInstance",
          value: function (container2) {
            this.instances = this.instances.filter(function (item) {
              if (item.container === container2)
                return (
                  typeof item.instance.destroy == "function" &&
                    item.instance.destroy(),
                  item.container !== container2
                );
            });
          },
        },
      ]),
      ccComponent2
    );
  })();
  (theme.createTemplateVariableEncoder = function () {
    return {
      utilityElement: document.createElement("div"),
      values: {},
      add: function (key, value, type) {
        switch (type) {
          case "attribute":
            (this.utilityElement.innerHTML = ""),
              this.utilityElement.setAttribute("util", value),
              (this.values[key] =
                this.utilityElement.outerHTML.match(/util="([^"]*)"/)[1]);
            break;
          case "html":
            (this.utilityElement.innerText = value),
              (this.values[key] = this.utilityElement.innerHTML);
            break;
          case "raw":
            this.values[key] = value;
            break;
          default:
            throw "Type '".concat(type, "' not handled");
        }
      },
    };
  }),
    (theme.suffixIds = function (container2, suffix) {
      var refAttrs = ["aria-describedby", "aria-controls"];
      (suffix = "-" + suffix),
        container2.querySelectorAll("[id]").forEach(function (el) {
          var oldId = el.id,
            newId = oldId + suffix;
          (el.id = newId),
            refAttrs.forEach(function (attr) {
              container2
                .querySelectorAll("[".concat(attr, '="').concat(oldId, '"]'))
                .forEach(function (refEl) {
                  refEl.setAttribute(attr, newId);
                });
            });
        });
    }),
    (theme.renderUnitPrice = function (
      unit_price,
      unit_price_measurement,
      money_format
    ) {
      if (unit_price && unit_price_measurement) {
        var unitPriceHtml = '<div class="unit-price">';
        (unitPriceHtml += '<span class="unit-price__price theme-money">'.concat(
          theme.Shopify.formatMoney(unit_price, money_format),
          "</span>"
        )),
          (unitPriceHtml += '<span class="unit-price__separator">'.concat(
            theme.strings.products_product_unit_price_separator,
            "</span>"
          ));
        var unit = unit_price_measurement.reference_unit;
        return (
          unit_price_measurement.reference_value != 1 &&
            (unit = unit_price_measurement.reference_value + unit),
          (unitPriceHtml += '<span class="unit-price__unit">'.concat(
            unit,
            "</span>"
          )),
          (unitPriceHtml += "</div>"),
          unitPriceHtml
        );
      } else return "";
    });
  var ccPopup = (function () {
    "use strict";
    function ccPopup2($container, namespace) {
      _classCallCheck(this, ccPopup2),
        (this.$container = $container),
        (this.namespace = namespace),
        (this.cssClasses = {
          visible: "cc-popup--visible",
          bodyNoScroll: "cc-popup-no-scroll",
          bodyNoScrollPadRight: "cc-popup-no-scroll-pad-right",
        });
    }
    return (
      _createClass(ccPopup2, [
        {
          key: "open",
          value: function (callback) {
            var _this2 = this;
            if (this.$container.data("freeze-scroll")) {
              $("body").addClass(this.cssClasses.bodyNoScroll);
              var scrollDiv = document.createElement("div");
              (scrollDiv.className = "popup-scrollbar-measure"),
                document.body.appendChild(scrollDiv);
              var scrollbarWidth =
                scrollDiv.getBoundingClientRect().width - scrollDiv.clientWidth;
              document.body.removeChild(scrollDiv),
                scrollbarWidth > 0 &&
                  $("body")
                    .css("padding-right", scrollbarWidth + "px")
                    .addClass(this.cssClasses.bodyNoScrollPadRight);
            }
            this.$container.addClass(this.cssClasses.visible),
              (this.previouslyActiveElement = document.activeElement),
              setTimeout(function () {
                _this2.$container.find(".cc-popup-close")[0].focus();
              }, 500),
              $(window).on("keydown" + this.namespace, function (event) {
                event.keyCode === 27 && _this2.close();
              }),
              callback && callback();
          },
        },
        {
          key: "close",
          value: function (callback) {
            var _this3 = this;
            if (
              (this.$container.removeClass(this.cssClasses.visible),
              this.previouslyActiveElement &&
                $(this.previouslyActiveElement).focus(),
              $(window).off("keydown" + this.namespace),
              this.$container.data("freeze-scroll"))
            ) {
              var transitionDuration = 500,
                $innerModal = this.$container.find(".cc-popup-modal");
              $innerModal.length &&
                ((transitionDuration = parseFloat(
                  getComputedStyle($innerModal[0]).transitionDuration
                )),
                transitionDuration &&
                  transitionDuration > 0 &&
                  (transitionDuration *= 1e3)),
                setTimeout(function () {
                  $("body")
                    .removeClass(_this3.cssClasses.bodyNoScroll)
                    .removeClass(_this3.cssClasses.bodyNoScrollPadRight)
                    .css("padding-right", "0");
                }, transitionDuration);
            }
            callback && callback();
          },
        },
      ]),
      ccPopup2
    );
  })();
  (function () {
    document.addEventListener("DOMContentLoaded", function () {
      var endlessScroll = new Ajaxinate({
        method: "scroll",
        loadingText: "Memuat..",
      });
    }),
      (theme.initAnimateOnScroll = function () {
        if (
          document.body.classList.contains("cc-animate-enabled") &&
          window.innerWidth >= 768
        ) {
          var animationTimeout =
              typeof document.body.dataset.ccAnimateTimeout < "u"
                ? document.body.dataset.ccAnimateTimeout
                : 200,
            intersectionObserver = new IntersectionObserver(function (
              entries,
              observer
            ) {
              entries.forEach(function (entry) {
                entry.isIntersecting &&
                  !entry.target.classList.contains("cc-animate-complete") &&
                  (setTimeout(function () {
                    entry.target.classList.add("-in", "cc-animate-complete");
                  }, animationTimeout),
                  setTimeout(function () {
                    entry.target.classList.remove("data-cc-animate"),
                      (entry.target.style.transitionDuration = null),
                      (entry.target.style.transitionDelay = null);
                  }, 5e3),
                  observer.unobserve(entry.target));
              });
            });
          document
            .querySelectorAll("[data-cc-animate]:not(.cc-animate-init)")
            .forEach(function (elem) {
              elem.dataset.ccAnimateDelay &&
                (elem.style.transitionDelay = elem.dataset.ccAnimateDelay),
                elem.dataset.ccAnimateDuration &&
                  (elem.style.transitionDuration =
                    elem.dataset.ccAnimateDuration),
                elem.dataset.ccAnimate &&
                  elem.classList.add(elem.dataset.ccAnimate),
                elem.classList.add("cc-animate-init"),
                intersectionObserver.observe(elem);
            });
        }
      }),
      theme.initAnimateOnScroll(),
      document.addEventListener("shopify:section:load", function () {
        setTimeout(theme.initAnimateOnScroll, 100);
      }),
      (theme.loadPagingInfinite = function () {
        setTimeout(theme.initAnimateOnScroll, 50),
          setTimeout(theme.ProductBlockManager.loadImages, 50);
      });
    try {
      window
        .matchMedia("(min-width: 768px)")
        .addEventListener("change", function (event) {
          event.matches && setTimeout(theme.initAnimateOnScroll, 100);
        });
    } catch {}
  })();
  var AccordionInstance = (function () {
      "use strict";
      function AccordionInstance2(container2) {
        _classCallCheck(this, AccordionInstance2),
          (this.accordion = container2),
          (this.itemClass = ".cc-accordion-item"),
          (this.titleClass = ".cc-accordion-item__title"),
          (this.panelClass = ".cc-accordion-item__panel"),
          (this.allowMultiOpen =
            this.accordion.dataset.allowMultiOpen === "true"),
          this.allowMultiOpen ||
            (this.activeItem = this.accordion.querySelector(
              "".concat(this.itemClass, "[open]")
            )),
          this.bindEvents();
      }
      return (
        _createClass(
          AccordionInstance2,
          [
            {
              key: "open",
              value: function (item, panel) {
                if (
                  ((panel.style.height = "0"),
                  (item.open = !0),
                  AccordionInstance2.addPanelHeight(panel),
                  setTimeout(function () {
                    item.classList.add("is-open");
                  }, 10),
                  !this.allowMultiOpen)
                ) {
                  if (this.activeItem && this.activeItem !== item) {
                    var activePanel = this.activeItem.querySelector(
                      this.panelClass
                    );
                    this.close(this.activeItem, activePanel);
                  }
                  this.activeItem = item;
                }
              },
            },
            {
              key: "close",
              value: function (item, panel) {
                AccordionInstance2.addPanelHeight(panel),
                  item.classList.remove("is-open"),
                  item.classList.add("is-closing"),
                  this.activeItem === item && (this.activeItem = null),
                  setTimeout(function () {
                    panel.style.height = "0";
                  }, 10);
              },
            },
            {
              key: "handleClick",
              value: function (e) {
                if (e.target.matches(this.titleClass)) {
                  e.preventDefault();
                  var item = e.target.parentNode,
                    panel = e.target.nextElementSibling;
                  item.open ? this.close(item, panel) : this.open(item, panel);
                }
              },
            },
            {
              key: "handleTransition",
              value: function (e) {
                if (e.target.matches(this.panelClass)) {
                  var panel = e.target,
                    item = panel.parentNode;
                  item.classList.contains("is-closing") &&
                    (item.classList.remove("is-closing"), (item.open = !1)),
                    AccordionInstance2.removePanelHeight(panel);
                }
              },
            },
            {
              key: "bindEvents",
              value: function () {
                (this.clickHandler = this.handleClick.bind(this)),
                  (this.transitionHandler = this.handleTransition.bind(this)),
                  this.accordion.addEventListener("click", this.clickHandler),
                  this.accordion.addEventListener(
                    "transitionend",
                    this.transitionHandler
                  );
              },
            },
            {
              key: "destroy",
              value: function () {
                this.accordion.removeEventListener("click", this.clickHandler),
                  this.accordion.removeEventListener(
                    "transitionend",
                    this.transitionHandler
                  );
              },
            },
          ],
          [
            {
              key: "addPanelHeight",
              value: function (panel) {
                panel.style.height = "".concat(panel.scrollHeight, "px");
              },
            },
            {
              key: "removePanelHeight",
              value: function (panel) {
                panel.getAttribute("style"), panel.removeAttribute("style");
              },
            },
          ]
        ),
        AccordionInstance2
      );
    })(),
    Accordion = (function (_ccComponent) {
      "use strict";
      _inherits(Accordion2, _ccComponent);
      var _super = _createSuper(Accordion2);
      function Accordion2() {
        var name =
            arguments.length > 0 && arguments[0] !== void 0
              ? arguments[0]
              : "accordion",
          cssSelector =
            arguments.length > 1 && arguments[1] !== void 0
              ? arguments[1]
              : ".cc-".concat(name);
        return (
          _classCallCheck(this, Accordion2),
          _super.call(this, name, cssSelector)
        );
      }
      return (
        _createClass(Accordion2, [
          {
            key: "init",
            value: function (container2) {
              _get(_getPrototypeOf(Accordion2.prototype), "init", this).call(
                this,
                container2
              ),
                this.registerInstance(
                  container2,
                  new AccordionInstance(container2)
                );
            },
          },
          {
            key: "destroy",
            value: function (container2) {
              this.destroyInstance(container2),
                _get(
                  _getPrototypeOf(Accordion2.prototype),
                  "destroy",
                  this
                ).call(this, container2);
            },
          },
        ]),
        Accordion2
      );
    })(ccComponent);
  new Accordion();
  var ModalInstance = (function () {
      "use strict";
      function ModalInstance2(container2) {
        _classCallCheck(this, ModalInstance2),
          (this.container = container2),
          (this.size = container2.dataset.ccModalSize || "medium"),
          (this.contentElement = document.querySelector(
            container2.dataset.ccModalContentelement
          )),
          this.container.addEventListener("click", this.handleClick.bind(this)),
          container2.dataset.ccModalLaunch === "true" &&
            setTimeout(this.open.bind(this), 10);
      }
      return (
        _createClass(ModalInstance2, [
          {
            key: "handleClick",
            value: function (e) {
              e.preventDefault(), this.open(), (this.opener = e.target);
            },
          },
          {
            key: "open",
            value: function () {
              var _this4 = this,
                tve = theme.createTemplateVariableEncoder();
              tve.add("size", this.size, "attribute"),
                tve.add("content", this.contentElement.innerHTML, "raw"),
                tve.add(
                  "button_close_label",
                  theme.strings.general_accessibility_labels_close,
                  "attribute"
                ),
                tve.add("button_close_icon", theme.icons.close, "raw");
              var html = `
      <div class="cc-modal-window cc-modal-window--pre-reveal cc-modal-window--size-`
                  .concat(
                    tve.values.size,
                    `">
        <div class="cc-modal-window__background"></div>
        <div class="cc-modal-window__foreground" role="dialog" aria-modal="true">
          <div class="cc-modal-window__content-container">
            <button class="cc-modal-window__close" aria-label="`
                  )
                  .concat(tve.values.button_close_label, '">')
                  .concat(
                    tve.values.button_close_icon,
                    `</button>
            <div class="cc-modal-window__content">`
                  )
                  .concat(
                    tve.values.content,
                    `</div>
          </div>
        </div>
      </div>
    `
                  ),
                modalElementFragment = document
                  .createRange()
                  .createContextualFragment(html);
              document.body.appendChild(modalElementFragment),
                document.body.classList.add("cc-modal-visible"),
                (this.modalElement = document.body.lastElementChild),
                this.modalElement
                  .querySelector(".cc-modal-window__background")
                  .addEventListener("click", this.close.bind(this)),
                this.modalElement
                  .querySelector(".cc-modal-window__close")
                  .addEventListener("click", this.close.bind(this)),
                setTimeout(function () {
                  _this4.modalElement.classList.remove(
                    "cc-modal-window--pre-reveal"
                  ),
                    _this4.modalElement
                      .querySelector(".cc-modal-window__close")
                      .focus();
                }, 10);
            },
          },
          {
            key: "close",
            value: function () {
              var _this5 = this;
              this.modalElement.classList.add("cc-modal-window--closing"),
                document.querySelector(
                  ".cc-modal-window:not(.cc-modal-window--closing)"
                ) || document.body.classList.remove("cc-modal-visible"),
                this.opener &&
                  setTimeout(function () {
                    _this5.opener.focus();
                  }, 10),
                setTimeout(
                  function () {
                    this.remove();
                  }.bind(this.modalElement),
                  5e3
                );
            },
          },
        ]),
        ModalInstance2
      );
    })(),
    Modal = (function (_ccComponent2) {
      "use strict";
      _inherits(Modal2, _ccComponent2);
      var _super2 = _createSuper(Modal2);
      function Modal2() {
        var name =
            arguments.length > 0 && arguments[0] !== void 0
              ? arguments[0]
              : "modal",
          cssSelector =
            arguments.length > 1 && arguments[1] !== void 0
              ? arguments[1]
              : ".cc-".concat(name);
        return (
          _classCallCheck(this, Modal2), _super2.call(this, name, cssSelector)
        );
      }
      return (
        _createClass(Modal2, [
          {
            key: "init",
            value: function (container2) {
              _get(_getPrototypeOf(Modal2.prototype), "init", this).call(
                this,
                container2
              ),
                this.registerInstance(
                  container2,
                  new ModalInstance(container2)
                );
            },
          },
          {
            key: "destroy",
            value: function (container2) {
              this.destroyInstance(container2),
                _get(_getPrototypeOf(Modal2.prototype), "destroy", this).call(
                  this,
                  container2
                );
            },
          },
        ]),
        Modal2
      );
    })(ccComponent);
  new Modal();
  var PriceRangeInstance = (function () {
      "use strict";
      function PriceRangeInstance2(container2) {
        var _this6 = this;
        _classCallCheck(this, PriceRangeInstance2),
          (this.container = container2),
          (this.selectors = {
            inputMin: ".cc-price-range__input--min",
            inputMax: ".cc-price-range__input--max",
            control: ".cc-price-range__control",
            controlMin: ".cc-price-range__control--min",
            controlMax: ".cc-price-range__control--max",
            bar: ".cc-price-range__bar",
            activeBar: ".cc-price-range__bar-active",
          }),
          (this.controls = {
            min: {
              barControl: container2.querySelector(this.selectors.controlMin),
              input: container2.querySelector(this.selectors.inputMin),
            },
            max: {
              barControl: container2.querySelector(this.selectors.controlMax),
              input: container2.querySelector(this.selectors.inputMax),
            },
          }),
          (this.controls.min.value = parseInt(
            this.controls.min.input.value === ""
              ? this.controls.min.input.placeholder
              : this.controls.min.input.value
          )),
          (this.controls.max.value = parseInt(
            this.controls.max.input.value === ""
              ? this.controls.max.input.placeholder
              : this.controls.max.input.value
          )),
          (this.valueMin = this.controls.min.input.min),
          (this.valueMax = this.controls.min.input.max),
          (this.valueRange = this.valueMax - this.valueMin),
          [this.controls.min, this.controls.max].forEach(function (item) {
            item.barControl.setAttribute("aria-valuemin", _this6.valueMin),
              item.barControl.setAttribute("aria-valuemax", _this6.valueMax),
              item.barControl.setAttribute("tabindex", 0);
          }),
          this.controls.min.barControl.setAttribute(
            "aria-valuenow",
            this.controls.min.value
          ),
          this.controls.max.barControl.setAttribute(
            "aria-valuenow",
            this.controls.max.value
          ),
          (this.bar = container2.querySelector(this.selectors.bar)),
          (this.activeBar = container2.querySelector(this.selectors.activeBar)),
          (this.inDrag = !1),
          this.bindEvents(),
          this.render();
      }
      return (
        _createClass(PriceRangeInstance2, [
          {
            key: "getPxToValueRatio",
            value: function () {
              return this.bar.clientWidth / (this.valueMax - this.valueMin);
            },
          },
          {
            key: "getPcToValueRatio",
            value: function () {
              return 100 / (this.valueMax - this.valueMin);
            },
          },
          {
            key: "setActiveControlValue",
            value: function (value) {
              isNaN(parseInt(value)) ||
                (this.activeControl === this.controls.min
                  ? (value === "" && (value = this.valueMin),
                    (value = Math.max(this.valueMin, value)),
                    (value = Math.min(value, this.controls.max.value)))
                  : (value === "" && (value = this.valueMax),
                    (value = Math.min(this.valueMax, value)),
                    (value = Math.max(value, this.controls.min.value))),
                (this.activeControl.value = Math.round(value)),
                this.activeControl.input.value != this.activeControl.value &&
                  (this.activeControl.value ==
                  this.activeControl.input.placeholder
                    ? (this.activeControl.input.value = "")
                    : (this.activeControl.input.value =
                        this.activeControl.value),
                  this.activeControl.input.dispatchEvent(
                    new CustomEvent("change", {
                      bubbles: !0,
                      cancelable: !1,
                      detail: { sender: "theme:component:price_range" },
                    })
                  )),
                this.activeControl.barControl.setAttribute(
                  "aria-valuenow",
                  this.activeControl.value
                ));
            },
          },
          {
            key: "render",
            value: function () {
              this.drawControl(this.controls.min),
                this.drawControl(this.controls.max),
                this.drawActiveBar();
            },
          },
          {
            key: "drawControl",
            value: function (control) {
              control.barControl.style.left =
                (control.value - this.valueMin) * this.getPcToValueRatio() +
                "%";
            },
          },
          {
            key: "drawActiveBar",
            value: function () {
              (this.activeBar.style.left =
                (this.controls.min.value - this.valueMin) *
                  this.getPcToValueRatio() +
                "%"),
                (this.activeBar.style.right =
                  (this.valueMax - this.controls.max.value) *
                    this.getPcToValueRatio() +
                  "%");
            },
          },
          {
            key: "handleControlTouchStart",
            value: function (e) {
              e.preventDefault(),
                this.startDrag(e.target, e.touches[0].clientX),
                (this.boundControlTouchMoveEvent =
                  this.handleControlTouchMove.bind(this)),
                (this.boundControlTouchEndEvent =
                  this.handleControlTouchEnd.bind(this)),
                window.addEventListener(
                  "touchmove",
                  this.boundControlTouchMoveEvent
                ),
                window.addEventListener(
                  "touchend",
                  this.boundControlTouchEndEvent
                );
            },
          },
          {
            key: "handleControlTouchMove",
            value: function (e) {
              this.moveDrag(e.touches[0].clientX);
            },
          },
          {
            key: "handleControlTouchEnd",
            value: function (e) {
              e.preventDefault(),
                window.removeEventListener(
                  "touchmove",
                  this.boundControlTouchMoveEvent
                ),
                window.removeEventListener(
                  "touchend",
                  this.boundControlTouchEndEvent
                ),
                this.stopDrag();
            },
          },
          {
            key: "handleControlMouseDown",
            value: function (e) {
              e.preventDefault(),
                this.startDrag(e.target, e.clientX),
                (this.boundControlMouseMoveEvent =
                  this.handleControlMouseMove.bind(this)),
                (this.boundControlMouseUpEvent =
                  this.handleControlMouseUp.bind(this)),
                window.addEventListener(
                  "mousemove",
                  this.boundControlMouseMoveEvent
                ),
                window.addEventListener(
                  "mouseup",
                  this.boundControlMouseUpEvent
                );
            },
          },
          {
            key: "handleControlMouseMove",
            value: function (e) {
              this.moveDrag(e.clientX);
            },
          },
          {
            key: "handleControlMouseUp",
            value: function (e) {
              e.preventDefault(),
                window.removeEventListener(
                  "mousemove",
                  this.boundControlMouseMoveEvent
                ),
                window.removeEventListener(
                  "mouseup",
                  this.boundControlMouseUpEvent
                ),
                this.stopDrag();
            },
          },
          {
            key: "startDrag",
            value: function (target, startX) {
              this.controls.min.barControl === target
                ? (this.activeControl = this.controls.min)
                : (this.activeControl = this.controls.max),
                (this.dragStartX = startX),
                (this.dragStartValue = this.activeControl.value),
                (this.inDrag = !0);
            },
          },
          {
            key: "moveDrag",
            value: function (moveX) {
              if (this.inDrag) {
                var value =
                  this.dragStartValue +
                  (moveX - this.dragStartX) / this.getPxToValueRatio();
                this.setActiveControlValue(value), this.render();
              }
            },
          },
          {
            key: "stopDrag",
            value: function () {
              this.inDrag = !1;
            },
          },
          {
            key: "handleControlKeyDown",
            value: function (e) {
              e.key === "ArrowRight"
                ? this.incrementControlFromKeypress(e.target, 10)
                : e.key === "ArrowLeft" &&
                  this.incrementControlFromKeypress(e.target, -10);
            },
          },
          {
            key: "incrementControlFromKeypress",
            value: function (control, pxAmount) {
              this.controls.min.barControl === control
                ? (this.activeControl = this.controls.min)
                : (this.activeControl = this.controls.max),
                this.setActiveControlValue(
                  this.activeControl.value + pxAmount / this.getPxToValueRatio()
                ),
                this.render();
            },
          },
          {
            key: "handleInputChange",
            value: function (e) {
              (e.target.value = e.target.value.replace(/\D/g, "")),
                (!e.detail ||
                  e.detail.sender != "theme:component:price_range") &&
                  (this.controls.min.input === e.target
                    ? (this.activeControl = this.controls.min)
                    : (this.activeControl = this.controls.max),
                  this.setActiveControlValue(e.target.value),
                  this.render());
            },
          },
          {
            key: "handleInputKeyup",
            value: function (e) {
              setTimeout(
                function () {
                  this.value = this.value.replace(/\D/g, "");
                }.bind(e.target),
                10
              );
            },
          },
          {
            key: "bindEvents",
            value: function () {
              var _this7 = this;
              [this.controls.min, this.controls.max].forEach(function (item) {
                item.barControl.addEventListener(
                  "touchstart",
                  _this7.handleControlTouchStart.bind(_this7)
                ),
                  item.barControl.addEventListener(
                    "mousedown",
                    _this7.handleControlMouseDown.bind(_this7)
                  ),
                  item.barControl.addEventListener(
                    "keydown",
                    _this7.handleControlKeyDown.bind(_this7)
                  ),
                  item.input.addEventListener(
                    "change",
                    _this7.handleInputChange.bind(_this7)
                  ),
                  item.input.addEventListener(
                    "keyup",
                    _this7.handleInputKeyup.bind(_this7)
                  );
              });
            },
          },
          { key: "destroy", value: function () {} },
        ]),
        PriceRangeInstance2
      );
    })(),
    PriceRange = (function (_ccComponent3) {
      "use strict";
      _inherits(PriceRange2, _ccComponent3);
      var _super3 = _createSuper(PriceRange2);
      function PriceRange2() {
        var name =
            arguments.length > 0 && arguments[0] !== void 0
              ? arguments[0]
              : "price-range",
          cssSelector =
            arguments.length > 1 && arguments[1] !== void 0
              ? arguments[1]
              : ".cc-".concat(name);
        return (
          _classCallCheck(this, PriceRange2),
          _super3.call(this, name, cssSelector)
        );
      }
      return (
        _createClass(PriceRange2, [
          {
            key: "init",
            value: function (container2) {
              _get(_getPrototypeOf(PriceRange2.prototype), "init", this).call(
                this,
                container2
              ),
                this.registerInstance(
                  container2,
                  new PriceRangeInstance(container2)
                );
            },
          },
          {
            key: "destroy",
            value: function (container2) {
              this.destroyInstance(container2),
                _get(
                  _getPrototypeOf(PriceRange2.prototype),
                  "destroy",
                  this
                ).call(this, container2);
            },
          },
        ]),
        PriceRange2
      );
    })(ccComponent);
  new PriceRange(),
    (theme.VideoManager = new (function () {
      var _ = this;
      (_._permitPlayback = function (container2) {
        return !(
          $(container2).hasClass("video-container--background") &&
          $(window).outerWidth() < 768
        );
      }),
        (_.youtubeVars = {
          incrementor: 0,
          apiReady: !1,
          videoData: {},
          toProcessSelector:
            '.video-container[data-video-type="youtube"]:not(.video--init)',
        }),
        (_.youtubeApiReady = function () {
          (_.youtubeVars.apiReady = !0), _._loadYoutubeVideos();
        }),
        (_._loadYoutubeVideos = function (container2) {
          $(_.youtubeVars.toProcessSelector, container2).length &&
            (_.youtubeVars.apiReady
              ? $(_.youtubeVars.toProcessSelector, container2).each(
                  function () {
                    if (_._permitPlayback($(this))) {
                      $(this).addClass("video--init"),
                        _.youtubeVars.incrementor++;
                      var containerId =
                        "theme-yt-video-" + _.youtubeVars.incrementor;
                      $(this).data("video-container-id", containerId);
                      var videoElement = $(
                          '<div class="video-container__video-element">'
                        )
                          .attr("id", containerId)
                          .appendTo($(".video-container__video", this)),
                        autoplay = $(this).data("video-autoplay"),
                        loop = $(this).data("video-loop"),
                        player = new YT.Player(containerId, {
                          height: "360",
                          width: "640",
                          videoId: $(this).data("video-id"),
                          playerVars: {
                            iv_load_policy: 3,
                            modestbranding: 1,
                            autoplay: 0,
                            loop: loop ? 1 : 0,
                            playlist: $(this).data("video-id"),
                            rel: 0,
                            showinfo: 0,
                          },
                          events: {
                            onReady: _._onYoutubePlayerReady.bind({
                              autoplay,
                              loop,
                              $container: $(this),
                            }),
                            onStateChange: _._onYoutubePlayerStateChange.bind({
                              autoplay,
                              loop,
                              $container: $(this),
                            }),
                          },
                        });
                      _.youtubeVars.videoData[containerId] = {
                        id: containerId,
                        container: this,
                        videoElement,
                        player,
                      };
                    }
                  }
                )
              : theme.loadScriptOnce("https://www.youtube.com/iframe_api"));
        }),
        (_._onYoutubePlayerReady = function (event) {
          event.target.setPlaybackQuality("hd1080"),
            this.autoplay && (event.target.mute(), event.target.playVideo()),
            _._initBackgroundVideo(this.$container);
        }),
        (_._onYoutubePlayerStateChange = function (event) {
          if (
            event.data == YT.PlayerState.PLAYING &&
            (this.$container.addClass("video--play-started"),
            this.autoplay && event.target.mute(),
            this.loop)
          ) {
            var finalSecond = event.target.getDuration() - 1;
            if (finalSecond > 2) {
              var loopTheVideo = function loopTheVideo2() {
                event.target.getCurrentTime() > finalSecond &&
                  event.target.seekTo(0),
                  setTimeout(loopTheVideo2, 250);
              };
              loopTheVideo();
            }
          }
        }),
        (_._unloadYoutubeVideos = function (container2) {
          for (var dataKey in _.youtubeVars.videoData) {
            var data = _.youtubeVars.videoData[dataKey];
            if ($(container2).find(data.container).length) {
              data.player.destroy(), delete _.youtubeVars.videoData[dataKey];
              return;
            }
          }
        }),
        (_.vimeoVars = {
          incrementor: 0,
          apiReady: !1,
          videoData: {},
          toProcessSelector:
            '.video-container[data-video-type="vimeo"]:not(.video--init)',
        }),
        (_.vimeoApiReady = function () {
          (_.vimeoVars.apiReady = !0), _._loadVimeoVideos();
        }),
        (_._loadVimeoVideos = function (container2) {
          $(_.vimeoVars.toProcessSelector, container2).length &&
            (_.vimeoVars.apiReady
              ? $(_.vimeoVars.toProcessSelector, container2).each(function () {
                  if (_._permitPlayback($(this))) {
                    $(this).addClass("video--init"), _.vimeoVars.incrementor++;
                    var $this = $(this),
                      containerId = "theme-vi-video-" + _.vimeoVars.incrementor;
                    $(this).data("video-container-id", containerId);
                    var videoElement = $(
                        '<div class="video-container__video-element">'
                      )
                        .attr("id", containerId)
                        .appendTo($(".video-container__video", this)),
                      autoplay = !!$(this).data("video-autoplay"),
                      player = new Vimeo.Player(containerId, {
                        url: $(this).data("video-url"),
                        width: 640,
                        loop: $(this).data("video-autoplay"),
                        autoplay,
                        muted: $this.hasClass("video-container--background"),
                      });
                    player.on(
                      "playing",
                      function () {
                        $(this).addClass("video--play-started");
                      }.bind(this)
                    ),
                      player.ready().then(function () {
                        if (
                          (autoplay && (player.setVolume(0), player.play()),
                          player.element &&
                            player.element.width &&
                            player.element.height)
                        ) {
                          var ratio =
                            parseInt(player.element.height) /
                            parseInt(player.element.width);
                          $this
                            .find(".video-container__video")
                            .css("padding-bottom", ratio * 100 + "%");
                        }
                        _._initBackgroundVideo($this);
                      }),
                      (_.vimeoVars.videoData[containerId] = {
                        id: containerId,
                        container: this,
                        videoElement,
                        player,
                        autoPlay: autoplay,
                      });
                  }
                })
              : window.define
              ? theme.loadScriptOnce(
                  "https://player.vimeo.com/api/player.js",
                  function () {
                    (_.vimeoVars.apiReady = !0),
                      _._loadVimeoVideos(),
                      (window.define = window.tempDefine);
                  },
                  function () {
                    (window.tempDefine = window.define), (window.define = null);
                  }
                )
              : theme.loadScriptOnce(
                  "https://player.vimeo.com/api/player.js",
                  function () {
                    (_.vimeoVars.apiReady = !0), _._loadVimeoVideos();
                  }
                ));
        }),
        (_._unloadVimeoVideos = function (container2) {
          for (var dataKey in _.vimeoVars.videoData) {
            var data = _.vimeoVars.videoData[dataKey];
            if ($(container2).find(data.container).length) {
              data.player.unload(), delete _.vimeoVars.videoData[dataKey];
              return;
            }
          }
        }),
        (_._loadThirdPartyApis = function (container2) {
          _._permitPlayback($(".video-container", container2)) &&
            (_._loadYoutubeVideos(container2), _._loadVimeoVideos(container2));
        }),
        (_.mp4Vars = {
          incrementor: 0,
          videoData: {},
          toProcessSelector:
            '.video-container[data-video-type="mp4"]:not(.video--init)',
        }),
        (_._loadMp4Videos = function (container2) {
          $(_.mp4Vars.toProcessSelector, container2).length &&
            $(_.mp4Vars.toProcessSelector, container2)
              .addClass("video--init")
              .each(function () {
                _.mp4Vars.incrementor++;
                var $this = $(this),
                  containerId = "theme-mp-video-" + _.mp4Vars.incrementor;
                $(this).data("video-container-id", containerId);
                var videoElement = $(
                    '<div class="video-container__video-element">'
                  )
                    .attr("id", containerId)
                    .appendTo($(".video-container__video", this)),
                  $video = $("<video playsinline>");
                $(this).data("video-loop") && $video.attr("loop", "loop"),
                  $(this).data("video-autoplay") &&
                    ($video.attr({ autoplay: "autoplay", muted: "muted" }),
                    ($video[0].muted = !0),
                    $video.one("loadeddata", function () {
                      this.play();
                    })),
                  $video.on(
                    "playing",
                    function () {
                      $(this).addClass("video--play-started");
                    }.bind(this)
                  ),
                  $video
                    .attr("src", $(this).data("video-url"))
                    .appendTo(videoElement);
              });
        }),
        (_._unloadMp4Videos = function (container2) {}),
        (_._initBackgroundVideo = function ($container) {
          if (
            $container.hasClass("video-container--background") &&
            $container.find(".video-container__video iframe").length
          ) {
            var assessBackgroundVideo = function () {
              var $container2 = this,
                cw = $container2.width(),
                ch = $container2.height(),
                cr = cw / ch,
                $frame = $(".video-container__video iframe", this),
                vr = $frame.attr("width") / $frame.attr("height"),
                $pan = $(".video-container__video", this),
                vCrop = 75;
              if (cr > vr) {
                var vh = cw / vr + vCrop * 2;
                $pan.css({
                  marginTop: (ch - vh) / 2 - vCrop,
                  marginLeft: "",
                  height: vh + vCrop * 2,
                  width: "",
                });
              } else {
                var vw = cw * vr + vCrop * 2 * vr;
                $pan.css({
                  marginTop: -vCrop,
                  marginLeft: (cw - vw) / 2,
                  height: ch + vCrop * 2,
                  width: vw,
                });
              }
            };
            assessBackgroundVideo.bind($container)(),
              $(window).on(
                "debouncedresize." + $container.data("video-container-id"),
                assessBackgroundVideo.bind($container)
              );
          }
        }),
        (this.onSectionLoad = function (container2) {
          $(".video-container[data-video-url]:not([data-video-type])").each(
            function () {
              var url = $(this).data("video-url");
              url.indexOf(".mp4") > -1 &&
                $(this).attr("data-video-type", "mp4"),
                url.indexOf("vimeo.com") > -1 &&
                  ($(this).attr("data-video-type", "vimeo"),
                  $(this).attr(
                    "data-video-id",
                    url.split("?")[0].split("/").pop()
                  )),
                (url.indexOf("youtu.be") > -1 ||
                  url.indexOf("youtube.com") > -1) &&
                  ($(this).attr("data-video-type", "youtube"),
                  url.indexOf("v=") > -1
                    ? $(this).attr(
                        "data-video-id",
                        url.split("v=").pop().split("&")[0]
                      )
                    : $(this).attr(
                        "data-video-id",
                        url.split("?")[0].split("/").pop()
                      ));
            }
          ),
            _._loadThirdPartyApis(container2),
            _._loadMp4Videos(container2),
            $(window).on("debouncedresize.video-manager-resize", function () {
              _._loadThirdPartyApis(container2);
            }),
            $(".video-container__play", container2).on("click", function (evt) {
              evt.preventDefault();
              var $container = $(this).closest(".video-container");
              $container.addClass("video-container--playing"),
                $(container2).trigger("cc:video:play");
              var id = $container.data("video-container-id");
              id.indexOf("theme-yt-video") === 0
                ? _.youtubeVars.videoData[id].player.playVideo()
                : _.vimeoVars.videoData[id].player.play();
            }),
            $(".video-container__stop", container2).on("click", function (evt) {
              evt.preventDefault();
              var $container = $(this).closest(".video-container");
              $container.removeClass("video-container--playing"),
                $(container2).trigger("cc:video:stop");
              var id = $container.data("video-container-id");
              id.indexOf("theme-yt-video") === 0
                ? _.youtubeVars.videoData[id].player.stopVideo()
                : (_.vimeoVars.videoData[id].player.pause(),
                  _.vimeoVars.videoData[id].player.setCurrentTime(0));
            });
        }),
        (this.onSectionUnload = function (container2) {
          $(".video-container__play, .video-container__stop", container2).off(
            "click"
          ),
            $(window).off(
              "." + $(".video-container").data("video-container-id")
            ),
            $(window).off("debouncedresize.video-manager-resize"),
            _._unloadYoutubeVideos(container2),
            _._unloadVimeoVideos(container2),
            _._unloadMp4Videos(container2),
            $(container2).trigger("cc:video:stop");
        });
    })()),
    (window.onYouTubeIframeAPIReady = function () {
      theme.VideoManager.youtubeApiReady();
    }),
    cc.sections.push({ name: "video", section: theme.VideoManager }),
    (theme.MapSection = new (function () {
      var _ = this;
      (_.config = {
        zoom: 14,
        styles: {
          default: [],
          silver: [
            { elementType: "geometry", stylers: [{ color: "#f5f5f5" }] },
            { elementType: "labels.icon", stylers: [{ visibility: "off" }] },
            {
              elementType: "labels.text.fill",
              stylers: [{ color: "#616161" }],
            },
            {
              elementType: "labels.text.stroke",
              stylers: [{ color: "#f5f5f5" }],
            },
            {
              featureType: "administrative.land_parcel",
              elementType: "labels.text.fill",
              stylers: [{ color: "#bdbdbd" }],
            },
            {
              featureType: "poi",
              elementType: "geometry",
              stylers: [{ color: "#eeeeee" }],
            },
            {
              featureType: "poi",
              elementType: "labels.text.fill",
              stylers: [{ color: "#757575" }],
            },
            {
              featureType: "poi.park",
              elementType: "geometry",
              stylers: [{ color: "#e5e5e5" }],
            },
            {
              featureType: "poi.park",
              elementType: "labels.text.fill",
              stylers: [{ color: "#9e9e9e" }],
            },
            {
              featureType: "road",
              elementType: "geometry",
              stylers: [{ color: "#ffffff" }],
            },
            {
              featureType: "road.arterial",
              elementType: "labels.text.fill",
              stylers: [{ color: "#757575" }],
            },
            {
              featureType: "road.highway",
              elementType: "geometry",
              stylers: [{ color: "#dadada" }],
            },
            {
              featureType: "road.highway",
              elementType: "labels.text.fill",
              stylers: [{ color: "#616161" }],
            },
            {
              featureType: "road.local",
              elementType: "labels.text.fill",
              stylers: [{ color: "#9e9e9e" }],
            },
            {
              featureType: "transit.line",
              elementType: "geometry",
              stylers: [{ color: "#e5e5e5" }],
            },
            {
              featureType: "transit.station",
              elementType: "geometry",
              stylers: [{ color: "#eeeeee" }],
            },
            {
              featureType: "water",
              elementType: "geometry",
              stylers: [{ color: "#c9c9c9" }],
            },
            {
              featureType: "water",
              elementType: "labels.text.fill",
              stylers: [{ color: "#9e9e9e" }],
            },
          ],
          retro: [
            { elementType: "geometry", stylers: [{ color: "#ebe3cd" }] },
            {
              elementType: "labels.text.fill",
              stylers: [{ color: "#523735" }],
            },
            {
              elementType: "labels.text.stroke",
              stylers: [{ color: "#f5f1e6" }],
            },
            {
              featureType: "administrative",
              elementType: "geometry.stroke",
              stylers: [{ color: "#c9b2a6" }],
            },
            {
              featureType: "administrative.land_parcel",
              elementType: "geometry.stroke",
              stylers: [{ color: "#dcd2be" }],
            },
            {
              featureType: "administrative.land_parcel",
              elementType: "labels.text.fill",
              stylers: [{ color: "#ae9e90" }],
            },
            {
              featureType: "landscape.natural",
              elementType: "geometry",
              stylers: [{ color: "#dfd2ae" }],
            },
            {
              featureType: "poi",
              elementType: "geometry",
              stylers: [{ color: "#dfd2ae" }],
            },
            {
              featureType: "poi",
              elementType: "labels.text.fill",
              stylers: [{ color: "#93817c" }],
            },
            {
              featureType: "poi.park",
              elementType: "geometry.fill",
              stylers: [{ color: "#a5b076" }],
            },
            {
              featureType: "poi.park",
              elementType: "labels.text.fill",
              stylers: [{ color: "#447530" }],
            },
            {
              featureType: "road",
              elementType: "geometry",
              stylers: [{ color: "#f5f1e6" }],
            },
            {
              featureType: "road.arterial",
              elementType: "geometry",
              stylers: [{ color: "#fdfcf8" }],
            },
            {
              featureType: "road.highway",
              elementType: "geometry",
              stylers: [{ color: "#f8c967" }],
            },
            {
              featureType: "road.highway",
              elementType: "geometry.stroke",
              stylers: [{ color: "#e9bc62" }],
            },
            {
              featureType: "road.highway.controlled_access",
              elementType: "geometry",
              stylers: [{ color: "#e98d58" }],
            },
            {
              featureType: "road.highway.controlled_access",
              elementType: "geometry.stroke",
              stylers: [{ color: "#db8555" }],
            },
            {
              featureType: "road.local",
              elementType: "labels.text.fill",
              stylers: [{ color: "#806b63" }],
            },
            {
              featureType: "transit.line",
              elementType: "geometry",
              stylers: [{ color: "#dfd2ae" }],
            },
            {
              featureType: "transit.line",
              elementType: "labels.text.fill",
              stylers: [{ color: "#8f7d77" }],
            },
            {
              featureType: "transit.line",
              elementType: "labels.text.stroke",
              stylers: [{ color: "#ebe3cd" }],
            },
            {
              featureType: "transit.station",
              elementType: "geometry",
              stylers: [{ color: "#dfd2ae" }],
            },
            {
              featureType: "water",
              elementType: "geometry.fill",
              stylers: [{ color: "#b9d3c2" }],
            },
            {
              featureType: "water",
              elementType: "labels.text.fill",
              stylers: [{ color: "#92998d" }],
            },
          ],
          dark: [
            { elementType: "geometry", stylers: [{ color: "#212121" }] },
            { elementType: "labels.icon", stylers: [{ visibility: "off" }] },
            {
              elementType: "labels.text.fill",
              stylers: [{ color: "#757575" }],
            },
            {
              elementType: "labels.text.stroke",
              stylers: [{ color: "#212121" }],
            },
            {
              featureType: "administrative",
              elementType: "geometry",
              stylers: [{ color: "#757575" }],
            },
            {
              featureType: "administrative.country",
              elementType: "labels.text.fill",
              stylers: [{ color: "#9e9e9e" }],
            },
            {
              featureType: "administrative.land_parcel",
              stylers: [{ visibility: "off" }],
            },
            {
              featureType: "administrative.locality",
              elementType: "labels.text.fill",
              stylers: [{ color: "#bdbdbd" }],
            },
            {
              featureType: "poi",
              elementType: "labels.text.fill",
              stylers: [{ color: "#757575" }],
            },
            {
              featureType: "poi.park",
              elementType: "geometry",
              stylers: [{ color: "#181818" }],
            },
            {
              featureType: "poi.park",
              elementType: "labels.text.fill",
              stylers: [{ color: "#616161" }],
            },
            {
              featureType: "poi.park",
              elementType: "labels.text.stroke",
              stylers: [{ color: "#1b1b1b" }],
            },
            {
              featureType: "road",
              elementType: "geometry.fill",
              stylers: [{ color: "#2c2c2c" }],
            },
            {
              featureType: "road",
              elementType: "labels.text.fill",
              stylers: [{ color: "#8a8a8a" }],
            },
            {
              featureType: "road.arterial",
              elementType: "geometry",
              stylers: [{ color: "#373737" }],
            },
            {
              featureType: "road.highway",
              elementType: "geometry",
              stylers: [{ color: "#3c3c3c" }],
            },
            {
              featureType: "road.highway.controlled_access",
              elementType: "geometry",
              stylers: [{ color: "#4e4e4e" }],
            },
            {
              featureType: "road.local",
              elementType: "labels.text.fill",
              stylers: [{ color: "#616161" }],
            },
            {
              featureType: "transit",
              elementType: "labels.text.fill",
              stylers: [{ color: "#757575" }],
            },
            {
              featureType: "water",
              elementType: "geometry",
              stylers: [{ color: "#000000" }],
            },
            {
              featureType: "water",
              elementType: "labels.text.fill",
              stylers: [{ color: "#3d3d3d" }],
            },
          ],
          night: [
            { elementType: "geometry", stylers: [{ color: "#242f3e" }] },
            {
              elementType: "labels.text.fill",
              stylers: [{ color: "#746855" }],
            },
            {
              elementType: "labels.text.stroke",
              stylers: [{ color: "#242f3e" }],
            },
            {
              featureType: "administrative.locality",
              elementType: "labels.text.fill",
              stylers: [{ color: "#d59563" }],
            },
            {
              featureType: "poi",
              elementType: "labels.text.fill",
              stylers: [{ color: "#d59563" }],
            },
            {
              featureType: "poi.park",
              elementType: "geometry",
              stylers: [{ color: "#263c3f" }],
            },
            {
              featureType: "poi.park",
              elementType: "labels.text.fill",
              stylers: [{ color: "#6b9a76" }],
            },
            {
              featureType: "road",
              elementType: "geometry",
              stylers: [{ color: "#38414e" }],
            },
            {
              featureType: "road",
              elementType: "geometry.stroke",
              stylers: [{ color: "#212a37" }],
            },
            {
              featureType: "road",
              elementType: "labels.text.fill",
              stylers: [{ color: "#9ca5b3" }],
            },
            {
              featureType: "road.highway",
              elementType: "geometry",
              stylers: [{ color: "#746855" }],
            },
            {
              featureType: "road.highway",
              elementType: "geometry.stroke",
              stylers: [{ color: "#1f2835" }],
            },
            {
              featureType: "road.highway",
              elementType: "labels.text.fill",
              stylers: [{ color: "#f3d19c" }],
            },
            {
              featureType: "transit",
              elementType: "geometry",
              stylers: [{ color: "#2f3948" }],
            },
            {
              featureType: "transit.station",
              elementType: "labels.text.fill",
              stylers: [{ color: "#d59563" }],
            },
            {
              featureType: "water",
              elementType: "geometry",
              stylers: [{ color: "#17263c" }],
            },
            {
              featureType: "water",
              elementType: "labels.text.fill",
              stylers: [{ color: "#515c6d" }],
            },
            {
              featureType: "water",
              elementType: "labels.text.stroke",
              stylers: [{ color: "#17263c" }],
            },
          ],
          aubergine: [
            { elementType: "geometry", stylers: [{ color: "#1d2c4d" }] },
            {
              elementType: "labels.text.fill",
              stylers: [{ color: "#8ec3b9" }],
            },
            {
              elementType: "labels.text.stroke",
              stylers: [{ color: "#1a3646" }],
            },
            {
              featureType: "administrative.country",
              elementType: "geometry.stroke",
              stylers: [{ color: "#4b6878" }],
            },
            {
              featureType: "administrative.land_parcel",
              elementType: "labels.text.fill",
              stylers: [{ color: "#64779e" }],
            },
            {
              featureType: "administrative.province",
              elementType: "geometry.stroke",
              stylers: [{ color: "#4b6878" }],
            },
            {
              featureType: "landscape.man_made",
              elementType: "geometry.stroke",
              stylers: [{ color: "#334e87" }],
            },
            {
              featureType: "landscape.natural",
              elementType: "geometry",
              stylers: [{ color: "#023e58" }],
            },
            {
              featureType: "poi",
              elementType: "geometry",
              stylers: [{ color: "#283d6a" }],
            },
            {
              featureType: "poi",
              elementType: "labels.text.fill",
              stylers: [{ color: "#6f9ba5" }],
            },
            {
              featureType: "poi",
              elementType: "labels.text.stroke",
              stylers: [{ color: "#1d2c4d" }],
            },
            {
              featureType: "poi.park",
              elementType: "geometry.fill",
              stylers: [{ color: "#023e58" }],
            },
            {
              featureType: "poi.park",
              elementType: "labels.text.fill",
              stylers: [{ color: "#3C7680" }],
            },
            {
              featureType: "road",
              elementType: "geometry",
              stylers: [{ color: "#304a7d" }],
            },
            {
              featureType: "road",
              elementType: "labels.text.fill",
              stylers: [{ color: "#98a5be" }],
            },
            {
              featureType: "road",
              elementType: "labels.text.stroke",
              stylers: [{ color: "#1d2c4d" }],
            },
            {
              featureType: "road.highway",
              elementType: "geometry",
              stylers: [{ color: "#2c6675" }],
            },
            {
              featureType: "road.highway",
              elementType: "geometry.stroke",
              stylers: [{ color: "#255763" }],
            },
            {
              featureType: "road.highway",
              elementType: "labels.text.fill",
              stylers: [{ color: "#b0d5ce" }],
            },
            {
              featureType: "road.highway",
              elementType: "labels.text.stroke",
              stylers: [{ color: "#023e58" }],
            },
            {
              featureType: "transit",
              elementType: "labels.text.fill",
              stylers: [{ color: "#98a5be" }],
            },
            {
              featureType: "transit",
              elementType: "labels.text.stroke",
              stylers: [{ color: "#1d2c4d" }],
            },
            {
              featureType: "transit.line",
              elementType: "geometry.fill",
              stylers: [{ color: "#283d6a" }],
            },
            {
              featureType: "transit.station",
              elementType: "geometry",
              stylers: [{ color: "#3a4762" }],
            },
            {
              featureType: "water",
              elementType: "geometry",
              stylers: [{ color: "#0e1626" }],
            },
            {
              featureType: "water",
              elementType: "labels.text.fill",
              stylers: [{ color: "#4e6d70" }],
            },
          ],
        },
      }),
        (_.apiStatus = null),
        (this.geolocate = function ($map) {
          var deferred = $.Deferred(),
            geocoder = new google.maps.Geocoder(),
            address = $map.data("address-setting");
          return (
            geocoder.geocode({ address }, function (results, status2) {
              status2 !== google.maps.GeocoderStatus.OK &&
                deferred.reject(status2),
                deferred.resolve(results);
            }),
            deferred
          );
        }),
        (this.createMap = function (container2) {
          var $map = $(".map-section__map-container", container2);
          return _.geolocate($map)
            .then(
              function (results) {
                var mapOptions = {
                  zoom: _.config.zoom,
                  styles: _.config.styles[$(container2).data("map-style")],
                  center: results[0].geometry.location,
                  scrollwheel: !1,
                  disableDoubleClickZoom: !0,
                  disableDefaultUI: !0,
                  zoomControl: !0,
                };
                (_.map = new google.maps.Map($map[0], mapOptions)),
                  (_.center = _.map.getCenter());
                var marker = new google.maps.Marker({
                  map: _.map,
                  position: _.center,
                  clickable: !1,
                });
                google.maps.event.addDomListener(window, "resize", function () {
                  google.maps.event.trigger(_.map, "resize"),
                    _.map.setCenter(_.center);
                });
              }.bind(this)
            )
            .fail(function () {
              var errorMessage;
              switch (status) {
                case "ZERO_RESULTS":
                  errorMessage = theme.strings.addressNoResults;
                  break;
                case "OVER_QUERY_LIMIT":
                  errorMessage = theme.strings.addressQueryLimit;
                  break;
                default:
                  errorMessage = theme.strings.addressError;
                  break;
              }
              if (Shopify.designMode) {
                var $mapContainer = $map.parents(".map-section");
                $mapContainer.addClass("page-width map-section--load-error"),
                  $mapContainer
                    .find(".map-section__wrapper")
                    .html(
                      '<div class="errors text-center">' +
                        errorMessage +
                        "</div>"
                    );
              }
            });
        }),
        (this.onSectionLoad = function (target) {
          var $container = $(target);
          window.gm_authFailure = function () {
            Shopify.designMode &&
              ($container.addClass("page-width map-section--load-error"),
              $container
                .find(".map-section__wrapper")
                .html(
                  '<div class="errors text-center">' +
                    theme.strings.authError +
                    "</div>"
                ));
          };
          var key = $container.data("api-key");
          typeof key != "string" ||
            key === "" ||
            theme.loadScriptOnce(
              "https://maps.googleapis.com/maps/api/js?key=" + key,
              function () {
                _.createMap($container);
              }
            );
        }),
        (this.onSectionUnload = function (target) {
          typeof window.google < "u" &&
            typeof google.maps < "u" &&
            google.maps.event.clearListeners(this.map, "resize");
        });
    })()),
    cc.sections.push({ name: "map", section: theme.MapSection }),
    (theme.Faq = new (function () {
      (this.onSectionLoad = function (container2) {
        (this.namespace = theme.namespaceFromSection(container2)),
          (this.container = container2),
          (this.classNames = {
            questionContainerHidden: "faq-question-container--hide",
          }),
          (this.searchInput =
            this.container.querySelector(".faq-search__input")),
          this.searchInput &&
            (this.registerEventListener(
              this.searchInput,
              "change",
              this.functions.performSearch.bind(this)
            ),
            this.registerEventListener(
              this.searchInput,
              "keyup",
              this.functions.performSearch.bind(this)
            ),
            this.registerEventListener(
              this.searchInput,
              "paste",
              this.functions.performSearch.bind(this)
            )),
          this.container.querySelector(".faq-index-item__link") &&
            this.registerEventListener(
              this.container,
              "click",
              this.functions.handleIndexClick.bind(this)
            );
      }),
        (this.functions = {
          performSearch: function () {
            setTimeout(
              function () {
                var splitValue = this.searchInput.value.split(" "),
                  questionContainers = this.container.querySelectorAll(
                    ".faq-question-container"
                  ),
                  terms = [];
                splitValue.forEach(function (t) {
                  t.length > 0 && terms.push(t.toLowerCase());
                }),
                  questionContainers.forEach(
                    function (element) {
                      if (terms.length) {
                        var termFound = !1,
                          matchContent = element.textContent.toLowerCase();
                        terms.forEach(function (term) {
                          matchContent.indexOf(term) >= 0 && (termFound = !0);
                        }),
                          termFound
                            ? element.classList.remove(
                                this.classNames.questionContainerHidden
                              )
                            : element.classList.add(
                                this.classNames.questionContainerHidden
                              );
                      } else
                        element.classList.remove(
                          this.classNames.questionContainerHidden
                        );
                    }.bind(this)
                  ),
                  this.container.querySelectorAll(".faq-content").forEach(
                    function (element) {
                      terms.length
                        ? element.classList.add(
                            this.classNames.questionContainerHidden
                          )
                        : element.classList.remove(
                            this.classNames.questionContainerHidden
                          );
                    }.bind(this)
                  );
              }.bind(this),
              10
            );
          },
          handleIndexClick: function (evt) {
            if (evt.target.classList.contains("faq-index-item__link")) {
              evt.preventDefault();
              var id = evt.target.href.split("#")[1],
                scrollTarget = document.getElementById(id),
                scrollTargetY =
                  scrollTarget.getBoundingClientRect().top +
                  window.pageYOffset -
                  50,
                stickyHeight = getComputedStyle(
                  document.documentElement
                ).getPropertyValue("--theme-sticky-header-height");
              stickyHeight && (scrollTargetY -= parseInt(stickyHeight)),
                window.scrollTo({ top: scrollTargetY, behavior: "smooth" });
            }
          },
        });
    })()),
    cc.sections.push({ name: "faq", section: theme.Faq }),
    (theme.StoreAvailability = function (container2) {
      var loadingClass = "store-availability-loading",
        initClass = "store-availability-initialized",
        storageKey = "cc-location";
      (this.onSectionLoad = function (container3) {
        var _this8 = this;
        (this.namespace = theme.namespaceFromSection(container3)),
          (this.$container = $(container3)),
          (this.productId = this.$container.data(
            "store-availability-container"
          )),
          (this.sectionUrl = this.$container.data("section-url")),
          this.$modal;
        var firstRun = !0;
        $(window).on(
          "cc-variant-updated".concat(this.namespace).concat(this.productId),
          function (e, args) {
            args.product.id === _this8.productId &&
              (_this8.functions.updateContent.bind(_this8)(
                args.variant.id,
                args.product.title,
                firstRun,
                _this8.$container.data("has-only-default-variant"),
                typeof args.variant.available < "u"
              ),
              (firstRun = !1));
          }
        ),
          this.$container.data("single-variant-id") &&
            (this.functions.updateContent.bind(this)(
              this.$container.data("single-variant-id"),
              this.$container.data("single-variant-product-title"),
              firstRun,
              this.$container.data("has-only-default-variant"),
              this.$container.data("single-variant-product-available")
            ),
            (firstRun = !1));
      }),
        (this.onSectionUnload = function () {
          $(window).off(
            "cc-variant-updated".concat(this.namespace).concat(this.productId)
          ),
            this.$container.off("click"),
            this.$modal && this.$modal.off("click");
        }),
        (this.functions = {
          getUserLocation: function () {
            return new Promise(function (resolve, reject) {
              var storedCoords;
              sessionStorage[storageKey] &&
                (storedCoords = JSON.parse(sessionStorage[storageKey])),
                storedCoords
                  ? resolve(storedCoords)
                  : navigator.geolocation
                  ? navigator.geolocation.getCurrentPosition(
                      function (position) {
                        var coords = {
                          latitude: position.coords.latitude,
                          longitude: position.coords.longitude,
                        };
                        fetch("/localization.json", {
                          method: "PUT",
                          headers: { "Content-Type": "application/json" },
                          body: JSON.stringify(coords),
                        }),
                          (sessionStorage[storageKey] = JSON.stringify(coords)),
                          resolve(coords);
                      },
                      function () {
                        resolve(!1);
                      },
                      { maximumAge: 36e5, timeout: 5e3 }
                    )
                  : resolve(!1);
            });
          },
          getAvailableStores: function (variantId, cb) {
            return $.get(this.sectionUrl.replace("VARIANT_ID", variantId), cb);
          },
          calculateDistance: function (coords1, coords2, unitSystem) {
            var dtor = Math.PI / 180,
              radius = unitSystem === "metric" ? 6378.14 : 3959,
              rlat1 = coords1.latitude * dtor,
              rlong1 = coords1.longitude * dtor,
              rlat2 = coords2.latitude * dtor,
              rlong2 = coords2.longitude * dtor,
              dlon = rlong1 - rlong2,
              dlat = rlat1 - rlat2,
              a =
                Math.pow(Math.sin(dlat / 2), 2) +
                Math.cos(rlat1) *
                  Math.cos(rlat2) *
                  Math.pow(Math.sin(dlon / 2), 2),
              c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
            return radius * c;
          },
          updateLocationDistances: function (coords) {
            var unitSystem = this.$modal
                .find("[data-unit-system]")
                .data("unit-system"),
              self = this;
            this.$modal.find('[data-distance="false"]').each(function () {
              var _this9 = this,
                thisCoords = {
                  latitude: parseFloat($(this).data("latitude")),
                  longitude: parseFloat($(this).data("longitude")),
                };
              if (thisCoords.latitude && thisCoords.longitude) {
                var distance = self.functions
                  .calculateDistance(coords, thisCoords, unitSystem)
                  .toFixed(1);
                $(this).html(distance),
                  setTimeout(function () {
                    $(_this9)
                      .closest(".store-availability-list__location__distance")
                      .addClass("-in");
                  }, 0);
              }
              $(this).attr("data-distance", "true");
            });
          },
          updateContent: function (
            variantId,
            productTitle,
            firstRun,
            isSingleDefaultVariant,
            isVariantAvailable
          ) {
            var _this10 = this;
            this.$container.off(
              "click",
              "[data-store-availability-modal-open]"
            ),
              this.$container.off(
                "click" + this.namespace,
                ".cc-popup-close, .cc-popup-background"
              ),
              $(".store-availabilities-modal").remove(),
              firstRun
                ? this.$container.hide()
                : isVariantAvailable
                ? (this.$container.addClass(loadingClass).addClass(initClass),
                  this.$container.css(
                    "height",
                    this.$container.outerHeight() > 0
                      ? this.$container.outerHeight() + "px"
                      : "auto"
                  ))
                : (this.$container.addClass(loadingClass).addClass(initClass),
                  this.$container.css("height", "0px")),
              isVariantAvailable &&
                this.functions.getAvailableStores.call(
                  this,
                  variantId,
                  function (response) {
                    if (
                      response.trim().length > 0 &&
                      !response.includes("NO_PICKUP")
                    ) {
                      _this10.$container.html(response),
                        _this10.$container.html(
                          _this10.$container.children().first().html()
                        ),
                        _this10.$container
                          .find("[data-store-availability-modal-product-title]")
                          .html(productTitle),
                        isSingleDefaultVariant &&
                          _this10.$container
                            .find(".store-availabilities-modal__variant-title")
                            .remove(),
                        _this10.$container.find(".cc-popup").appendTo("body"),
                        (_this10.$modal = $("body").find(
                          ".store-availabilities-modal"
                        ));
                      var popup = new ccPopup(
                        _this10.$modal,
                        _this10.namespace
                      );
                      if (
                        (_this10.$container.on(
                          "click",
                          "[data-store-availability-modal-open]",
                          function () {
                            return (
                              popup.open(),
                              _this10.functions
                                .getUserLocation()
                                .then(function (coords) {
                                  coords &&
                                    _this10.$modal.find(
                                      '[data-distance="false"]'
                                    ).length &&
                                    _this10.functions.getAvailableStores.call(
                                      _this10,
                                      variantId,
                                      function (response2) {
                                        _this10.$modal
                                          .find(".store-availabilities-list")
                                          .html(
                                            $(response2)
                                              .find(
                                                ".store-availabilities-list"
                                              )
                                              .html()
                                          ),
                                          _this10.functions.updateLocationDistances.bind(
                                            _this10
                                          )(coords);
                                      }
                                    );
                                }),
                              !1
                            );
                          }
                        ),
                        _this10.$modal.on(
                          "click" + _this10.namespace,
                          ".cc-popup-close, .cc-popup-background",
                          function () {
                            popup.close();
                          }
                        ),
                        firstRun)
                      )
                        _this10.$container.slideDown(300);
                      else {
                        _this10.$container.removeClass(loadingClass);
                        var newHeight = _this10.$container
                          .find(".store-availability-container")
                          .outerHeight();
                        _this10.$container.css(
                          "height",
                          newHeight > 0 ? newHeight + "px" : "auto"
                        );
                      }
                    }
                  }
                );
          },
        }),
        this.onSectionLoad(container2);
    }),
    cc.sections.push({
      name: "store-availability",
      section: theme.StoreAvailability,
    }),
    (theme.Popup = new (function () {
      var dismissedStorageKey = "cc-theme-popup-dismissed";
      (this.onSectionLoad = function (container2) {
        var _this11 = this;
        (this.namespace = theme.namespaceFromSection(container2)),
          (this.$container = $(container2)),
          (this.popup = new ccPopup(this.$container, this.namespace));
        var dismissForDays = this.$container.data("dismiss-for-days"),
          delaySeconds = this.$container.data("delay-seconds"),
          showPopup = !0,
          testMode = this.$container.data("test-mode"),
          lastDismissed = window.localStorage.getItem(dismissedStorageKey);
        if (lastDismissed) {
          var dismissedDaysAgo = (new Date().getTime() - lastDismissed) / 864e5;
          dismissedDaysAgo < dismissForDays && (showPopup = !1);
        }
        this.$container.find(".cc-popup-form__response").length &&
          ((showPopup = !0),
          (delaySeconds = 1),
          this.$container.find(".cc-popup-form__response--success").length &&
            this.functions.popupSetAsDismissed.call(this)),
          document.querySelector(".shopify-challenge__container") &&
            (showPopup = !1),
          (showPopup || testMode) &&
            setTimeout(function () {
              _this11.popup.open();
            }, delaySeconds * 1e3),
          this.$container.on(
            "click" + this.namespace,
            ".cc-popup-close, .cc-popup-background",
            function () {
              _this11.popup.close(function () {
                _this11.functions.popupSetAsDismissed.call(_this11);
              });
            }
          );
      }),
        (this.onSectionSelect = function () {
          this.popup.open();
        }),
        (this.functions = {
          popupSetAsDismissed: function () {
            window.localStorage.setItem(
              dismissedStorageKey,
              new Date().getTime()
            );
          },
        }),
        (this.onSectionUnload = function () {
          this.$container.off(this.namespace);
        });
    })()),
    cc.sections.push({ name: "newsletter-popup", section: theme.Popup }),
    (theme.owlCarouselEventList =
      [
        "to",
        "next",
        "prev",
        "destroy",
        "initialized",
        "resized",
        "refreshed",
      ].join(".owl.carousel ") + ".owl.carousel"),
    (theme.beforeCarouselLoadEventBlockFix = function (carouselEls) {
      $(carouselEls).on(theme.owlCarouselEventList, function (evt) {
        evt.stopPropagation();
      });
    }),
    (theme.beforeCarouselUnloadEventBlockFix = function (carouselEls) {
      $(carouselEls).off(theme.owlCarouselEventList);
    }),
    (theme.loadCarousels = function (container2) {
      return $(".carousel", container2).each(function () {
        var $this = $(this);
        function getTotalProductBlockWidth() {
          var productBlockTotalWidth = 0;
          return (
            $this
              .find(
                $this.hasClass("owl-loaded")
                  ? ".owl-item:not(.cloned)"
                  : ".product-block"
              )
              .each(function () {
                productBlockTotalWidth += $(this).outerWidth(!0);
              }),
            productBlockTotalWidth
          );
        }
        $this
          .closest(".collection-slider")
          .on("click.themeCarousel", ".prev, .next", function (e) {
            e.preventDefault();
            var carousel = $(this)
              .closest(".collection-slider")
              .find(".owl-carousel")
              .data("owl.carousel");
            $(this).hasClass("prev") ? carousel.prev() : carousel.next();
          });
        var carouselOptions,
          isLooping,
          fixedMode = !$(this).closest(".container--no-max").length;
        if (
          ($this.toggleClass("carousel--fixed-grid-mode", fixedMode), fixedMode)
        ) {
          var desktopNumPerRow = parseInt(
            $(this)[0].className.match(/per-row-(.)/)[1]
          );
          carouselOptions = {
            margin: 0,
            loop: !1,
            autoWidth: !1,
            items: 5,
            center: !1,
            nav: !1,
            dots: !1,
            responsive: {
              0: { items: desktopNumPerRow < 4 ? 1 : 2 },
              480: { items: Math.min(2, desktopNumPerRow - 2) },
              767: { items: desktopNumPerRow - 1 },
              1e3: { items: desktopNumPerRow },
            },
          };
        } else (isLooping = getTotalProductBlockWidth() > $this.width()), (carouselOptions = { margin: 0, loop: isLooping, autoWidth: !0, items: Math.min($this.children().length, 8), center: !0, nav: !1, dots: !1 });
        var loadCarousel = function () {
          $this.find("[data-src]").each(function () {
            $(this)
              .attr("data-src-temp", $(this).attr("data-src"))
              .removeAttr("data-src");
          }),
            theme.beforeCarouselLoadEventBlockFix($this),
            $this.on("initialized.owl.carousel", function () {
              $this.find("[data-src-temp]").each(function () {
                $(this)
                  .attr("data-src", $(this).attr("data-src-temp"))
                  .removeAttr("data-src-temp");
              }),
                $this
                  .find(
                    '.product-block__image--primary .lazyload--manual, .product-block__image--secondary[data-image-index="1"] .lazyload--manual'
                  )
                  .removeClass("lazyload--manual")
                  .addClass("lazyload"),
                theme.ProductBlockManager.loadImages(
                  $this.closest("[data-section-type]")
                ),
                setTimeout(function () {
                  $this.data("owl.carousel").invalidate("width"),
                    $this.trigger("refresh.owl.carousel");
                }, 10);
            }),
            $this.on(
              "initialized.owl.carousel resized.owl.carousel",
              function (evt) {
                if (!fixedMode && evt.type == "resized") {
                  var shouldLoop = getTotalProductBlockWidth() > $this.width();
                  if (shouldLoop != isLooping) {
                    (carouselOptions.loop = shouldLoop),
                      (isLooping = shouldLoop),
                      $(evt.target).data("owl.carousel").destroy(),
                      $(evt.target).owlCarousel(carouselOptions);
                    return;
                  }
                }
                setTimeout(function () {
                  var currentWidth = $this.find(".owl-stage").width(),
                    stageIsPartiallyOffScreen = currentWidth > $this.width();
                  if (stageIsPartiallyOffScreen) {
                    var newWidth = 0;
                    $this.find(".owl-item").each(function () {
                      newWidth += $(this).outerWidth(!0) + 1;
                    }),
                      $this
                        .find(".owl-stage")
                        .css({})
                        .removeClass("owl-stage--items-fit");
                  } else $this.find(".owl-stage").addClass("owl-stage--items-fit").css({});
                  $this
                    .closest(".collection-slider")
                    .find(".prev, .next")
                    .toggleClass(
                      "owl-btn-disabled",
                      !stageIsPartiallyOffScreen
                    );
                }, 10);
              }
            ),
            (theme.carouselInputIncrementer =
              theme.carouselInputIncrementer || 0),
            $this
              .on("refreshed.owl.carousel", function () {
                $(".owl-item", this).removeAttr("aria-hidden"),
                  $(".owl-item.cloned", this)
                    .attr("aria-hidden", "true")
                    .each(function () {
                      theme.carouselInputIncrementer++;
                      var uniquenessSuffix =
                        "_" + theme.carouselInputIncrementer;
                      $(this)
                        .find(
                          "form[id]:not([data-id-altered]), :input[id]:not([data-id-altered])"
                        )
                        .each(function () {
                          $(this).attr(
                            "id",
                            $(this).attr("id") + uniquenessSuffix
                          );
                        })
                        .attr("data-id-altered", !0),
                        $(this)
                          .find("label[for]:not([data-id-altered])")
                          .each(function () {
                            $(this).attr(
                              "for",
                              $(this).attr("for") + uniquenessSuffix
                            );
                          })
                          .attr("data-id-altered", !0);
                    });
              })
              .addClass("owl-carousel")
              .owlCarousel(carouselOptions);
        };
        loadCarousel();
      });
    }),
    (theme.unloadCarousels = function (container2) {
      $(".collection-slider", container2).off(".themeCarousel"),
        $(".slick-slider", container2).slick("unslick"),
        theme.beforeCarouselUnloadEventBlockFix($(".owl-carousel", container2)),
        $(".owl-carousel", container2).each(function () {
          $(this).data("owl.carousel").destroy();
        });
    }),
    (theme.icons = {
      left:
        '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><title>' +
        theme.strings.icon_labels_left +
        '</title><path d="M0 0h24v24H0z" fill="none"/><path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/></svg>',
      right:
        '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><title>' +
        theme.strings.icon_labels_right +
        '</title><path d="M0 0h24v24H0z" fill="none"/><path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"/></svg>',
      close:
        '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><title>' +
        theme.strings.icon_labels_close +
        '</title><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>',
      chevronLeft:
        '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-left"><title>' +
        theme.strings.icon_labels_left +
        '</title><polyline points="15 18 9 12 15 6"></polyline></svg>',
      chevronRight:
        '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-right"><title>' +
        theme.strings.icon_labels_right +
        '</title><polyline points="9 18 15 12 9 6"></polyline></svg>',
      chevronDown:
        '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><title>' +
        theme.strings.icon_labels_down +
        '</title><path d="M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z"/><path d="M0-.75h24v24H0z" fill="none"/></svg>',
      tick: '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h24v24H0z" fill="none"/><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>',
      label:
        '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="feather feather-tag"><title>Label</title><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path><line x1="7" y1="7" x2="7" y2="7"></line></svg>',
    });
  try {
    theme.Shopify.features = JSON.parse(
      document.documentElement.querySelector("#shopify-features").textContent
    );
  } catch (e) {
    theme.Shopify.features = {};
  }
  (theme.namespaceFromSection = function (container2) {
    return [
      ".",
      $(container2).data("section-type"),
      $(container2).data("section-id"),
    ].join("");
  }),
    (theme.toggleLinkDropdownButton = function (evt) {
      evt.stopPropagation();
      var $btn2 = $(evt.currentTarget),
        doExpand = $btn2.attr("aria-expanded") == "false";
      $btn2.attr("aria-expanded", doExpand),
        $btn2.css("width", $btn2.outerWidth() + "px");
      var newWidth = null,
        $optsBox = $btn2.next(),
        isLeftAligned = $btn2
          .closest(".link-dropdown")
          .hasClass("link-dropdown--left-aligned");
      isLeftAligned ||
        (doExpand
          ? ((newWidth = $optsBox.outerWidth()),
            (newWidth += parseInt($optsBox.css("right"))),
            (newWidth -= parseInt(
              $optsBox.find(".link-dropdown__link:first").css("padding-left")
            )))
          : (newWidth =
              parseInt($btn2.css("padding-right")) +
              $btn2.find(".link-dropdown__button-text").width() +
              1),
        setTimeout(function () {
          $btn2.css("width", newWidth + "px");
        }, 10));
    }),
    (theme.awakenImagesFromSlumber = function ($cont) {
      $cont.find(".lazyload--manual:not(.lazyload)").addClass("lazyload");
    }),
    (theme.classUpTextLinks = function (container2) {
      $(".rte a:has(img)", container2).addClass("image-link");
    }),
    (theme.select2 = {
      transitionOutDelay: 250,
      init: function ($els, config) {
        var standardSelectOptions = {
            minimumResultsForSearch: 1 / 0,
            width: "computedstyle",
          },
          swatchSelectOptions = {
            minimumResultsForSearch: 1 / 0,
            templateResult: theme.select2.swatchSelect2OptionTemplate,
            templateSelection: theme.select2.swatchSelect2OptionTemplate,
            width: "computedstyle",
          };
        typeof config < "u" &&
          ((standardSelectOptions = $.extend(standardSelectOptions, config)),
          (swatchSelectOptions = $.extend(swatchSelectOptions, config))),
          $els.not(".select2-hidden-accessible").each(function () {
            $(this).select2(
              $(this).data("colour-swatch")
                ? swatchSelectOptions
                : standardSelectOptions
            );
          });
      },
      destroyAllIn: function ($container) {
        theme.select2.destroy($("select[data-select2-id]", $container));
      },
      destroy: function ($els) {},
      swatchSelect2OptionTemplate: function (state) {
        if (state.id) {
          var colourKey = removeDiacritics(state.id)
            .toLowerCase()
            .replace(/'/g, "")
            .replace(/[^a-z0-9]+/g, "-")
            .replace(/-+/g, "-")
            .replace(/-*$/, "");
          return $(
            [
              '<div class="swatch-option">',
              '<span class="swatch-option__nugget bg-',
              colourKey,
              '"></span>',
              '<span class="swatch-option__label">',
              state.text,
              "</span>",
              "</div>",
            ].join("")
          );
        } else
          return $(
            [
              '<div class="swatch-option swatch-option--all">',
              '<span class="swatch-option__label">',
              state.text,
              "</span>",
              "</div>",
            ].join("")
          );
      },
    }),
    (theme.lazyBGSetWidths = [
      180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 1950, 2100, 2260, 2450,
      2700, 3e3, 3350, 3750, 4100,
    ]),
    (theme.loadLazyBGSet = function (container2) {
      $("[data-lazy-bgset-src]", container2).each(function () {
        for (
          var srcset = "",
            masterSrc = $(this).data("lazy-bgset-src"),
            aspectRatio = $(this).data("lazy-bgset-aspect-ratio"),
            masterWidth = $(this).data("lazy-bgset-width"),
            masterHeight = Math.round(masterWidth / aspectRatio),
            i = 0;
          i < theme.lazyBGSetWidths.length;
          i++
        ) {
          var thisWidth = theme.lazyBGSetWidths[i];
          masterWidth >= thisWidth &&
            (srcset += ""
              .concat(
                theme.Shopify.formatImage(masterSrc, thisWidth + "x"),
                " "
              )
              .concat(thisWidth, "w ")
              .concat(Math.round(thisWidth / aspectRatio), "h, "));
        }
        (srcset += ""
          .concat(masterSrc, " ")
          .concat(masterWidth, "w ")
          .concat(masterHeight, "h")),
          $(this)
            .attr("data-bgset", srcset)
            .removeClass("lazyload--manual")
            .addClass("lazyload");
      });
    }),
    (theme.applyAjaxToProductForm = function ($formContainer) {
      theme.settings.cart_type === "drawer" &&
        ($formContainer
          .filter('[data-ajax-add-to-cart="true"]')
          .find("form.product-purchase-form")
          .each(function () {
            var cartPopupTemplate = [
                '<div id="cart-summary-overlay" class="cart-summary-overlay">',
                '<div class="cart-summary-overlay__row-head">',
                '<div class="cart-summary-overlay__column-image">',
                '<div class="cart-summary-overlay__column-title">',
                theme.strings.products_added_notification_title,
                "</div>",
                "</div>",
                '<div class="cart-summary-overlay__column-item">',
                '<div class="cart-summary-overlay__column-title">',
                theme.strings.products_added_notification_item,
                "</div>",
                "</div>",
                '<div class="cart-summary-overlay__column-price-region">',
                '<div class="cart-summary-overlay__column-price">',
                '<div class="cart-summary-overlay__column-title">',
                theme.strings.products_added_notification_unit_price,
                "</div>",
                "</div>",
                '<div class="cart-summary-overlay__column-quantity">',
                '<div class="cart-summary-overlay__column-title">',
                theme.strings.products_added_notification_quantity,
                "</div>",
                "</div>",
                '<div class="cart-summary-overlay__column-total">',
                '<div class="cart-summary-overlay__column-title">',
                theme.strings.products_added_notification_total_price,
                "</div>",
                "</div>",
                "</div>",
                '<div class="cart-summary-overlay__column-subtotal">',
                '<div class="cart-summary-overlay__column-title">',
                theme.strings.products_added_notification_subtotal,
                "</div>",
                "</div>",
                "</div>",
                '<div class="cart-summary-overlay__row-body">',
                '<div class="cart-summary-overlay__column-image">',
                '<img src="[[image_url]]" alt="[[encoded-title]]" />',
                "</div>",
                '<div class="cart-summary-overlay__column-item">',
                '<div class="cart-summary-overlay__title">[[title]]</div>',
                '<div class="cart-summary-overlay__variants">[[variants]]</div>',
                '<div class="cart-summary-overlay__mobile-price-row">',
                '<div class="cart-summary-overlay__mobile-unit-price">[[unit_price]]</div>',
                '<div class="cart-summary-overlay__mobile-quantity">',
                theme.strings.products_added_notification_quantity,
                '<span class="cart-summary-overlay__quantity">[[quantity]]</span>',
                "</div>",
                '<div class="cart-summary-overlay__mobile-line-price">[[line_price]]</div>',
                "</div>",
                "</div>",
                '<div class="cart-summary-overlay__column-price-region">',
                '<div class="cart-summary-overlay__column-price">',
                '<span class="cart-summary-overlay__unit-price">[[unit_price]]</span>',
                "</div>",
                '<div class="cart-summary-overlay__column-quantity">',
                '<span class="cart-summary-overlay__quantity">[[quantity]]</span>',
                "</div>",
                '<div class="cart-summary-overlay__column-total">',
                '<div class="cart-summary-overlay__line-price">[[line_price]]</div>',
                "</div>",
                "[[line_discount]]",
                "</div>",
                '<div class="cart-summary-overlay__column-subtotal">',
                '<span class="cart-summary-overlay__subtotal">[[subtotal]]</span>',
                '<div class="cart-summary-overlay__note">',
                theme.strings.products_added_notification_shipping_note,
                "&nbsp;</div>",
                "</div>",
                "</div>",
                '<div class="cart-summary-overlay__actions">',
                '<a id="shop-more" class="button altcolour" href="#">',
                theme.strings.products_added_notification_keep_shopping,
                "</a>",
                '<a class="button to-cart" href="',
                theme.routes.cart_url,
                '">',
                theme.strings.products_added_notification_cart,
                "</a>",
                "</div>",
                "</div>",
              ].join(""),
              shopifyAjaxAddURL = theme.routes.cart_add_url + ".js",
              shopifyAjaxCartURL = theme.routes.cart_url + ".js";
            $(this).on("submit", function (evt) {
              evt.preventDefault();
              var $form = $(this);
              $form
                .find('button[type="submit"]')
                .attr("disabled", "disabled")
                .each(function () {
                  $(this).data("previous-value", $(this).val());
                })
                .val(theme.strings.products_product_adding_to_cart),
                $("#cart-summary-overlay #shop-more").triggerHandler("click"),
                $.post(
                  shopifyAjaxAddURL,
                  $form.serialize(),
                  function (itemData) {
                    document.documentElement.dispatchEvent(
                      new CustomEvent("theme:cartchanged", {
                        bubbles: !0,
                        cancelable: !1,
                      })
                    ),
                      $form
                        .find('button[type="submit"]')
                        .removeAttr("disabled")
                        .each(function () {
                          ($btn = $(this)),
                            $btn
                              .val(theme.strings.products_product_added_to_cart)
                              .addClass("inverted"),
                            window.setTimeout(function () {
                              $btn
                                .removeClass("inverted")
                                .val($btn.data("previous-value"));
                            }, 3e3);
                        });
                    var addedDataJSON = $.parseJSON(itemData);
                    $.get(
                      shopifyAjaxCartURL,
                      function (cartData) {
                        for (
                          var cartDataJSON = $.parseJSON(cartData),
                            addedQty = addedDataJSON.quantity,
                            addedImage = addedDataJSON.image,
                            productData =
                              theme.OptionManager.getProductData($form),
                            originalVariantPrice = addedDataJSON.original_price,
                            i = 0;
                          i < productData.variants.length;
                          i++
                        ) {
                          var variantData = productData.variants[i];
                          variantData.id == addedDataJSON.variant_id &&
                            variantData.compare_at_price &&
                            variantData.compare_at_price >
                              originalVariantPrice &&
                            (originalVariantPrice =
                              variantData.compare_at_price);
                        }
                        var variantHtml = "";
                        if (addedDataJSON.variant_title)
                          for (var i = 0; i < productData.options.length; i++)
                            variantHtml += [
                              '<div class="cart-summary-overlay__variant">',
                              '<span class="cart-summary-overlay__variant-option">',
                              productData.options[i].name,
                              "</span>",
                              '<span class="cart-summary-overlay__variant-value">',
                              addedDataJSON.variant_options[i],
                              "</span>",
                              "</div>",
                            ].join("");
                        addedDataJSON.selling_plan_allocation &&
                          addedDataJSON.selling_plan_allocation.selling_plan
                            .name &&
                          (variantHtml += [
                            '<div class="cart-summary-overlay__variant">',
                            '<span class="cart-summary-overlay__variant-value">',
                            addedDataJSON.selling_plan_allocation.selling_plan
                              .name,
                            "</span>",
                            "</div>",
                          ].join("")),
                          $form.data("show-preorder-label")
                            ? (variantHtml +=
                                '<div class="cart-summary-overlay__price-label price-label price-label--preorder">'.concat(
                                  theme.strings.products_product_preorder,
                                  "</div>"
                                ))
                            : $form.data("show-sale-price-label") &&
                              originalVariantPrice >
                                addedDataJSON.original_price &&
                              (variantHtml +=
                                '<div class="cart-summary-overlay__price-label price-label price-label--sale">'.concat(
                                  theme.strings.products_labels_sale,
                                  "</div>"
                                ));
                        var unitPriceHtml = "";
                        originalVariantPrice > addedDataJSON.final_price &&
                          (unitPriceHtml +=
                            '<div class="struck-out-price"><span class="theme-money">' +
                            theme.Shopify.formatMoney(
                              originalVariantPrice,
                              theme.money_format
                            ) +
                            "</span></div>"),
                          (unitPriceHtml +=
                            '<div><span class="theme-money">' +
                            theme.Shopify.formatMoney(
                              addedDataJSON.final_price,
                              theme.money_format
                            ) +
                            "</span></div>"),
                          (unitPriceHtml += theme.renderUnitPrice(
                            addedDataJSON.unit_price,
                            addedDataJSON.unit_price_measurement,
                            theme.money_format
                          ));
                        var linePriceHtml = "";
                        originalVariantPrice != addedDataJSON.final_price
                          ? ((linePriceHtml +=
                              '<div class="theme-money struck-out-price">' +
                              theme.Shopify.formatMoney(
                                originalVariantPrice * addedQty,
                                theme.money_format
                              ) +
                              "</div>"),
                            (linePriceHtml +=
                              '<div class="theme-money">' +
                              theme.Shopify.formatMoney(
                                addedDataJSON.final_line_price,
                                theme.money_format
                              ) +
                              "</div>"))
                          : (linePriceHtml +=
                              '<span class="theme-money">' +
                              theme.Shopify.formatMoney(
                                addedDataJSON.final_line_price,
                                theme.money_format
                              ) +
                              "</span>");
                        var lineDiscountHtml = "";
                        if (
                          addedDataJSON.line_level_discount_allocations &&
                          addedDataJSON.line_level_discount_allocations.length >
                            0
                        ) {
                          lineDiscountHtml += '<ul class="cart-discount-list">';
                          for (
                            var i = 0;
                            i <
                            addedDataJSON.line_level_discount_allocations
                              .length;
                            i++
                          ) {
                            var discount_allocation =
                              addedDataJSON.line_level_discount_allocations[i];
                            lineDiscountHtml += [
                              '<li class="cart-discount cart-discount--inline">',
                              '<span class="cart-discount__label">',
                              '<span class="cart-discount__icon">',
                              theme.icons.label,
                              "</span>",
                              '<span class="cart-discount__title">',
                              discount_allocation.discount_application.title,
                              "</span>",
                              "</span>",
                              '<span class="cart-discount__amount theme-money">',
                              theme.Shopify.formatMoney(
                                discount_allocation.amount,
                                theme.money_format
                              ),
                              "</span>",
                              "</li>",
                            ].join("");
                          }
                          lineDiscountHtml += "</ul>";
                        }
                        var subtotalHtml = "";
                        if (
                          cartDataJSON.cart_level_discount_applications &&
                          cartDataJSON.cart_level_discount_applications.length >
                            0
                        ) {
                          subtotalHtml += '<ul class="cart-discount-list">';
                          for (
                            var i = 0;
                            i <
                            cartDataJSON.cart_level_discount_applications
                              .length;
                            i++
                          ) {
                            var discount_application =
                              cartDataJSON.cart_level_discount_applications[i];
                            subtotalHtml += [
                              '<li class="cart-discount cart-discount--inline">',
                              '<span class="cart-discount__label">',
                              '<span class="cart-discount__icon">',
                              theme.icons.label,
                              "</span>",
                              '<span class="cart-discount__title">',
                              discount_application.title,
                              "</span>",
                              "</span>",
                              '<span class="cart-discount__amount theme-money">',
                              theme.Shopify.formatMoney(
                                discount_application.total_allocated_amount,
                                theme.money_format
                              ),
                              "</span>",
                              "</li>",
                            ].join("");
                          }
                          subtotalHtml += "</ul>";
                        }
                        (subtotalHtml +=
                          '<span class="cart-summary-overlay__subtotal-mobile-title">' +
                          theme.strings.products_added_notification_subtotal +
                          ":</span> "),
                          (subtotalHtml +=
                            '<span class="cart-summary-overlay__subtotal-amount theme-money">' +
                            theme.Shopify.formatMoney(
                              cartDataJSON.total_price,
                              theme.money_format
                            ) +
                            "</span>");
                        var cartShadeHTML = cartPopupTemplate;
                        (cartShadeHTML = cartShadeHTML.replace(
                          "[[title]]",
                          addedDataJSON.product_title
                        )),
                          (cartShadeHTML = cartShadeHTML.replace(
                            "[[encoded-title]]",
                            addedDataJSON.product_title
                              .replace(/"/g, "&quot;")
                              .replace(/&/g, "&amp;")
                          )),
                          (cartShadeHTML = cartShadeHTML.replace(
                            "[[variants]]",
                            variantHtml
                          )),
                          (cartShadeHTML = cartShadeHTML.replace(
                            /\[\[quantity\]\]/g,
                            addedQty
                          )),
                          (cartShadeHTML = cartShadeHTML.replace(
                            "[[image_url]]",
                            theme.Shopify.formatImage(addedImage, "170x")
                          )),
                          (cartShadeHTML = cartShadeHTML
                            .split("[[unit_price]]")
                            .join(unitPriceHtml)),
                          (cartShadeHTML = cartShadeHTML
                            .split("[[line_price]]")
                            .join(linePriceHtml)),
                          (cartShadeHTML = cartShadeHTML
                            .split("[[line_discount]]")
                            .join(lineDiscountHtml)),
                          (cartShadeHTML = cartShadeHTML.replace(
                            "[[subtotal]]",
                            subtotalHtml
                          ));
                        var $cartShade = $(cartShadeHTML);
                        $cartShade
                          .find("#shop-more")
                          .bind("click", function () {
                            return (
                              $cartShade.animate(
                                { top: -$cartShade.outerHeight() },
                                500,
                                function () {
                                  $(this).remove();
                                }
                              ),
                              !1
                            );
                          }),
                          $cartShade
                            .prependTo("body")
                            .css("top", -$cartShade.outerHeight())
                            .animate({ top: 0 }, 500);
                      },
                      "html"
                    );
                  },
                  "text"
                ).fail(function (data) {
                  if (
                    ($form
                      .find('button[type="submit"]')
                      .removeAttr("disabled")
                      .each(function () {
                        $(this).val($(this).data("previous-value"));
                      }),
                    typeof data < "u" && typeof data.status < "u")
                  ) {
                    var jsonRes = $.parseJSON(data.responseText);
                    theme.showQuickPopup(
                      jsonRes.description,
                      $form.find('button[type="submit"]:first')
                    );
                  } else $form.attr("ajax-add-to-cart", "false").submit();
                });
            });
          }),
        $(window)
          .off(".ajaxAddScroll")
          .on("scroll.ajaxAddScroll", function () {
            $("#cart-summary-overlay #shop-more").triggerHandler("click");
          }));
    }),
    (theme.removeAjaxFromProductForm = function ($formContainer) {
      $formContainer.find("form.product-purchase-form").off("submit");
    }),
    (theme.buildGalleryViewer = function (config) {
      for (
        var $allContainer = $(
            '<div class="gallery-viewer gallery-viewer--pre-reveal">'
          ),
          $zoomContainer = $(
            '<div class="gallery-viewer__zoom-container">'
          ).appendTo($allContainer),
          $thumbContainer = $('<div class="gallery-viewer__thumbs">').appendTo(
            $allContainer
          ),
          $controlsContainer = $(
            '<div class="gallery-viewer__controls">'
          ).appendTo($allContainer),
          $close = $(
            '<a class="gallery-viewer__button gallery-viewer__close" href="#">'
          )
            .html(config.close)
            .appendTo($controlsContainer),
          $right = $(
            '<a class="gallery-viewer__button gallery-viewer__prev" href="#">'
          )
            .html(config.prev)
            .appendTo($controlsContainer),
          $left = $(
            '<a class="gallery-viewer__button gallery-viewer__next" href="#">'
          )
            .html(config.next)
            .appendTo($controlsContainer),
          $currentZoomImage = null,
          wheelZoomMultiplier = -0.001,
          pinchZoomMultiplier = 0.003,
          touchPanModifier = 1,
          currentTransform = { panX: 0, panY: 0, zoom: 1 },
          i = 0;
        i < config.images.length;
        i++
      ) {
        var img = config.images[i];
        $('<a class="gallery-viewer__thumb" href="#">')
          .data("zoom-url", img.zoomUrl)
          .html(img.thumbTag)
          .appendTo($thumbContainer);
      }
      config.images.length === 1 &&
        $allContainer.addClass("gallery-viewer--single-image");
      var panZoomImageFromCoordinate = function (inputX, inputY) {
          var doPanX = $currentZoomImage.width() > $allContainer.width(),
            doPanY = $currentZoomImage.height() > $allContainer.height();
          if (doPanX || doPanY) {
            var midX = $allContainer.width() / 2,
              midY = $allContainer.height() / 2,
              offsetFromCentreX = inputX - midX,
              offsetFromCentreY = inputY - midY,
              finalOffsetX = 0,
              finalOffsetY = 0;
            if (doPanX) {
              var offsetMultiplierX =
                ($currentZoomImage.width() - $allContainer.width()) / 2 / midX;
              finalOffsetX = Math.round(-offsetFromCentreX * offsetMultiplierX);
            }
            if (doPanY) {
              var offsetMultiplierY =
                ($currentZoomImage.height() - $allContainer.height()) /
                2 /
                midY;
              finalOffsetY = Math.round(-offsetFromCentreY * offsetMultiplierY);
            }
            (currentTransform.panX = finalOffsetX),
              (currentTransform.panY = finalOffsetY),
              alterCurrentPanBy(0, 0),
              updateImagePosition();
          }
        },
        alterCurrentPanBy = function (x2, y) {
          currentTransform.panX += x2;
          var panXMax =
            ($currentZoomImage[0].naturalWidth * currentTransform.zoom -
              $allContainer.width()) /
            2;
          (panXMax = Math.max(panXMax, 0)),
            (currentTransform.panX = Math.min(currentTransform.panX, panXMax)),
            (currentTransform.panX = Math.max(currentTransform.panX, -panXMax)),
            (currentTransform.panY += y);
          var panYMax =
            ($currentZoomImage[0].naturalHeight * currentTransform.zoom -
              $allContainer.height()) /
            2;
          (panYMax = Math.max(panYMax, 0)),
            (currentTransform.panY = Math.min(currentTransform.panY, panYMax)),
            (currentTransform.panY = Math.max(currentTransform.panY, -panYMax)),
            updateImagePosition();
        },
        setCurrentTransform = function (panX, panY, zoom) {
          (currentTransform.panX = panX),
            (currentTransform.panY = panY),
            (currentTransform.zoom = zoom),
            alterCurrentTransformZoomBy(0);
        },
        alterCurrentTransformZoomBy = function (delta) {
          (currentTransform.zoom += delta),
            (currentTransform.zoom = Math.min(currentTransform.zoom, 1));
          var maxZoomX =
              $allContainer.width() / $currentZoomImage[0].naturalWidth,
            maxZoomY =
              $allContainer.height() / $currentZoomImage[0].naturalHeight;
          (currentTransform.zoom = Math.max(
            currentTransform.zoom,
            Math.min(maxZoomX, maxZoomY)
          )),
            alterCurrentPanBy(0, 0),
            updateImagePosition();
        },
        updateImagePosition = function () {
          $currentZoomImage.css(
            "transform",
            "translate3d("
              .concat(currentTransform.panX, "px, ")
              .concat(currentTransform.panY, "px, 0) scale(")
              .concat(currentTransform.zoom, ")")
          );
        };
      $allContainer.on(
        "click.galleryViewer select.galleryViewer",
        ".gallery-viewer__thumb",
        function (evt) {
          evt.preventDefault(),
            $(this)
              .addClass("gallery-viewer__thumb--active")
              .siblings(".gallery-viewer__thumb--active")
              .removeClass("gallery-viewer__thumb--active"),
            ($currentZoomImage = $(
              '<img class="gallery-viewer__zoom-image" alt="" style="visibility: hidden">'
            )),
            $currentZoomImage
              .on("load", function () {
                $(this).off("load"),
                  $(this).css({
                    visibility: "",
                    top: $allContainer.height() / 2 - $(this).height() / 2,
                    left: $allContainer.width() / 2 - $(this).width() / 2,
                  }),
                  setCurrentTransform(0, 0, 1);
              })
              .attr("src", $(this).data("zoom-url")),
            $zoomContainer.html($currentZoomImage);
        }
      );
      var pinchTracking = { isTracking: !1, lastPinchDistance: 0 },
        touchTracking = { isTracking: !1, lastTouchX: 0, lastTouchY: 0 };
      $allContainer.on("touchend.galleryViewer", function (evt) {
        (pinchTracking.isTracking = !1), (touchTracking.isTracking = !1);
      }),
        $allContainer.on(
          "mousemove.galleryViewer touchmove.galleryViewer",
          function (evt) {
            if (
              (evt.preventDefault(),
              evt.type === "touchmove" && evt.touches.length > 0)
            ) {
              var touch1 = evt.touches[0];
              if (
                (touchTracking.isTracking
                  ? (alterCurrentPanBy(
                      (touch1.clientX - touchTracking.lastTouchX) *
                        touchPanModifier,
                      (touch1.clientY - touchTracking.lastTouchY) *
                        touchPanModifier
                    ),
                    (touchTracking.lastTouchX = touch1.clientX),
                    (touchTracking.lastTouchY = touch1.clientY))
                  : ((touchTracking.isTracking = !0),
                    (touchTracking.lastTouchX = touch1.clientX),
                    (touchTracking.lastTouchY = touch1.clientY)),
                evt.touches.length === 2)
              ) {
                var touch2 = evt.touches[1],
                  pinchDistance = Math.sqrt(
                    Math.pow(touch1.clientX - touch2.clientX, 2) +
                      Math.pow(touch1.clientY - touch2.clientY, 2)
                  );
                if (!pinchTracking.isTracking)
                  (pinchTracking.lastPinchDistance = pinchDistance),
                    (pinchTracking.isTracking = !0);
                else {
                  var pinchDelta =
                    pinchDistance - pinchTracking.lastPinchDistance;
                  alterCurrentTransformZoomBy(pinchDelta * pinchZoomMultiplier),
                    (pinchTracking.lastPinchDistance = pinchDistance);
                }
              } else pinchTracking.isTracking = !1;
            } else panZoomImageFromCoordinate(evt.clientX, evt.clientY);
          }
        ),
        $allContainer.on("wheel.galleryViewer", function (evt) {
          evt.preventDefault(),
            evt.originalEvent.deltaY != 0 &&
              alterCurrentTransformZoomBy(
                evt.originalEvent.deltaY * wheelZoomMultiplier
              );
        }),
        $allContainer.on(
          "touchmove.galleryViewer",
          ".gallery-viewer__thumbs",
          function (evt) {
            evt.stopPropagation();
          }
        ),
        $allContainer.on(
          "click.galleryViewer",
          ".gallery-viewer__next",
          function (evt) {
            evt.preventDefault();
            var $next = $thumbContainer
              .find(".gallery-viewer__thumb--active")
              .next();
            $next.length === 0 &&
              ($next = $thumbContainer.find(".gallery-viewer__thumb:first")),
              $next.trigger("select");
          }
        ),
        $allContainer.on(
          "click.galleryViewer",
          ".gallery-viewer__prev",
          function (evt) {
            evt.preventDefault();
            var $prev = $thumbContainer
              .find(".gallery-viewer__thumb--active")
              .prev();
            $prev.length === 0 &&
              ($prev = $thumbContainer.find(".gallery-viewer__thumb:last")),
              $prev.trigger("select");
          }
        ),
        $allContainer.on(
          "click.galleryViewer",
          ".gallery-viewer__close",
          function (evt) {
            evt.preventDefault(),
              $allContainer.off(".galleryViewer"),
              $allContainer.addClass("gallery-viewer--transition-out");
            var transitionDelay = $allContainer.css("transition-duration");
            (transitionDelay =
              transitionDelay.indexOf("ms") > -1
                ? parseFloat(transitionDelay)
                : parseFloat(transitionDelay) * 1e3),
              setTimeout(function () {
                $allContainer.remove(),
                  $("html").removeClass("gallery-viewer-open");
              }, transitionDelay);
          }
        ),
        $allContainer.on(
          "click.galleryViewer",
          ".gallery-viewer__zoom-container",
          function (evt) {
            evt.preventDefault(),
              currentTransform.zoom == 1
                ? ((currentTransform.zoom = 0), alterCurrentTransformZoomBy(0))
                : ((currentTransform.zoom = 1), alterCurrentTransformZoomBy(0));
          }
        ),
        $("html").removeClass("gallery-viewer-open"),
        $(".gallery-viewer").remove(),
        $("html").addClass("gallery-viewer-open"),
        $allContainer.appendTo("body"),
        $thumbContainer
          .find(
            ".gallery-viewer__thumb:eq(" +
              (config.current > 0 ? config.current : 0) +
              ")"
          )
          .trigger("select")
          .focus(),
        setTimeout(function () {
          $allContainer.removeClass("gallery-viewer--pre-reveal");
        }, 10);
    }),
    (theme.Navigation = {
      init: function (options) {
        if (options.nav.length != 0) {
          var $nav = options.nav,
            navHoverDelay = 250,
            $navLastOpenDropdown = $(),
            navOpenTimeoutId = -1,
            $mobileDrawer = $('<div class="mobile-navigation-drawer">');
          $mobileDrawer.append($nav.clone());
          var $mobileDrawerFooter = $(
            '<div class="mobile-navigation-drawer__footer">'
          ).appendTo($mobileDrawer);
          $mobileDrawerFooter.append(
            $(".announcement-bar .inline-menu")
              .clone()
              .removeClass("desktop-only")
          ),
            $mobileDrawerFooter.append(
              $(".announcement-bar .header-disclosures")
                .clone()
                .removeClass("desktop-only")
            ),
            $mobileDrawerFooter.append(
              $(".announcement-bar .social-links")
                .clone()
                .removeClass("desktop-only")
            ),
            theme.suffixIds($mobileDrawer[0], "mob"),
            $mobileDrawer.insertAfter($("#shopify-section-header")),
            $mobileDrawer.on(
              "click",
              ".navigation__tier-1 > .navigation__item > .navigation__children-toggle",
              function (evt) {
                evt.preventDefault(),
                  $(this)
                    .siblings(".navigation__tier-2-container")
                    .css({
                      top:
                        Math.ceil(
                          $(".navigation__mobile-header:last").height() + 1
                        ) + "px",
                    }),
                  $(this)
                    .parent()
                    .addClass("navigation__item--open")
                    .closest(".mobile-navigation-drawer")
                    .addClass("mobile-navigation-drawer--child-open")
                    .find(".mobile-nav-title")
                    .text($(this).siblings(".navigation__link").text());
              }
            ),
            $nav.data("mobile-expand-with-entire-link") &&
              $mobileDrawer.on(
                "click",
                ".navigation__item--with-children > .navigation__link",
                function (evt) {
                  evt.preventDefault(),
                    $(this)
                      .siblings(".navigation__children-toggle")
                      .trigger("click");
                }
              ),
            $mobileDrawer.on("click", ".mobile-nav-back", function (evt) {
              evt.preventDefault(),
                $(this)
                  .closest(".mobile-navigation-drawer")
                  .removeClass("mobile-navigation-drawer--child-open")
                  .find(".navigation__tier-1 > .navigation__item--open")
                  .removeClass("navigation__item--open");
            }),
            $mobileDrawer.on(
              "click",
              ".navigation__tier-2 > .navigation__item > .navigation__children-toggle",
              function (evt) {
                evt.preventDefault();
                var doOpen = !$(this)
                  .parent()
                  .hasClass("navigation__item--open");
                if (doOpen) {
                  $(this).parent().addClass("navigation__item--open");
                  var $childContainer = $(this).siblings(
                    ".navigation__tier-3-container"
                  );
                  $childContainer.css(
                    "height",
                    $childContainer.children().outerHeight()
                  );
                } else
                  $(this).parent().removeClass("navigation__item--open"),
                    $(this)
                      .siblings(".navigation__tier-3-container")
                      .css("height", "");
              }
            ),
            $nav.on(
              "mouseenter mouseleave",
              ".navigation__tier-1 > .navigation__item--with-children",
              function (evt) {
                var $dropdownContainer = $(this);
                if (evt.type == "mouseenter") {
                  clearTimeout(navOpenTimeoutId),
                    clearTimeout($dropdownContainer.data("navCloseTimeoutId"));
                  var $openSiblings = $dropdownContainer.siblings(
                    ".navigation__item--show-children"
                  );
                  $openSiblings
                    .not($navLastOpenDropdown)
                    .removeClass("navigation__item--show-children"),
                    ($navLastOpenDropdown = $dropdownContainer);
                  var timeoutDelay =
                      $openSiblings.length == 0 ? 0 : navHoverDelay,
                    newNavOpenTimeoutId = setTimeout(function () {
                      $dropdownContainer
                        .addClass("navigation__item--show-children")
                        .siblings(".navigation__item--show-children")
                        .removeClass("navigation__item--show-children");
                    }, timeoutDelay);
                  (navOpenTimeoutId = newNavOpenTimeoutId),
                    $dropdownContainer.data(
                      "navOpenTimeoutId",
                      newNavOpenTimeoutId
                    );
                } else
                  clearTimeout($dropdownContainer.data("navOpenTimeoutId")),
                    $dropdownContainer.data(
                      "navCloseTimeoutId",
                      setTimeout(function () {
                        $dropdownContainer.removeClass(
                          "navigation__item--show-children"
                        );
                      }, navHoverDelay)
                    );
                $dropdownContainer
                  .children("[aria-expanded]")
                  .attr("aria-expanded", evt.type == "mouseenter");
              }
            );
          var touchHandler = function (evt) {
            if ($(window).width() > 767) {
              if (evt.type == "touchstart")
                $(this).data("touchstartedAt", evt.timeStamp);
              else if (evt.type == "touchend") {
                if (evt.timeStamp - $(this).data("touchstartedAt") < 1e3)
                  return (
                    $(this).data("touchOpenTriggeredAt", evt.timeStamp),
                    $(this).parent().hasClass("navigation__item--show-children")
                      ? $(this).parent().trigger("mouseleave")
                      : ($(
                          ".navigation:first .navigation__item--show-children"
                        ).trigger("mouseleave"),
                        $(this).parent().trigger("mouseenter")),
                    !1
                  );
              } else if (
                evt.type == "click" &&
                $(this).data("touchOpenTriggeredAt") &&
                evt.timeStamp - $(this).data("touchOpenTriggeredAt") < 1e3
              )
                return !1;
            }
          };
          $nav.on(
            "touchstart touchend click",
            ".navigation__tier-1 > .navigation__item--with-children > .navigation__link",
            touchHandler
          );
          var keydownHandler = function (evt) {
            if (evt.which == 13) {
              var $parent = $(this).parent();
              return (
                $parent.trigger(
                  $parent.hasClass("navigation__item--show-children")
                    ? "mouseleave"
                    : "mouseenter"
                ),
                !1
              );
            }
          };
          $nav.on(
            "keydown",
            ".navigation__tier-1 > .navigation__item--with-children > .navigation__children-toggle",
            keydownHandler
          ),
            options.proxyTier1Nav &&
              $(options.proxyTier1Nav)
                .on(
                  "mouseenter mouseleave",
                  ".navigation__tier-1 > .navigation__item--with-children",
                  function (evt) {
                    $(
                      $(".navigation__tier-1 > .navigation__item", $nav)[
                        $(this).index()
                      ]
                    ).trigger(evt.type);
                  }
                )
                .on(
                  "touchstart touchend click",
                  ".navigation__tier-1 > .navigation__item--with-children > .navigation__link",
                  function (evt) {
                    var response = touchHandler.bind(
                      $(
                        $(".navigation__tier-1 > .navigation__item", $nav)[
                          $(this).parent().index()
                        ]
                      ).children(".navigation__link")[0]
                    )(evt);
                    if (response === !1) return !1;
                  }
                )
                .on(
                  "keydown",
                  ".navigation__tier-1 > .navigation__item--with-children > .navigation__children-toggle",
                  function (evt) {
                    if (evt.which == 13)
                      return (
                        keydownHandler.bind(
                          $(
                            $(".navigation__tier-1 > .navigation__item", $nav)[
                              $(this).parent().index()
                            ]
                          ).children(".navigation__children-toggle")[0]
                        )(evt),
                        !1
                      );
                  }
                ),
            $nav.on(
              "click",
              '.navigation__link[href="#"][aria-haspopup="true"]',
              function () {
                return (
                  $(this)
                    .siblings(".navigation__children-toggle")
                    .trigger("click"),
                  !1
                );
              }
            );
        }
      },
      destroy: function ($nav, $proxyTier1Nav) {
        $nav
          .add($proxyTier1Nav)
          .off("click mouseenter mouseleave touchstart touchend keydown"),
          theme.ProductBlockManager.unloadImages(
            $(".mobile-navigation-drawer .product-list")
          ),
          $(".mobile-navigation-drawer").off("click").remove();
      },
    }),
    (theme.ProductBlockManager = new (function () {
      var _ = this;
      (_.isDesktop = function () {
        return $(window).width() >= 768;
      }),
        (_.loadImages = function (container2) {
          var container2 = container2;
          typeof container2 > "u" && (container2 = $("body")),
            theme.loadLazyBGSet(container2),
            _.isDesktop() &&
              (setTimeout(function () {
                $(
                  ".product-block__image--show-on-hover.product-block__image--inactivated",
                  container2
                ).each(function () {
                  _.lazyloadImage($(this)),
                    lazySizes.loader.unveil($(this).find(".lazyload")[0]);
                });
              }, 250),
              setTimeout(function () {
                $(
                  ".product-block__image--show-on-hover + .product-block__image--inactivated",
                  container2
                ).each(function () {
                  _.lazyloadImage($(this));
                });
              }, 1e3)),
            _.monitorImagePagination(container2),
            _.monitorSwatchSelection(container2),
            _.afterImagesResized(container2);
        }),
        (_.unloadImages = function (container2) {
          $(container2).off(".productBlockManager");
        }),
        (_.getImageAt = function ($images, index) {
          return $images[
            ((index % $images.length) + $images.length) % $images.length
          ];
        }),
        (_.lazyloadImage = function ($image, onLoadCB) {
          var _this12 = this,
            $toLoad = $image.filter(".product-block__image--inactivated");
          $toLoad.length
            ? (onLoadCB &&
                $toLoad.on("lazyloaded.themeBlockManager", function (evt) {
                  evt.target === $toLoad.find(".lazyloaded")[0] && onLoadCB(),
                    $(_this12).off("lazyloaded.themeBlockManager");
                }),
              $toLoad.removeClass("product-block__image--inactivated"))
            : onLoadCB && onLoadCB();
        }),
        (_.incrementActiveImage = function ($images, increment) {
          var index = Math.max(
            $images.filter(".product-block__image--active:first").index(),
            0
          );
          _.setActiveImage($images, index + increment);
        }),
        (_.setActiveImage = function ($images, index) {
          var $newActive = $(_.getImageAt($images, index));
          _.lazyloadImage($newActive, function () {
            $newActive.addClass("product-block__image--active"),
              $newActive.siblings().removeClass("product-block__image--active");
            var $hoverImage = $(_.getImageAt($images, index + 1)).addClass(
              "product-block__image--show-on-hover"
            );
            $hoverImage
              .siblings()
              .removeClass("product-block__image--show-on-hover"),
              _.lazyloadImage($hoverImage);
          });
          var $dots = $images
            .closest(".image-cont")
            .find(".product-block__image-dot");
          $dots
            .removeClass("product-block__image-dot--active")
            .eq($newActive.index())
            .addClass("product-block__image-dot--active");
        }),
        (_.monitorImagePagination = function (container2) {
          $(".image-cont--with-secondary-image", container2).length &&
            ($(container2).on(
              "click.productBlockManager",
              ".image-page-button",
              function (evt) {
                var $images = $(this)
                  .closest(".product-block")
                  .find(".product-block__image");
                return (
                  _.incrementActiveImage(
                    $images,
                    $(evt.currentTarget).hasClass("image-page-button--next")
                      ? 1
                      : -1
                  ),
                  $images.each(function () {
                    _.lazyloadImage($(this));
                  }),
                  !1
                );
              }
            ),
            $(".image-cont--with-secondary-image:first", container2).closest(
              ".carousel, .product-list--scrollarea"
            ).length === 0 &&
              ($(container2).on("imageSwiped", ".product-block", function () {
                $(".product-block__image--inactivated", this).length &&
                  setTimeout(
                    function () {
                      $(this)
                        .find(".product-block__image")
                        .each(function () {
                          _.lazyloadImage($(this));
                        });
                    }.bind(this),
                    500
                  );
              }),
              $(container2).on(
                "touchstart.productBlockManager",
                ".image-cont--with-secondary-image",
                function (evt) {
                  (theme.productBlockTouchTracking = !0),
                    (theme.productBlockTouchStartX = evt.touches[0].clientX),
                    (theme.productBlockTouchStartY = evt.touches[0].clientY);
                  var nextImage = evt.currentTarget.querySelector(
                    ".product-block__image--active + .product-block__image--inactivated"
                  );
                  nextImage && _.lazyloadImage($(nextImage));
                }
              ),
              $(container2).on(
                "touchmove.productBlockManager",
                ".image-cont--with-secondary-image",
                function (evt) {
                  if (
                    theme.productBlockTouchTracking &&
                    Math.abs(
                      evt.touches[0].clientY - theme.productBlockTouchStartY
                    ) < 30
                  ) {
                    var deltaX =
                      evt.touches[0].clientX - theme.productBlockTouchStartX;
                    if (deltaX > 25) {
                      var $images = $(this)
                        .closest(".product-block")
                        .trigger("imageSwiped")
                        .find(".product-block__image");
                      _.incrementActiveImage($images, -1),
                        (theme.productBlockTouchTracking = !1);
                    } else if (deltaX < -25) {
                      var $images = $(this)
                        .closest(".product-block")
                        .trigger("imageSwiped")
                        .find(".product-block__image");
                      _.incrementActiveImage($images, 1),
                        (theme.productBlockTouchTracking = !1);
                    }
                  }
                }
              ),
              $(container2).on(
                "touchend.productBlockManager",
                ".image-cont--with-secondary-image",
                function (evt) {
                  theme.productBlockTouchTracking = !1;
                }
              )));
        }),
        (_.monitorSwatchSelection = function (container2) {
          $("[data-media].product-block-options__item", container2).length &&
            $(container2).on(
              "mouseenter.productBlockManager click.productBlockManager",
              "[data-media].product-block-options__item",
              function () {
                var $images = $(this)
                    .closest(".product-block")
                    .find(".product-block__image"),
                  index = $images
                    .filter(
                      '[data-media-id="' +
                        $(this).data("media") +
                        '"].product-block__image'
                    )
                    .index();
                _.setActiveImage($images, index);
              }
            );
        }),
        (_.afterImagesResized = function (container2) {
          var container2 = container2;
          typeof container2 > "u" && (container2 = $("body")),
            _.alignProductBlockHeights(container2);
        }),
        (_.alignProductBlockHeights = function (container2) {
          var container2 = container2;
          typeof container2 > "u" && (container2 = $("body")),
            $(".collection-listing .product-list", container2).each(
              function () {
                if (
                  $(window).width() >= 768 ||
                  $(this).closest(".carousel").length > 0
                ) {
                  var tallest = 0;
                  $(this)
                    .find(".product-block .block-inner .block-inner-inner")
                    .each(function () {
                      $(this).height() > tallest &&
                        (tallest = $(this).height());
                    }),
                    $(this)
                      .find(".product-block .block-inner")
                      .css("min-height", tallest);
                } else
                  $(this)
                    .find(".product-block .block-inner")
                    .css("min-height", "");
              }
            );
        });
    })()),
    (theme.initProductGallery = function (container2) {
      var $gallery = $(".gallery", container2);
      if (!$gallery.hasClass("gallery-initialised")) {
        $gallery.addClass("gallery-initialised"),
          $(".product-slideshow", container2).each(function () {
            var $slideshow = $(this)
              .on("init", function (evt, slick) {
                $(".lazyload--manual", this)
                  .removeClass("lazyload--manual")
                  .addClass("lazyload");
              })
              .on("beforeChange", function (evt, slick, current, next) {
                $(
                  $(this).closest(".gallery").find(".thumbnails a")[next]
                ).trigger("selectFromSlick");
              })
              .slick({
                autoplay: !1,
                fade: !0,
                infinite: !1,
                useTransform: !0,
                dots: !1,
                arrows: !0,
                appendArrows: $(this)
                  .siblings(".slideshow-controls")
                  .find(".slideshow-controls__arrows"),
                prevArrow:
                  '<button type="button" class="slick-product-prev" aria-label="' +
                  theme.strings.previous +
                  '">' +
                  theme.icons.chevronLeft +
                  "</button>",
                nextArrow:
                  '<button type="button" class="slick-product-next" aria-label="' +
                  theme.strings.next +
                  '">' +
                  theme.icons.chevronRight +
                  "</button>",
                responsive: [
                  { breakpoint: 768, settings: { fade: !1, arrows: !1 } },
                ],
              });
            theme.ProductMedia.init($gallery, {
              onPlyrInit: function (playerObj2) {
                theme.productGallerySlideshowTabFix(
                  $slideshow.slick("getSlick").$slides,
                  $slideshow.slick("getSlick").currentSlide
                );
              },
              onYoutubeInit: function (playerObj2) {
                theme.productGallerySlideshowTabFix(
                  $slideshow.slick("getSlick").$slides,
                  $slideshow.slick("getSlick").currentSlide
                );
              },
              onModelViewerInit: function (element) {
                theme.productGallerySlideshowTabFix(
                  $slideshow.slick("getSlick").$slides,
                  $slideshow.slick("getSlick").currentSlide
                );
              },
              onVideoVisible: function (e) {
                $(window).width() >= 768 &&
                  $(e.target)
                    .closest(".slick-slider")
                    .slick("slickSetOption", "swipe", !1);
              },
              onVideoHidden: function (e) {
                $(window).width() >= 768 &&
                  $(e.target)
                    .closest(".slick-slider")
                    .slick("slickSetOption", "swipe", !0);
              },
              onPlyrPlay: function (e) {
                $(e.target)
                  .closest(".slick-slider")
                  .slick("slickSetOption", "swipe", !1);
              },
              onPlyrPause: function (e) {
                $(e.target)
                  .closest(".slick-slider")
                  .slick("slickSetOption", "swipe", !0);
              },
              onModelViewerPlay: function (e) {
                $(e.target)
                  .closest(".slick-slider")
                  .slick("slickSetOption", "swipe", !1),
                  $(e.target)
                    .closest(".slick-slider")
                    .slick("slickSetOption", "accessibility", !1);
              },
              onModelViewerPause: function (e) {
                $(e.target)
                  .closest(".slick-slider")
                  .slick("slickSetOption", "swipe", !0),
                  $(e.target)
                    .closest(".slick-slider")
                    .slick("slickSetOption", "accessibility", !0);
              },
            }),
              theme.productGallerySlideshowTabFix(
                $slideshow.slick("getSlick").$slides,
                $slideshow.slick("getSlick").currentSlide
              ),
              $slideshow.on("afterChange", function (evt, slick, current) {
                $(".product-media--activated")
                  .removeClass("product-media--activated")
                  .trigger("mediaHidden"),
                  $(".product-media", slick.$slides[current])
                    .addClass("product-media--activated")
                    .trigger("mediaVisible"),
                  theme.productGallerySlideshowTabFix(slick.$slides, current),
                  $(this).closest(".quickbuy-container").trigger("changedsize");
              }),
              $(container2).closest(".collection-listing").length > 0 &&
                $slideshow.on("afterChange", function () {
                  $(this).closest(".quickbuy-container").trigger("changedsize");
                });
          });
        var $thumbnails = $(".thumbnails", container2);
        if ($thumbnails.length) {
          var carouselVisibleItemCount = 6,
            isCarousel = !1,
            assessCarousel = function () {
              $thumbnails.parent().css("display") == "flex"
                ? isCarousel &&
                  ((isCarousel = !1),
                  theme.beforeCarouselUnloadEventBlockFix($thumbnails),
                  $thumbnails
                    .removeClass("owl-carousel")
                    .data("owl.carousel")
                    .destroy())
                : isCarousel ||
                  ((isCarousel = !0),
                  theme.beforeCarouselLoadEventBlockFix($thumbnails),
                  $thumbnails
                    .addClass("owl-carousel")
                    .on("initialized.owl.carousel", function () {
                      $(".lazyload--manual", this)
                        .removeClass("lazyload--manual")
                        .addClass("lazyload");
                    })
                    .owlCarousel({
                      items: carouselVisibleItemCount,
                      dots: !1,
                      margin: 7,
                    }));
            };
          $(window).on("debouncedresize.productGallery", assessCarousel),
            assessCarousel(),
            $(container2).data("assessCarouselCallback", assessCarousel),
            $(".gallery", container2).on(
              "click select selectFromSlick",
              ".thumbnails.owl-carousel a",
              function (e) {
                e.preventDefault();
                var $carouselItem = $(this).parent();
                if (e.type != "selectFromSlick")
                  $(this)
                    .closest(".gallery")
                    .find(".slideshow")
                    .slick("slickGoTo", $carouselItem.index());
                else {
                  $(this)
                    .addClass("selected")
                    .parent()
                    .siblings()
                    .find("a")
                    .removeClass("selected");
                  var shelfStart = $carouselItem
                      .parent()
                      .children(".active:first")
                      .index(),
                    shelfEnd = shelfStart + carouselVisibleItemCount - 1,
                    currentIndex = $carouselItem.index();
                  currentIndex < shelfStart
                    ? $carouselItem
                        .closest(".owl-carousel")
                        .trigger("to.owl.carousel", currentIndex)
                    : currentIndex > shelfEnd &&
                      $carouselItem
                        .closest(".owl-carousel")
                        .trigger(
                          "to.owl.carousel",
                          Math.max(
                            0,
                            currentIndex - carouselVisibleItemCount + 1
                          )
                        );
                }
              }
            ),
            $(".gallery", container2).on(
              "click select selectFromSlick",
              " .thumbnails:not(.owl-carousel) a",
              function (e) {
                e.preventDefault(),
                  e.type != "selectFromSlick"
                    ? $(this)
                        .closest(".gallery")
                        .find(".slideshow")
                        .slick("slickGoTo", $(this).index())
                    : $(this)
                        .addClass("selected")
                        .siblings(".selected")
                        .removeClass("selected");
              }
            );
        }
      }
    }),
    (theme.destroyProductGallery = function (container2) {
      $(window).off(".productGallery");
      var $gallery = $(".gallery", container2).off(
        "click select selectFromSlick"
      );
      theme.ProductMedia.destroy($gallery),
        $(".slick-slider", container2)
          .slick("unslick")
          .off("init beforeChange afterChange"),
        $(".owl-carousel", container2).each(function () {
          theme.beforeCarouselUnloadEventBlockFix(this),
            $(this).data("owl.carousel").destroy();
        });
    }),
    (theme.ProductMedia = new (function () {
      var _ = this;
      (_._setupShopifyXr = function () {
        if (!window.ShopifyXR) {
          document.addEventListener(
            "shopify_xr_initialized",
            _._setupShopifyXr.bind(this)
          );
          return;
        }
        window.ShopifyXR.addModels(JSON.parse($(this).html())),
          window.ShopifyXR.setupXRElements();
      }),
        (this.init = function (container2, callbacks) {
          var callbacks = callbacks || {},
            _container = container2;
          $(container2)
            .find(".product-media--video")
            .each(function (index) {
              var enableLooping = $(this).data("enable-video-looping"),
                element = $(this).find("iframe, video")[0];
              if (element.tagName === "VIDEO")
                window.Shopify.loadFeatures([
                  {
                    name: "video-ui",
                    version: "1.0",
                    onLoad: function () {
                      var playerObj2 = { playerType: "html5", element };
                      (playerObj2.play = function () {
                        this.plyr.play();
                      }.bind(playerObj2)),
                        (playerObj2.pause = function () {
                          this.plyr.pause();
                        }.bind(playerObj2)),
                        (playerObj2.destroy = function () {
                          this.plyr.destroy();
                        }.bind(playerObj2)),
                        (playerObj2.plyr = new Shopify.Plyr(element, {
                          controls: [
                            "play",
                            "progress",
                            "mute",
                            "volume",
                            "play-large",
                            "fullscreen",
                          ],
                          loop: { active: enableLooping },
                          hideControlsOnPause: !0,
                          iconUrl:
                            "//cdn.shopify.com/shopifycloud/shopify-plyr/v1.0/shopify-plyr.svg",
                          tooltips: { controls: !1, seek: !0 },
                        })),
                        $(this)
                          .data("player", playerObj2)
                          .addClass("product-media--video-loaded"),
                        callbacks.onPlyrPlay &&
                          $(element).on("playing", callbacks.onPlyrPlay),
                        callbacks.onPlyrPause &&
                          $(element).on("pause ended", callbacks.onPlyrPause),
                        callbacks.onPlyrInit &&
                          callbacks.onPlyrInit(playerObj2);
                    }.bind(this),
                  },
                ]),
                  theme.loadStyleOnce(
                    "https://cdn.shopify.com/shopifycloud/shopify-plyr/v1.0/shopify-plyr.css"
                  );
              else if (element.tagName === "IFRAME")
                if (
                  /^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(
                    element.src
                  )
                ) {
                  var temp = window.onYouTubeIframeAPIReady,
                    loadYoutubeVideo = function () {
                      var playerObj2 = { playerType: "youtube", element },
                        videoId = $(this).data("video-id");
                      (playerObj2.player = new YT.Player(element, {
                        videoId,
                        events: {
                          onStateChange: function (event) {
                            event.data === YT.PlayerState.ENDED &&
                              enableLooping &&
                              event.target.seekTo(0);
                          },
                        },
                      })),
                        (playerObj2.play = function () {
                          this.player.playVideo();
                        }.bind(playerObj2)),
                        (playerObj2.pause = function () {
                          this.player.pauseVideo();
                        }.bind(playerObj2)),
                        (playerObj2.destroy = function () {
                          this.player.destroy();
                        }.bind(playerObj2)),
                        $(this)
                          .data("player", playerObj2)
                          .addClass("product-media--video-loaded"),
                        callbacks.onYouTubeInit &&
                          callbacks.onYouTubeInit(playerObj2);
                    }.bind(this);
                  (window.onYouTubeIframeAPIReady = function () {
                    temp(), loadYoutubeVideo();
                  }),
                    theme.loadScriptOnce("https://www.youtube.com/iframe_api");
                } else
                  /vimeo\.com/.test(element.src) &&
                    theme.loadScriptOnce(
                      "https://player.vimeo.com/api/player.js",
                      function () {
                        enableLooping &&
                          (element.src = element.src + "&loop=1"),
                          (playerObj = {
                            playerType: "vimeo",
                            element,
                            player: new Vimeo.Player(element),
                            play: function () {
                              this.player.play();
                            },
                            pause: function () {
                              this.player.pause();
                            },
                            destroy: function () {
                              this.player.destroy();
                            },
                          }),
                          $(this)
                            .data("player", playerObj)
                            .addClass("product-media--video-loaded");
                      }
                    );
            }),
            $(container2).on(
              "mediaVisible",
              ".product-media--video-loaded, .product-media--model-loaded",
              function () {
                $(window).width() >= 768 && $(this).data("player").play(),
                  $(this).hasClass("product-media--model") &&
                    $(".view-in-space", _container).attr(
                      "data-shopify-model3d-id",
                      $(this).data("model-id")
                    );
              }
            ),
            $(container2).on(
              "mediaHidden",
              ".product-media--video-loaded, .product-media--model-loaded",
              function () {
                $(this).data("player").pause();
              }
            ),
            callbacks.onVideoVisible &&
              $(container2).on(
                "mediaVisible",
                ".product-media--video-loaded",
                callbacks.onVideoVisible
              ),
            callbacks.onVideoHidden &&
              $(container2).on(
                "mediaHidden",
                ".product-media--video-loaded",
                callbacks.onVideoHidden
              ),
            $("model-viewer", container2).each(function () {
              callbacks.onModelViewerPlay &&
                $(this).on(
                  "shopify_model_viewer_ui_toggle_play",
                  callbacks.onModelViewerPlay
                ),
                callbacks.onModelViewerPause &&
                  $(this).on(
                    "shopify_model_viewer_ui_toggle_pause",
                    callbacks.onModelViewerPause
                  );
            }),
            $(container2).on(
              "mediaVisible mediaVisibleInitial",
              ".product-media--model:not(.product-media--model-loaded)",
              function (e) {
                var element = $(this).find("model-viewer")[0],
                  autoplay = e.type != "mediaVisibleInitial";
                theme.loadStyleOnce(
                  "https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css"
                ),
                  window.Shopify.loadFeatures([
                    {
                      name: "model-viewer-ui",
                      version: "1.0",
                      onLoad: function () {
                        $(this).data(
                          "player",
                          new Shopify.ModelViewerUI(element)
                        ),
                          $(this).addClass("product-media--model-loaded"),
                          callbacks.onModelViewerInit &&
                            callbacks.onModelViewerInit(element),
                          autoplay && $(this).trigger("mediaVisible");
                      }.bind(this),
                    },
                  ]);
              }
            ),
            $(".model-json", container2).length &&
              window.Shopify.loadFeatures([
                {
                  name: "shopify-xr",
                  version: "1.0",
                  onLoad: _._setupShopifyXr.bind($(".model-json", container2)),
                },
              ]),
            $(document).on("shopify_xr_launch", function () {
              $(".product-media--video-loaded").each(function () {
                $(this).data("player").pause();
              });
            }),
            setTimeout(
              function () {
                $(".product-media:first", this)
                  .filter(".product-media--model")
                  .trigger("mediaVisibleInitial");
              }.bind(container2),
              50
            );
        }),
        (this.destroy = function (container2) {
          $(document).off("shopify_xr_launch"),
            $(container2).off("mediaVisible mediaVisibleInitial mediaHidden"),
            $(
              ".product-media--video-loaded, .product-media--model-loaded",
              container2
            ).each(function () {
              $(this).data("player").destroy();
            }),
            $(".product-media--video video", container2).off(
              "playing pause ended"
            ),
            $("model-viewer", container2).off(
              "shopify_model_viewer_ui_toggle_play shopify_model_viewer_ui_toggle_pause"
            );
        });
    })()),
    (theme.productGallerySlideshowTabFix = function (slides, current) {
      $(slides[current])
        .find(
          "a, input, button, select, iframe, video, model-viewer, [tabindex]"
        )
        .each(function () {
          typeof $(this).data("theme-slideshow-original-tabindex") < "u"
            ? $(this).data("theme-slideshow-original-tabindex") === !1
              ? $(this).removeAttr("tabindex")
              : $(this).attr(
                  "tabindex",
                  $(this).data("theme-slideshow-original-tabindex")
                )
            : $(this).removeAttr("tabindex");
        }),
        $(slides)
          .not(slides[current])
          .find(
            "a, input, button, select, iframe, video, model-viewer, [tabindex]"
          )
          .each(function () {
            typeof $(this).data("theme-slideshow-original-tabindex") > "u" &&
              ($(this).data(
                "theme-slideshow-original-tabindex",
                typeof $(this).attr("tabindex") < "u"
                  ? $(this).attr("tabindex")
                  : !1
              ),
              $(this).attr("tabindex", "-1"));
          });
    }),
    (theme.productData = {}),
    (theme.OptionManager = new (function () {
      var _ = this;
      (_._getVariantOptionElement = function (variant, $container) {
        return $container.find(
          'select[name="id"] option[value="' + variant.id + '"]'
        );
      }),
        (_.selectors = {
          container: ".product-detail",
          gallery: ".gallery",
          priceArea: ".price-area",
          variantIdInputs: '[name="id"]',
          submitButton: 'input[type="submit"], button[type="submit"]',
          multiOption: ".option-selectors",
          installmentsFormSuffix: "-installments",
        }),
        (_.strings = {
          priceNonExistent: theme.strings.products_variant_non_existent,
          buttonDefault: theme.strings.products_product_add_to_cart,
          buttonNoStock: theme.strings.products_variant_no_stock,
          buttonNoVariant: theme.strings.products_variant_non_existent,
          unitPriceSeparator:
            theme.strings.products_product_unit_price_separator,
          inventoryNotice: theme.strings.onlyXLeft,
        }),
        (_._getString = function (key, variant) {
          var string = _.strings[key];
          return (
            variant &&
              (string = string.replace(
                "[PRICE]",
                '<span class="theme-money">' +
                  theme.Shopify.formatMoney(variant.price, theme.money_format) +
                  "</span>"
              )),
            string
          );
        }),
        (_.getProductData = function ($form) {
          var productId = $form.data("product-id"),
            data = null;
          return (
            theme.productData[productId] ||
              (theme.productData[productId] = JSON.parse(
                document.getElementById("ProductJson-" + productId).innerHTML
              )),
            (data = theme.productData[productId]),
            data ||
              console.log(
                "Product data missing (id: " + $form.data("product-id") + ")"
              ),
            data
          );
        }),
        (_.getBaseUnit = function (variant) {
          return variant.unit_price_measurement.reference_value === 1
            ? variant.unit_price_measurement.reference_unit
            : variant.unit_price_measurement.reference_value +
                variant.unit_price_measurement.reference_unit;
        }),
        (_.addVariantUrlToHistory = function (variant) {
          if (variant) {
            var newurl =
              window.location.protocol +
              "//" +
              window.location.host +
              window.location.pathname +
              "?variant=" +
              variant.id;
            window.history.replaceState({ path: newurl }, "", newurl);
          }
        }),
        (_.updateSku = function (variant, $container) {
          $container.find(".sku .sku__value").html(variant ? variant.sku : ""),
            $container
              .find(".sku")
              .toggleClass("sku--no-sku", !variant || !variant.sku);
        }),
        (_.updateBarcode = function (variant, $container) {
          $container
            .find(".barcode .barcode__value")
            .html(variant ? variant.barcode : ""),
            $container
              .find(".barcode")
              .toggleClass("barcode--no-barcode", !variant || !variant.barcode);
        }),
        (_.updateInventoryNotice = function (variant, $container) {
          var inventoryData = _._getVariantOptionElement(
            variant,
            $container
          ).data("inventory");
          inventoryData
            ? $container
                .find(".product-inventory-notice")
                .removeClass("product-inventory-notice--no-inventory")
                .html(
                  _._getString("inventoryNotice").replace(
                    "[[ quantity ]]",
                    inventoryData
                  )
                )
            : $container
                .find(".product-inventory-notice")
                .addClass("product-inventory-notice--no-inventory")
                .empty();
        }),
        (_.updateTransferNotice = function (variant, $container) {
          var transferData = _._getVariantOptionElement(
            variant,
            $container
          ).data("inventory-transfer");
          transferData
            ? $container
                .find(".product-inventory-transfer")
                .removeClass("product-inventory-transfer--none")
                .html(transferData)
            : $container
                .find(".product-inventory-transfer")
                .addClass("product-inventory-transfer--none")
                .empty();
        }),
        (_.updateBackorder = function (variant, $container) {
          var $backorder = $container.find(".backorder");
          if ($backorder.length)
            if (variant && variant.available)
              if (
                variant.inventory_management &&
                _._getVariantOptionElement(variant, $container).data("stock") ==
                  "out"
              ) {
                var productData = _.getProductData(
                  $backorder.closest(".product-form")
                );
                $backorder
                  .find(".backorder__variant")
                  .html(
                    productData.title +
                      (variant.title.indexOf("Default") >= 0
                        ? ""
                        : " - " + variant.title)
                  ),
                  $backorder.show();
              } else $backorder.hide();
            else $backorder.hide();
        }),
        (_.updatePrice = function (variant, $container) {
          var $priceArea = $container.find(_.selectors.priceArea);
          if (($priceArea.removeClass("on-sale"), variant)) {
            var $newPriceArea = $("<div>"),
              $price = $('<div class="price ">').appendTo($newPriceArea);
            let discPercentage = Math.round(
              ((variant.compare_at_price - variant.price) /
                variant.compare_at_price) *
                100
            );
            if (
              (variant.compare_at_price > variant.price &&
                ($price.append(" "),
                $('<span class="was-price theme-money">')
                  .html(
                    theme.Shopify.formatMoney(
                      variant.compare_at_price,
                      theme.money_format
                    )
                  )
                  .appendTo($price),
                $price.append(
                  `<span class="percentage-discount">${discPercentage}%</span>`
                ),
                $price.addClass("on-sale")),
              $('<span class="current-price theme-money">')
                .html(
                  theme.Shopify.formatMoney(variant.price, theme.money_format)
                )
                .appendTo($price),
              variant.unit_price_measurement)
            ) {
              var $newUnitPriceArea = $('<div class="unit-price">').appendTo(
                $newPriceArea
              );
              $('<span class="unit-price__price theme-money">')
                .html(
                  theme.Shopify.formatMoney(
                    variant.unit_price,
                    theme.money_format
                  )
                )
                .appendTo($newUnitPriceArea),
                $('<span class="unit-price__separator">')
                  .html(_._getString("unitPriceSeparator"))
                  .appendTo($newUnitPriceArea),
                $('<span class="unit-price__unit">')
                  .html(_.getBaseUnit(variant))
                  .appendTo($newUnitPriceArea);
            }
            $priceArea.html($newPriceArea.html());
          } else $priceArea.html(_._getString("priceNonExistent", variant));
        }),
        (_._updateButtonText = function ($button, string, variant) {
          $button.each(function () {
            var newVal;
            (newVal = _._getString("button" + string, variant)),
              newVal !== !1 &&
                ($(this).is("input")
                  ? $(this).val(newVal)
                  : $(this).html(newVal));
          });
        }),
        (_.updateButtons = function (variant, $container) {
          var $button = $container.find(_.selectors.submitButton);
          variant && variant.available == !0
            ? ($button.removeAttr("disabled"),
              _._updateButtonText($button, "Default", variant))
            : ($button.attr("disabled", "disabled"),
              variant
                ? _._updateButtonText($button, "NoStock", variant)
                : _._updateButtonText($button, "NoVariant", variant));
        }),
        (_.updateContainerStatusClasses = function (variant, $container) {
          $container.toggleClass(
            "variant-status--unavailable",
            variant && !variant.available
          ),
            $container.toggleClass(
              "variant-status--backorder",
              variant &&
                variant.available &&
                variant.inventory_management &&
                _._getVariantOptionElement(variant, $container).data("stock") ==
                  "out"
            ),
            $container.toggleClass(
              "variant-status--on-sale",
              variant &&
                variant.available &&
                variant.compare_at_price > variant.price
            );
        }),
        (_.initProductOptions = function ($productForm) {
          if (!$productForm.hasClass("theme-init")) {
            var productData = _.getProductData($productForm);
            $productForm.addClass("theme-init"),
              $productForm
                .find(_.selectors.multiOption)
                .on("change.themeProductOptions", "select", function () {
                  var selectedOptions = [];
                  $(this)
                    .closest(_.selectors.multiOption)
                    .find("select")
                    .each(function () {
                      selectedOptions.push($(this).val());
                    });
                  for (
                    var variant = !1, i = 0;
                    i < productData.variants.length;
                    i++
                  ) {
                    for (
                      var v = productData.variants[i], matchCount = 0, j = 0;
                      j < selectedOptions.length;
                      j++
                    )
                      v.options[j] == selectedOptions[j] && matchCount++;
                    if (matchCount == selectedOptions.length) {
                      variant = v;
                      break;
                    }
                  }
                  variant &&
                    $productForm
                      .find(_.selectors.variantIdInputs)
                      .val(variant.id),
                    $productForm
                      .find(_.selectors.variantIdInputs)
                      .each(function () {
                        this.dispatchEvent(
                          new CustomEvent("change", {
                            bubbles: !0,
                            cancelable: !1,
                            detail: variant,
                          })
                        );
                      });
                }),
              $productForm.find(_.selectors.variantIdInputs).each(function () {
                $(this).on(
                  "change.themeProductOptions firstrun.themeProductOptions",
                  function (e) {
                    if (!$(this).is("input[type=radio]:not(:checked)")) {
                      var variant = e.detail;
                      if (!variant && variant !== !1)
                        for (var i = 0; i < productData.variants.length; i++)
                          productData.variants[i].id == $(this).val() &&
                            (variant = productData.variants[i]);
                      var $container = $(this).closest(_.selectors.container),
                        $addToCart = $container
                          .find(_.selectors.submitButton)
                          .filter("[data-add-to-cart-text]");
                      $addToCart.length &&
                        (_.strings.buttonDefault =
                          $addToCart.data("add-to-cart-text")),
                        _.updatePrice(variant, $container),
                        _.updateButtons(variant, $container),
                        $(window).trigger("cc-variant-updated", {
                          variant,
                          product: productData,
                        }),
                        variant &&
                          variant.featured_media &&
                          $container
                            .find(_.selectors.gallery)
                            .trigger("variantImageSelected", variant),
                        _.updateBarcode(variant, $container),
                        _.updateSku(variant, $container),
                        _.updateInventoryNotice(variant, $container),
                        _.updateTransferNotice(variant, $container),
                        _.updateBackorder(variant, $container),
                        _.updateContainerStatusClasses(variant, $container),
                        $productForm.data("enable-history-state") &&
                          e.type == "change" &&
                          _.addVariantUrlToHistory(variant),
                        $productForm.trigger("variantChanged", variant);
                    }
                  }
                ),
                  $(this).trigger("firstrun");
              }),
              theme.applyAjaxToProductForm($productForm);
          }
        }),
        (_.unloadProductOptions = function ($productForm) {
          $productForm.removeClass("theme-init").each(function () {
            $(this).trigger("unloading").off(".themeProductOptions"),
              $(this).find(_.selectors.multiOption).off(".themeProductOptions"),
              theme.removeAjaxFromProductForm($productForm);
          });
        });
    })()),
    (theme.loadQuickbuy = function () {
      function contractDetail($blocks, speed) {
        $blocks.length > 0 &&
          ($blocks.removeClass("expanded"),
          $blocks
            .find(".quickbuy-container")
            .stop()
            .animate({ height: 0 }, speed, function () {
              $(this).find(".inner").empty();
            }),
          $blocks.stop().each(function () {
            $(this).animate({ paddingBottom: 0 }, speed);
          }));
      }
      function loadComponents(componentContainer) {
        $(componentContainer)
          .closest("[data-components]")
          .each(function () {
            $(this)
              .data("components")
              .split(",")
              .forEach(function (component) {
                $(document).trigger("cc:component:load", [
                  component,
                  componentContainer,
                ]);
              });
          }),
          $(componentContainer)
            .find(".cc-accordion")
            .on("transitionend.qbLoadComponents", function () {
              $(this).closest(".quickbuy-container").trigger("changedsize");
            });
      }
      function unloadComponents(componentContainer) {
        $(componentContainer).find(".cc-accordion").off(".qbLoadComponents"),
          $(componentContainer)
            .closest("[data-components]")
            .each(function () {
              $(this)
                .data("components")
                .split(",")
                .forEach(function (component) {
                  $(document).trigger("cc:component:unload", [
                    component,
                    componentContainer,
                  ]);
                });
            });
      }
      var droppyDownAnimSpeed = 500;
      $(document).on(
        "click",
        ".product-list .product-block:not(.collection-block):not(.main-search-result) .quickbuy-toggle",
        function () {
          var pageWidth = $(window).width(),
            productUrl = $(this).attr("href");
          if (pageWidth > 767) {
            theme.currentQuickbuyRequest &&
              theme.currentQuickbuyRequest.abort();
            var $block = $(this).closest(".product-block"),
              $detailCont = null,
              $quickbuyCont = null,
              $slider = $(this).closest(".collection-slider"),
              $sliderRow = null;
            if ($slider.length > 0) {
              if (
                (($sliderRow = $slider.closest(".collection-slider-row")),
                $sliderRow.find(".quickbuy-container").length === 0)
              )
                return;
              $quickbuyCont = $sliderRow.find(".quickbuy-container");
            } else $quickbuyCont = $block.find(".quickbuy-container");
            if (
              (($detailCont = $quickbuyCont.find(".inner")),
              $block.toggleClass("expanded").hasClass("expanded"))
            ) {
              if ($slider.length > 0) {
                var noneExpanded =
                  $slider
                    .find(".product-block.expanded")
                    .not($block)
                    .removeClass("expanded").length === 0;
                noneExpanded
                  ? $quickbuyCont.height(0)
                  : (theme.OptionManager.unloadProductOptions(
                      $('[name="id"].original-selector', $quickbuyCont)
                    ),
                    $(".gallery", $quickbuyCont).off(this.namespace),
                    $(".slideshow", $quickbuyCont).slick("unslick"),
                    unloadComponents($quickbuyCont)),
                  $quickbuyCont
                    .off("changedsize")
                    .on("changedsize", function () {
                      $quickbuyCont
                        .stop()
                        .animate(
                          { height: $detailCont.outerHeight() },
                          droppyDownAnimSpeed
                        );
                    });
              } else {
                var $expandedSiblings = $block.siblings(".expanded");
                $expandedSiblings.each(function () {
                  contractDetail($(this), 0),
                    theme.OptionManager.unloadProductOptions(
                      $('[name="id"].original-selector', this)
                    ),
                    theme.destroyProductGallery(this),
                    unloadComponents(this);
                }),
                  $quickbuyCont
                    .off("changedsize")
                    .on("changedsize", function () {
                      if ($block.hasClass("expanded")) {
                        var targetHeight = $detailCont.outerHeight(),
                          speed =
                            $expandedSiblings.length > 0
                              ? 0
                              : droppyDownAnimSpeed;
                        $block
                          .stop()
                          .animate({ paddingBottom: targetHeight + 20 }, speed),
                          $quickbuyCont
                            .stop()
                            .animate({ height: targetHeight }, speed);
                      }
                    });
              }
              window.SPR &&
                theme.ProductBlockManager.alignProductBlockHeights(),
                $detailCont.html('<div class="loading-spinner"></div>'),
                $quickbuyCont.trigger("changedsize");
              var url = $(this).attr("href");
              (theme.currentQuickbuyRequest = $.get(url, function (response) {
                var $newDetail = $("<div>" + response + "</div>").find(
                  ".quickbuy-content"
                );
                if (
                  ($newDetail.find(".more").attr("href", productUrl),
                  $newDetail
                    .find(".detail .title")
                    .wrapInner($("<a>").attr("href", productUrl)),
                  $newDetail
                    .find(".show-gallery")
                    .removeClass("show-gallery")
                    .attr("href", productUrl),
                  $newDetail.find(".not-in-quickbuy").remove(),
                  $newDetail
                    .find(".only-in-quickbuy")
                    .removeClass("only-in-quickbuy"),
                  $newDetail
                    .find(".sticky-content-container")
                    .removeClass("sticky-content-container"),
                  $newDetail.find(".store-availability-container").remove(),
                  $newDetail
                    .find('[data-enable-history-state="true"]')
                    .attr("data-enable-history-state", "false"),
                  $newDetail.find(".rte img").on("load", function () {
                    $quickbuyCont.trigger("changedsize"), $(this).off("load");
                  }),
                  $detailCont.html($newDetail),
                  Shopify.PaymentButton &&
                    $quickbuyCont.find(".shopify-payment-button").length)
                ) {
                  var _f = null;
                  (_f = function () {
                    document.removeEventListener(
                      "shopify:payment_button:loaded",
                      _f
                    ),
                      $quickbuyCont.trigger("changedsize");
                  }),
                    document.addEventListener(
                      "shopify:payment_button:loaded",
                      _f
                    ),
                    Shopify.PaymentButton.init();
                }
                theme.initProductGallery($quickbuyCont),
                  $quickbuyCont
                    .find(".product-form")
                    .trigger("load-product-form")
                    .on("variantChanged", function () {
                      $quickbuyCont.trigger("changedsize");
                    }),
                  loadComponents($quickbuyCont),
                  theme.initAnimateOnScroll(),
                  $quickbuyCont.trigger("changedsize");
              }).always(function () {
                theme.currentQuickbuyRequest = !1;
              })),
                $quickbuyCont.find(".close-detail").removeAttr("tabindex");
              var scrollMode = "qb",
                scrollOffset = -120;
              if (
                ($(".section-header").css("position") == "sticky" &&
                  (scrollOffset -= $(".section-header").height()),
                scrollMode == "qb")
              )
                $("html:not(:animated),body:not(:animated)").animate(
                  { scrollTop: $quickbuyCont.offset().top + scrollOffset },
                  500
                );
              else if ($slider.length > 0)
                $("html:not(:animated),body:not(:animated)").animate(
                  { scrollTop: $block.offset().top },
                  500
                );
              else {
                saveCollectionPageData();
                var offsetTop =
                  typeof $block.data("offsetTop") < "u"
                    ? $block.data("offsetTop")
                    : $block.offset().top;
                $("html:not(:animated),body:not(:animated)").animate(
                  { scrollTop: offsetTop + scrollOffset },
                  500
                );
              }
            } else {
              unloadComponents($quickbuyCont),
                $slider.length > 0
                  ? $quickbuyCont
                      .stop()
                      .animate({ height: 0 }, droppyDownAnimSpeed, function () {
                        $detailCont.empty();
                      })
                  : contractDetail($block, droppyDownAnimSpeed);
              var scrollUpOffset = -140;
              $("html:not(:animated),body:not(:animated)").animate(
                { scrollTop: $block.offset().top + scrollUpOffset },
                500
              ),
                $quickbuyCont.find(".close-detail").attr("tabindex", "-1");
            }
            return !1;
          }
        }
      ),
        $(document).on(
          "click",
          ".quickbuy-container .close-detail",
          function () {
            var $slider = $(this).closest(".collection-slider-row");
            return (
              $slider.length
                ? $slider
                    .find(".product-block.expanded .quickbuy-toggle:first")
                    .trigger("click")
                : $(this)
                    .closest(".product-block")
                    .find(".quickbuy-toggle:first")
                    .trigger("click"),
              !1
            );
          }
        );
      function saveCollectionPageData() {
        $(".collection-listing").each(function () {
          var $blocks = $(this).find(".product-block");
          if ($blocks.length <= 1) return !0;
          var row = 0,
            currTop = 0,
            blockHeight = Math.min(
              $blocks.first().outerHeight(),
              $($blocks[1]).outerHeight()
            ),
            blockPageOffset = $blocks.first().offset().top;
          $blocks.each(function (index) {
            var currOffsetTop = $(this).offset().top;
            index == 0
              ? (currTop = currOffsetTop)
              : currOffsetTop > currTop && (row++, (currTop = currOffsetTop)),
              $(this).data({ offsetTop: blockPageOffset + row * blockHeight });
          });
        });
      }
    }),
    $(function () {
      $(document).on("click", ".sharing a", function (e) {
        var $parent = $(this).parent();
        if ($parent.hasClass("twitter")) {
          e.preventDefault();
          var url = $(this).attr("href"),
            width = 575,
            height = 450,
            left = ($(window).width() - width) / 2,
            top = ($(window).height() - height) / 2,
            opts =
              "status=1, toolbar=0, location=0, menubar=0, directories=0, scrollbars=0,width=" +
              width +
              ",height=" +
              height +
              ",top=" +
              top +
              ",left=" +
              left;
          window.open(url, "Twitter", opts);
        } else if ($parent.hasClass("facebook")) {
          e.preventDefault();
          var url = $(this).attr("href"),
            width = 626,
            height = 256,
            left = ($(window).width() - width) / 2,
            top = ($(window).height() - height) / 2,
            opts =
              "status=1, toolbar=0, location=0, menubar=0, directories=0, scrollbars=0,width=" +
              width +
              ",height=" +
              height +
              ",top=" +
              top +
              ",left=" +
              left;
          window.open(url, "Facebook", opts);
        } else if ($parent.hasClass("pinterest")) {
          e.preventDefault();
          var url = $(this).attr("href"),
            width = 700,
            height = 550,
            left = ($(window).width() - width) / 2,
            top = ($(window).height() - height) / 2,
            opts =
              "status=1, toolbar=0, location=0, menubar=0, directories=0, scrollbars=0,width=" +
              width +
              ",height=" +
              height +
              ",top=" +
              top +
              ",left=" +
              left;
          window.open(url, "Pinterest", opts);
        } else if ($parent.hasClass("google")) {
          e.preventDefault();
          var url = $(this).attr("href"),
            width = 550,
            height = 450,
            left = ($(window).width() - width) / 2,
            top = ($(window).height() - height) / 2,
            opts =
              "status=1, toolbar=0, location=0, menubar=0, directories=0, scrollbars=0,width=" +
              width +
              ",height=" +
              height +
              ",top=" +
              top +
              ",left=" +
              left;
          window.open(url, "Google+", opts);
        }
      });
    }),
    (theme.AnnouncementBarSection = new (function () {
      (this.onSectionLoad = function (container2) {
        $(".disclosure", container2).each(function () {
          $(this).data("disclosure", new theme.Disclosure($(this)));
        });
      }),
        (this.onSectionUnload = function (container2) {
          $(".disclosure", container2).each(function () {
            $(this).data("disclosure").unload();
          });
        });
    })()),
    (theme.BlogTemplateSection = new (function () {
      (this.onSectionLoad = function (container2) {
        (this.namespace = theme.namespaceFromSection(container2)),
          (this.$container = $(container2)),
          theme.classUpTextLinks(container2),
          this.$container.on(
            "click" + this.namespace,
            ".link-dropdown__button",
            theme.toggleLinkDropdownButton.bind(this)
          ),
          $(document).on("click" + this.namespace, function () {
            $('.link-dropdown__button[aria-expanded="true"]').trigger("click");
          });
      }),
        (this.onSectionUnload = function (container2) {
          this.$container.off(this.namespace), $(document).off(this.namespace);
        });
    })()),
    (theme.CartTemplateSection = new (function () {
      (this.onSectionLoad = function (container2) {
        theme.classUpTextLinks(container2),
          $(document).on(
            "theme:cartchanged.cartTemplateSection",
            this.functions.refreshCartDependentContent.bind(this)
          ),
          $("#cartform input#terms", container2).length > 0 &&
            $(document).on(
              "click.cartTemplateSection",
              '#cartform [name="checkout"], .additional-checkout-buttons input, a[href*="/checkout"]',
              function () {
                if ($("#cartform input#terms:checked").length == 0)
                  return alert(theme.strings.cart_terms_confirmation), !1;
              }
            ),
          $(container2).data("ajax-update") &&
            ($(container2).on(
              "keyup.cartTemplateSection change.cartTemplateSection changeFromButton.cartTemplateSection",
              ".cart-item__quantity-input",
              function (evt) {
                if (
                  !this.replacingContent &&
                  !(
                    $(evt.currentTarget).data("initial-value") &&
                    $(evt.currentTarget).data("initial-value") ==
                      $(evt.currentTarget).val()
                  ) &&
                  !(
                    $(evt.currentTarget).val().length == 0 ||
                    $(evt.currentTarget).val() == "0"
                  )
                ) {
                  var toFocusId;
                  evt.type === "changeFromButton"
                    ? (toFocusId = $(evt.data).attr("id"))
                    : (toFocusId = $(evt.currentTarget).attr("id")),
                    this.functions.updateCart.call(
                      this,
                      {
                        line: $(evt.currentTarget).data("line"),
                        quantity: $(evt.currentTarget).val(),
                      },
                      function () {
                        $("#" + toFocusId).focus();
                      }
                    );
                }
              }.bind(this)
            ),
            $(container2).on(
              "click.cartTemplateSection",
              ".quantity-down, .quantity-up",
              function (evt) {
                var $input = $(this).closest(".quantity").find("input"),
                  step = $input.attr("step")
                    ? parseInt($input.attr("step"))
                    : 1;
                return (
                  $(this).hasClass("quantity-down")
                    ? $input
                        .val(parseInt($input.val()) - step)
                        .trigger("changeFromButton", { data: this })
                    : $input
                        .val(parseInt($input.val()) + step)
                        .trigger("changeFromButton", { data: this }),
                  !1
                );
              }
            )),
          theme.cartNoteMonitor.load(
            $('.checkout-note [name="note"]', container2)
          ),
          $(container2).on(
            "click.cartTemplateSection",
            "button[data-toggle-shipping]",
            function () {
              $("#shipping-calculator").toggle();
              var alt = $(this).data("toggle-html");
              return (
                $(this).data("toggle-html", $(this).html()),
                $(this).html(alt),
                !1
              );
            }
          );
      }),
        (this.functions = {
          refreshCartDependentContent: function () {
            this.cartRefreshXhr && this.cartRefreshXhr.abort(),
              (this.cartRefreshXhr = $.ajax({
                type: "GET",
                url: theme.routes.cart_url + "?view=ajax",
                success: function (data) {
                  var toReplace = [
                      ".cart-item-list",
                      ".checkout-subtotal-container__right",
                    ],
                    $newDom = $("<div>" + data + "</div>");
                  $newDom.find(".fade-in").removeClass("fade-in"),
                    $newDom
                      .find("[data-cc-animate]")
                      .removeAttr("data-cc-animate");
                  for (var i = 0; i < toReplace.length; i++)
                    (this.replacingContent = !0),
                      $(
                        '[data-section-type="cart-template"] ' + toReplace[i]
                      ).html($newDom.find(toReplace[i]).html()),
                      (this.replacingContent = !1);
                }.bind(this),
                error: function (data) {
                  data.statusText != "abort" &&
                    (console.log("Error refreshing page"), console.log(data));
                },
                complete: function () {
                  this.cartRefreshXhr = null;
                }.bind(this),
              }));
          },
          updateCart: function (params, successCallback) {
            this.cartXhr && this.cartXhr.abort(),
              this.cartRefreshXhr && this.cartRefreshXhr.abort(),
              (this.cartXhr = $.ajax({
                type: "POST",
                url: theme.routes.cart_change_url + ".js",
                data: params,
                dataType: "json",
                success: function () {
                  document.documentElement.dispatchEvent(
                    new CustomEvent("theme:cartchanged", {
                      bubbles: !0,
                      cancelable: !1,
                    })
                  ),
                    successCallback();
                },
                error: function (data) {
                  data.statusText != "abort" &&
                    (console.log("Error processing update"), console.log(data));
                },
                complete: function () {
                  this.cartXhr = null;
                }.bind(this),
              }));
          },
        }),
        (this.onSectionUnload = function (container2) {
          $(document).off(".cartTemplateSection"),
            $(container2).off(".cartTemplateSection"),
            theme.cartNoteMonitor.unload(
              $('.checkout-note [name="note"]', container2)
            );
        });
    })()),
    (theme.CollectionTemplateSection = new (function () {
      (this.onSectionLoad = function (container2) {
        (this.namespace = theme.namespaceFromSection(container2)),
          (this.$container = $(container2)),
          theme.classUpTextLinks(container2),
          this.$container.data("ajax-filtering")
            ? (this.$container.on(
                "click" + this.namespace,
                ".link-dropdown__link, .filter-group__applied-item, .filter-group__clear-link, .pagination a",
                this.functions.ajaxLoadLink.bind(this)
              ),
              this.$container.on(
                "change" + this.namespace + " submit" + this.namespace,
                "#CollectionFilterForm",
                theme.debounce(this.functions.ajaxLoadForm.bind(this), 700)
              ),
              this.registerEventListener(
                window,
                "popstate",
                this.functions.ajaxPopState.bind(this)
              ))
            : this.$container.on(
                "change" + this.namespace,
                "#CollectionFilterForm",
                function () {
                  $(this).submit();
                }
              ),
          this.$container.on(
            "click" + this.namespace,
            ".link-dropdown__button",
            theme.toggleLinkDropdownButton.bind(this)
          ),
          $(document).on("click" + this.namespace, function () {
            $('.link-dropdown__button[aria-expanded="true"]').trigger("click");
          }),
          $(window).on(
            "debouncedresize" + this.namespace,
            this.functions.truncateButtonSubcollections.bind(this)
          ),
          this.functions.truncateButtonSubcollections.call(this);
        var $subcollectionGallery = $(
          ".subcollection-links--gallery .gallery",
          container2
        );
        $subcollectionGallery
          .on("init", function () {
            $(".lazyload--manual", this)
              .removeClass("lazyload--manual")
              .addClass("lazyload");
          })
          .slick({
            autoplay: !1,
            fade: !1,
            infinite: !1,
            swipeToSlide: !0,
            slidesToShow: Math.min(
              4,
              $(".subcollection-links--gallery .gallery__item", container2)
                .length
            ),
            slidesToScroll: 1,
            useTransform: !0,
            arrows: !0,
            dots: !1,
            prevArrow:
              '<button type="button" class="image-page-button image-page-button--previous" aria-label="' +
              theme.strings.previous +
              '">' +
              theme.icons.chevronLeft +
              "</button>",
            nextArrow:
              '<button type="button" class="image-page-button image-page-button--next" aria-label="' +
              theme.strings.next +
              '">' +
              theme.icons.chevronRight +
              "</button>",
            responsive: [
              {
                breakpoint: 1e3,
                settings: {
                  slidesToShow: Math.min(
                    3,
                    $(
                      ".subcollection-links--gallery .gallery__item",
                      container2
                    ).length
                  ),
                },
              },
              {
                breakpoint: 768,
                settings:
                  $subcollectionGallery.data("mobile-item-count") == "hide"
                    ? "unslick"
                    : {
                        slidesToShow:
                          $subcollectionGallery.data("mobile-item-count"),
                      },
              },
            ],
          });
        var $utilBarClone = $(".utility-bar")
          .clone()
          .addClass("utility-bar--sticky-mobile-copy")
          .removeAttr("data-ajax-container")
          .insertAfter(".utility-bar");
        theme.suffixIds($utilBarClone[0], "dupe"),
          (this.previousScrollTop = window.scrollY),
          $(window).on(
            "throttled-scroll" + this.namespace,
            this.functions.checkStickyScroll.bind(this)
          ),
          this.$container.on(
            "click" + this.namespace,
            "[data-toggle-filters]",
            function (evt) {
              var isNowVisible = $(".filter-container", this.$container)
                .toggleClass(
                  "filter-container--show-filters-desktop filter-container--show-filters-mobile"
                )
                .hasClass("filter-container--show-filters-desktop");
              return (
                $(
                  ".toggle-btn[data-toggle-filters]",
                  this.$container
                ).toggleClass("toggle-btn--revealed-desktop", isNowVisible),
                theme.ProductBlockManager.afterImagesResized(),
                $(".slick-slider", this.$container).each(function () {
                  $(this).slick("setPosition");
                }),
                !1
              );
            }.bind(this)
          ),
          this.$container.on(
            "click" + this.namespace,
            ".layout-switch",
            this.functions.switchGridLayout.bind(this)
          ),
          this.functions.initFiltersEtc.call(this);
      }),
        (this.onSectionUnload = function (container2) {
          theme.ProductBlockManager.unloadImages(this.$container),
            this.$container.off(this.namespace),
            theme.destroyProductGallery(this.$container),
            $(".slick-slider", container2).slick("unslick").off("init"),
            $(window).off(this.namespace),
            $(document).off(this.namespace);
        }),
        (this.functions = {
          truncateButtonSubcollections: function () {
            var $subcollections = $(
              ".subcollection-links--buttons",
              this.$container
            );
            if ($subcollections.css("display") == "flex") {
              var limit = 4,
                $btns = $subcollections.find(".btn");
              $btns.length > limit &&
                $subcollections.find(".subcollection-links__expander")
                  .length === 0 &&
                ($btns.slice(limit - 1).hide(),
                $(
                  '<a href="#" class="btn btn--tertiary subcollection-links__expander">'
                )
                  .text(
                    theme.strings.collections_general_see_all_subcollections
                  )
                  .appendTo($subcollections)
                  .on("click", function (evt) {
                    evt.preventDefault(),
                      $(this).siblings().show(),
                      $(this).remove();
                  }));
            } else
              $subcollections.find(".subcollection-links__expander").length &&
                ($subcollections
                  .find(".subcollection-links__expander")
                  .siblings()
                  .show(),
                $subcollections
                  .find(".subcollection-links__expander")
                  .remove());
          },
          initFiltersEtc: function () {
            $(".filter-container", this.$container).addClass(
              "filter-container--mobile-initialised"
            ),
              location.href.indexOf("?") >= 0 &&
                $(
                  "#sort-dropdown-options .link-dropdown__link",
                  this.$container
                ).each(function () {
                  var queryTerms = location.href.split("?")[1].split("&"),
                    newHref = $(this).attr("href");
                  queryTerms.forEach(function (term) {
                    term.indexOf("sort_by=") === -1 && (newHref += "&" + term);
                  }),
                    $(this).attr("href", newHref);
                }),
              theme.ProductBlockManager.loadImages(this.$container);
          },
          switchGridLayout: function (evt) {
            evt.preventDefault(),
              $(evt.currentTarget).hasClass("layout-switch--one-column")
                ? this.$container
                    .find(".product-list")
                    .addClass("product-list--one-column-mobile")
                : this.$container
                    .find(".product-list")
                    .removeClass("product-list--one-column-mobile"),
              $(evt.currentTarget)
                .addClass("layout-switch--active")
                .siblings()
                .removeClass("layout-switch--active");
          },
          checkStickyScroll: function () {
            var utilityBarOffsetY = $(".utility-bar").offset().top;
            $(window).width() < 768 &&
            this.previousScrollTop > window.scrollY &&
            window.scrollY > utilityBarOffsetY
              ? $("body").addClass("utility-bar-sticky-mobile-copy-reveal")
              : $("body.utility-bar-sticky-mobile-copy-reveal").removeClass(
                  "utility-bar-sticky-mobile-copy-reveal"
                ),
              (this.previousScrollTop = window.scrollY);
          },
          ajaxLoadLink: function (evt) {
            evt.preventDefault(),
              this.functions.ajaxLoadUrl.call(
                this,
                $(evt.currentTarget).attr("href")
              );
          },
          ajaxLoadForm: function (evt) {
            evt.type === "submit" && evt.preventDefault();
            var queryVals = [];
            evt.currentTarget
              .querySelectorAll("input, select")
              .forEach(function (input) {
                ((input.type !== "checkbox" && input.type !== "radio") ||
                  input.checked) &&
                  input.value !== "" &&
                  queryVals.push([input.name, encodeURIComponent(input.value)]);
              });
            var newUrl = location.pathname;
            queryVals.forEach(function (value) {
              newUrl += "&".concat(value[0], "=").concat(value[1]);
            }),
              (newUrl = newUrl.replace("&", "?")),
              this.functions.ajaxLoadUrl.call(this, newUrl);
          },
          ajaxPopState: function (event) {
            this.functions.ajaxLoadUrl.call(this, document.location.href);
          },
          ajaxLoadUrl: function (url) {
            var fullUrl = url;
            fullUrl.slice(0, 1) === "/" &&
              (fullUrl =
                window.location.protocol +
                "//" +
                window.location.host +
                fullUrl),
              (location.href = fullUrl),
              window.history.pushState({ path: fullUrl }, "", fullUrl);
            var refreshContainerSelector = "[data-ajax-container]",
              $ajaxContainers = this.$container.find(refreshContainerSelector);
            $ajaxContainers.addClass("ajax-loading"),
              this.currentAjaxLoadUrlFetch &&
                this.currentAjaxLoadUrlFetch.abort(),
              (this.currentAjaxLoadUrlFetch = $.get(
                url,
                function (data) {
                  (this.currentAjaxLoadUrlFetch = null),
                    document.activeElement &&
                      (this.activeElementId = document.activeElement.id),
                    theme.ProductBlockManager.unloadImages(this.$container);
                  var $newAjaxContainers = $(
                    "<div>".concat(data, "</div>")
                  ).find(refreshContainerSelector);
                  $newAjaxContainers.each(function (index) {
                    $($ajaxContainers[index]).html($(this).html());
                  }),
                    this.functions.initFiltersEtc.call(this);
                  var $componentHaver =
                    this.$container.closest("[data-components]");
                  if ($componentHaver.length) {
                    var components = $componentHaver
                      .data("components")
                      .split(",");
                    components.forEach(
                      function (component) {
                        $(document).trigger("cc:component:load", [
                          component,
                          $componentHaver[0],
                        ]);
                      }.bind(this)
                    );
                  }
                  if (
                    ($ajaxContainers.removeClass("ajax-loading"),
                    window.SPR &&
                      SPR.initDomEls &&
                      SPR.loadBadges &&
                      (SPR.initDomEls(), SPR.loadBadges()),
                    theme.initAnimateOnScroll(),
                    this.activeElementId)
                  ) {
                    var el = document.getElementById(this.activeElementId);
                    el && el.focus();
                  }
                  var scrollToY =
                    $("[data-ajax-scroll-to]:first", this.$container).offset()
                      .top - $(".section-header").height();
                  window.scrollTo({ top: scrollToY, behavior: "smooth" });
                }.bind(this)
              ));
          },
        });
    })()),
    (theme.CustomRowSection = new (function () {
      (this.onSectionLoad = function (container2) {
        theme.classUpTextLinks(container2),
          theme.VideoManager.onSectionLoad(container2);
      }),
        (this.onSectionUnload = function (container2) {
          theme.VideoManager.onSectionUnload(container2);
        });
    })()),
    (theme.FeaturedCollectionSection = new (function () {
      (this.onSectionLoad = function (container2) {
        var $carousels = theme.loadCarousels(container2);
        $carousels.length === 0 &&
          theme.ProductBlockManager.loadImages(container2);
      }),
        (this.onSectionUnload = function (container2) {
          theme.ProductBlockManager.unloadImages(container2),
            theme.unloadCarousels(container2);
        });
    })()),
    (theme.FeaturedCollectionsSection = new (function () {
      (this.onSectionLoad = function (container2) {
        var $carousels = theme.loadCarousels(container2);
        $carousels.length === 0 &&
          theme.ProductBlockManager.loadImages(container2);
      }),
        (this.onSectionUnload = function (container2) {
          theme.ProductBlockManager.unloadImages(container2),
            theme.unloadCarousels(container2);
        });
    })()),
    (theme.FeaturedProductSection = new (function () {
      (this.onSectionLoad = function (container2) {
        $(".product-form", container2).trigger("load-product-form"),
          theme.classUpTextLinks(container2),
          theme.initProductGallery(container2);
      }),
        (this.onSectionUnload = function (container2) {
          theme.destroyProductGallery(container2),
            theme.OptionManager.unloadProductOptions(
              $(".product-form", container2)
            ),
            $(".slideshow", container2).slick("unslick");
        });
    })()),
    (theme.FooterSection = new (function () {
      (this.onSectionLoad = function (container2) {
        $(".disclosure", container2).each(function () {
          $(this).data("disclosure", new theme.Disclosure($(this)));
        });
      }),
        (this.onSectionUnload = function (container2) {
          $(".disclosure", container2).each(function () {
            $(this).data("disclosure").unload();
          });
        });
    })()),
    (theme.GallerySection = new (function () {
      (this.onSectionLoad = function (container2) {
        var $carouselGallery = $(".gallery--mobile-carousel", container2);
        if ($carouselGallery.length) {
          var assessCarouselFunction = function () {
            var isCarousel = $carouselGallery.hasClass("slick-slider"),
              shouldShowCarousel = $(window).width() < 768;
            if (
              (shouldShowCarousel ||
                $(".lazyload--manual", $carouselGallery)
                  .removeClass("lazyload--manual")
                  .addClass("lazyload"),
              isCarousel && !shouldShowCarousel)
            ) {
              $carouselGallery.slick("unslick").off("init"),
                $carouselGallery
                  .find("a, .gallery__item")
                  .removeAttr("tabindex")
                  .removeAttr("role");
              var rowLimit = $carouselGallery.data("grid"),
                $currentRow = null;
              $carouselGallery.find(".gallery__item").each(function (index) {
                index % rowLimit === 0 &&
                  ($currentRow = $('<div class="gallery__row">').appendTo(
                    $carouselGallery
                  )),
                  $(this).appendTo($currentRow);
              });
            } else
              !isCarousel &&
                shouldShowCarousel &&
                ($carouselGallery
                  .find(".gallery__item")
                  .appendTo($carouselGallery),
                $carouselGallery.find(".gallery__row").remove(),
                $carouselGallery
                  .on("init", function () {
                    $(".lazyload--manual", this)
                      .removeClass("lazyload--manual")
                      .addClass("lazyload");
                  })
                  .slick({
                    autoplay: !1,
                    fade: !1,
                    infinite: !0,
                    useTransform: !0,
                    arrows: !1,
                    dots: !0,
                    customPaging: function (slider, i) {
                      return '<button class="custom-dot" type="button" data-role="none" role="button" tabindex="0"><svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="30px" height="30px" viewBox="0 0 30 30" xml:space="preserve"><circle class="circle-one" cx="15" cy="15" r="13" /><circle class="circle-two" cx="15" cy="15" r="13" /></svg></button>';
                    },
                  }));
          };
          assessCarouselFunction(),
            $(window).on(
              "debouncedresize.themeSection" + container2.id,
              assessCarouselFunction
            );
        }
      }),
        (this.onSectionUnload = function (container2) {
          $(window).off(".themeSection" + container2.id),
            $(".slick-slider", container2).each(function () {
              $(this).slick("unslick").off("init");
            });
        }),
        (this.onBlockSelect = function (block) {
          var blockSlideIndex = $(block).data("slick-index");
          $(block)
            .closest(".slick-slider")
            .each(function () {
              $(this).slick("slickGoTo", blockSlideIndex);
            });
        });
    })()),
    (theme.HeaderSection = new (function () {
      (this.onSectionLoad = function (container) {
        $(container).on(
          "focusin.headerSection focusout.headerSection",
          ".social-links",
          function (e) {
            return !1;
          }
        );
        var searchFocusOutTimeoutId = -1;
        $(container).on(
          "focusin.headerSection focusout.headerSection",
          ".search-box",
          function (e) {
            e.type == "focusin"
              ? (clearTimeout(searchFocusOutTimeoutId),
                $(this).closest(".search-box").addClass("focus"))
              : (clearTimeout(searchFocusOutTimeoutId),
                (searchFocusOutTimeoutId = setTimeout(
                  function () {
                    $(this).closest(".search-box").removeClass("focus");
                  }.bind(this),
                  200
                )));
          }
        ),
          $(container).on(
            "click.headerSection",
            ".show-search-link, .main-search__close",
            function (e) {
              return (
                $("body").toggleClass("show-search").hasClass("show-search")
                  ? setTimeout(function () {
                      $(".main-search__input:first").focus();
                    }, 500)
                  : $(".show-search-link:first").focus(),
                !1
              );
            }
          ),
          $(container).on(
            "keyup.headerSection",
            ".main-search__input",
            function (e) {
              e.keyCode == 27 && $(".main-search__close").click();
            }
          );
        var $liveSearchContainer = $(
          '.main-search[data-live-search="true"]',
          container
        );
        if ($liveSearchContainer.length) {
          var searchTimeoutThrottle = 500,
            searchTimeoutID = -1,
            currReqObj = null,
            showPrice = $liveSearchContainer.data("live-search-price"),
            showVendor = $liveSearchContainer.data("live-search-vendor"),
            includeMeta = $liveSearchContainer.data("live-search-meta"),
            productImageShape = $liveSearchContainer.data(
              "product-image-shape"
            ),
            showSoldOutLabel = $liveSearchContainer.data("show-sold-out-label"),
            showSaleLabel = $liveSearchContainer.data("show-sale-label"),
            showReductionLabel = $liveSearchContainer.data("show-reduction"),
            reductionLabelType = $liveSearchContainer.data("reduction-type");
          $(container).on(
            "keyup.headerSection change.headerSection",
            ".main-search__input",
            function () {
              var $searchContainer = $(".main-search"),
                $resultsBox = $searchContainer.find(".main-search__results"),
                valueToSearch = $(this).val();
              if (
                valueToSearch.length > 2 &&
                valueToSearch != $(this).data("oldval")
              ) {
                $(this).data("oldval", valueToSearch),
                  currReqObj?.abort(),
                  clearTimeout(searchTimeoutID);
                var $form = $(this).closest("form"),
                  linkURL =
                    $form.attr("action") +
                    ($form.attr("action").indexOf("?") > -1 ? "&" : "?") +
                    $form.serialize();
                $searchContainer
                  .removeClass(
                    "main-search--has-results main-search--results-on-multiple-lines main-search--no-results"
                  )
                  .addClass("main-search--loading"),
                  $(".main-search__results-spinner").length === 0 &&
                    $resultsBox.html(
                      '<div class="main-search__results-spinner"><div class="loading-spinner"></div></div>'
                    ),
                  (searchTimeoutID = setTimeout(function () {
                    var ajaxUrl, ajaxData;
                    theme.Shopify.features.predictiveSearch
                      ? ((ajaxUrl = theme.routes.search_url + "/suggest.json"),
                        (ajaxData = {
                          q: valueToSearch,
                          resources: {
                            type: $form.find('input[name="type"]').val(),
                            limit: 8,
                            options: {
                              unavailable_products: "last",
                              fields: includeMeta
                                ? "title,product_type,variants.title,vendor,tag,variants.sku"
                                : "title,product_type,variants.title,vendor",
                            },
                          },
                        }))
                      : ((ajaxUrl = linkURL + "&view=data"), (ajaxData = null)),
                      (currReqObj = $.ajax({
                        url: ajaxUrl,
                        data: ajaxData,
                        dataType: "json",
                        success: function (response) {
                          (currReqObj = null),
                            $searchContainer.removeClass(
                              "main-search--has-results main-search--results-on-multiple-lines main-search--no-results"
                            ),
                            $resultsBox.empty();
                          var $resultsProducts = $(
                              '<div class="main-search__results__products collection-listing"><div class="product-list product-list--per-row-4 product-list--image-shape-natural"></div></div>'
                            ),
                            $resultsPages = $(
                              '<div class="main-search__results__pages">'
                            );
                          if (response.resources.results.products)
                            for (
                              var i = 0;
                              i < response.resources.results.products.length;
                              i++
                            ) {
                              var result =
                                  response.resources.results.products[i],
                                $item = $(
                                  [
                                    '<div class="product-block main-search-result">',
                                    '<div class="block-inner">',
                                    '<div class="block-inner-inner">',
                                    '<div class="image-cont">',
                                    '<a class="product-link">',
                                    '<div class="image-label-wrap">',
                                    '<div class="product-block__image product-block__image--primary"></div>',
                                    "</div>",
                                    "</a>",
                                    "</div>",
                                    '<div class="product-info">',
                                    '<div class="inner">',
                                    '<div class="innerer">',
                                    '<a class="product-link">',
                                    '<div class="product-block__title"></div>',
                                    '<div class="product-price"></div>',
                                    "</a>",
                                    "</div>",
                                    "</div>",
                                    "</div>",
                                    "</div>",
                                    "</div>",
                                    "</div>",
                                  ].join("")
                                );
                              if (
                                ($item
                                  .find(".product-link")
                                  .attr("href", result.url),
                                result.featured_image &&
                                  result.featured_image.url)
                              ) {
                                var $img = $(
                                  '<div class="rimage-outer-wrapper"><div class="rimage-wrapper lazyload--placeholder"><img class="rimage__image lazyload fade-in"></div></div>'
                                ).appendTo(
                                  $item.find(".product-block__image--primary")
                                );
                                $img
                                  .find(".rimage-wrapper")
                                  .css(
                                    "padding-top",
                                    (1 /
                                      Math.max(
                                        result.featured_image.aspect_ratio,
                                        0.6
                                      )) *
                                      100 +
                                      "%"
                                  ),
                                  $img
                                    .find(".rimage__image")
                                    .attr(
                                      "data-src",
                                      theme.Shopify.formatImage(
                                        result.featured_image.url,
                                        "512x"
                                      ) + " 512w"
                                    );
                              }
                              var $itemInfoCont = $item.find(
                                ".product-info .product-link"
                              );
                              if (
                                ($itemInfoCont
                                  .find(".product-block__title")
                                  .html(result.title),
                                showVendor &&
                                  $('<div class="vendor">')
                                    .html(result.vendor)
                                    .prependTo($itemInfoCont),
                                showPrice)
                              ) {
                                var $price =
                                  $itemInfoCont.find(".product-price");
                                result.price_max != result.price_min &&
                                  ($(
                                    '<span class="product-price__item product-price__from">'
                                  )
                                    .html(theme.strings.products_listing_from)
                                    .appendTo($price),
                                  $price.append(" ")),
                                  parseFloat(result.compare_at_price_min) >
                                  parseFloat(result.price_min)
                                    ? ($(
                                        '<span class="product-price__item product-price__amount product-price__amount--on-sale theme-money">'
                                      )
                                        .html(
                                          theme.Shopify.formatMoney(
                                            result.price_min,
                                            theme.money_format
                                          )
                                        )
                                        .appendTo($price),
                                      $(
                                        '<span class="product-price__item product-price__compare theme-money">'
                                      )
                                        .html(
                                          theme.Shopify.formatMoney(
                                            result.compare_at_price_min,
                                            theme.money_format
                                          )
                                        )
                                        .appendTo($price))
                                    : $(
                                        '<span class="product-price__item product-price__amount theme-money">'
                                      )
                                        .html(
                                          theme.Shopify.formatMoney(
                                            result.price_min,
                                            theme.money_format
                                          )
                                        )
                                        .appendTo($price);
                              }
                              showSoldOutLabel && !result.available
                                ? $(
                                    '<span class="product-price__item price-label price-label--sold-out">'
                                  )
                                    .html(
                                      theme.strings.products_labels_sold_out
                                    )
                                    .appendTo($item.find(".product-price"))
                                : showSaleLabel &&
                                  parseFloat(result.compare_at_price_min) >
                                    parseFloat(result.price_min) &&
                                  $(
                                    '<span class="product-price__item price-label price-label--sale">'
                                  )
                                    .html(theme.strings.products_labels_sale)
                                    .appendTo($item.find(".product-price")),
                                showReductionLabel &&
                                  parseFloat(result.compare_at_price_min) >
                                    parseFloat(result.price_min) &&
                                  (reductionLabelType == "percent"
                                    ? $(
                                        '<span class="product-label product-label--sale"><span></span></span>'
                                      )
                                        .appendTo(
                                          $item.find(".image-label-wrap")
                                        )
                                        .find("span")
                                        .html(
                                          theme.strings.products_labels_percent_reduction.replace(
                                            /\[\[ ?amount ?\]\]/,
                                            Math.round(
                                              100 *
                                                (1 -
                                                  parseFloat(result.price_min) /
                                                    parseFloat(
                                                      result.compare_at_price_min
                                                    ))
                                            )
                                          )
                                        )
                                    : $(
                                        '<span class="product-label product-label--sale"><span></span></span>'
                                      )
                                        .appendTo(
                                          $item.find(".image-label-wrap")
                                        )
                                        .find("span")
                                        .html(
                                          theme.strings.products_labels_value_reduction_html.replace(
                                            /\[\[ ?amount ?\]\]/,
                                            theme.Shopify.formatMoney(
                                              parseInt(
                                                result.compare_at_price_min
                                                  .toString()
                                                  .replace(".", "")
                                              ) -
                                                parseInt(
                                                  result.price_min
                                                    .toString()
                                                    .replace(".", "")
                                                ),
                                              theme.money_format
                                            )
                                          )
                                        )),
                                $resultsProducts.children().append($item);
                            }
                          if (response.resources.results.pages)
                            for (
                              var i = 0;
                              i < response.resources.results.pages.length;
                              i++
                            ) {
                              var result = response.resources.results.pages[i],
                                $item = $(
                                  '<a class="main-search-result main-search-result--page">'
                                ).attr("href", result.url);
                              $('<div class="main-search-result__text">')
                                .html(result.title)
                                .appendTo($item),
                                $resultsPages.append($item);
                            }
                          if (response.resources.results.articles)
                            for (
                              var i = 0;
                              i < response.resources.results.articles.length;
                              i++
                            ) {
                              var result =
                                  response.resources.results.articles[i],
                                $item = $(
                                  '<a class="main-search-result main-search-result--article">'
                                ).attr("href", result.url);
                              $('<div class="main-search-result__text">')
                                .html(result.title)
                                .appendTo($item),
                                $resultsPages.append($item);
                            }
                          $searchContainer.removeClass("main-search--loading");
                          var areProducts =
                              $resultsProducts.find(".main-search-result:first")
                                .length > 0,
                            arePages =
                              $resultsPages.find(".main-search-result:first")
                                .length > 0;
                          areProducts || arePages
                            ? ($searchContainer.addClass(
                                "main-search--has-results"
                              ),
                              $searchContainer.toggleClass(
                                "main-search--results-on-multiple-lines",
                                $resultsProducts.find(".product-block").length >
                                  4
                              ),
                              areProducts &&
                                $resultsBox.append($resultsProducts),
                              arePages &&
                                ($('<h6 class="main-search-result__heading">')
                                  .html(
                                    theme.strings.general_quick_search_pages
                                  )
                                  .prependTo($resultsPages),
                                $resultsBox.append($resultsPages)),
                              $(
                                '<a class="main-search__results-all-link button altcolour">'
                              )
                                .attr("href", linkURL)
                                .html(theme.strings.layout_live_search_see_all)
                                .appendTo($resultsBox))
                            : ($searchContainer.addClass(
                                "main-search--no-results"
                              ),
                              $('<div class="main-search__empty-message">')
                                .html(
                                  theme.strings.general_quick_search_no_results
                                )
                                .appendTo($resultsBox));
                        },
                        error: function (response) {
                          console.log("Error fetching results");
                        },
                      }));
                  }, searchTimeoutThrottle));
              } else
                $(this).val().length <= 2 &&
                  ($(this).data("oldval", valueToSearch),
                  currReqObj?.abort(),
                  clearTimeout(searchTimeoutID),
                  $searchContainer.removeClass(
                    "main-search--has-results main-search--results-on-multiple-lines main-search--loading"
                  ),
                  $resultsBox.empty());
            }
          );
        }
        theme.Navigation.init({
          nav: $(".navigation--main", container),
          proxyTier1Nav: $(".navigation--left", container),
        }),
          theme.inlineNavigationCheck
            ? (theme.inlineNavigationCheck(),
              $(window).on(
                "debouncedresize.headerSection",
                theme.inlineNavigationCheck
              ))
            : document.querySelector("#InlineNavigationCheckScript") &&
              eval(
                document.querySelector("#InlineNavigationCheckScript").innerHTML
              ),
          this.functions.setStickyHeaderHeight.call(this),
          $(window).on(
            "debouncedresize.headerSection",
            this.functions.setStickyHeaderHeight.bind(this)
          ),
          $(".disclosure", container).each(function () {
            $(this).data("disclosure", new theme.Disclosure($(this)));
          }),
          $(".mobile-navigation-drawer .disclosure").each(function () {
            $(this).data("disclosure", new theme.Disclosure($(this)));
            var $list = $(".disclosure-list", this),
              listHeight = 0;
            $list.children().each(function () {
              listHeight += $(this).height();
            }),
              $(".disclosure-list", this).css(
                "height",
                "".concat(listHeight, "px")
              );
          }),
          $(document).on("theme:cartchanged.headerSection", function () {
            $.get(theme.routes.search_url, function (data) {
              for (
                var cartSummarySelectors = [
                    "#pageheader .logo-area__right__inner",
                  ],
                  i = 0;
                i < cartSummarySelectors.length;
                i++
              ) {
                var $newCartObj = $("<div>" + data + "</div>")
                    .find(cartSummarySelectors[i])
                    .first(),
                  $currCart = $(cartSummarySelectors[i]);
                $currCart.html($newCartObj.html());
              }
            });
          });
      }),
        (this.onSectionUnload = function (container2) {
          $(container2).off(".headerSection"),
            $(document).off(".headerSection"),
            $(window).off(".headerSection"),
            $(".disclosure", container2).each(function () {
              $(this).data("disclosure").unload();
            }),
            $(".mobile-navigation-drawer .disclosure").each(function () {
              $(this).data("disclosure").unload();
            }),
            theme.Navigation.destroy(
              $(".navigation", container2),
              $(".navigation--left", container2)
            );
        }),
        (this.functions = {
          setStickyHeaderHeight: function setStickyHeaderHeight() {
            var header = document.querySelector(".section-header"),
              stickyHeaderHeight = 0;
            header &&
              (getComputedStyle(header).position === "sticky" ||
                getComputedStyle(header).position === "-webkit-sticky") &&
              (stickyHeaderHeight = Math.ceil(header.clientHeight)),
              document.documentElement.style.setProperty(
                "--theme-sticky-header-height",
                stickyHeaderHeight + "px"
              );
          },
        });
    })()),
    (theme.ImageWithTextOverlaySection = new (function () {
      var _ = this;
      (_.checkForHeaderHeightSubtraction = function () {
        $(
          ".section-image-with-text-overlay .height--full-minus-header-height"
        ).each(function () {
          var height = $(window).height() - $(".section-header").height();
          $(".rimage-outer-wrapper, .placeholder-image", this).height(height);
        });
      }),
        (this.onSectionLoad = function (container2) {
          $(".height--full", container2).each(function () {
            $(this).closest(".section-image-with-text-overlay").index() == 0 &&
              ($(this).addClass("height--full-minus-header-height"),
              _.checkForHeaderHeightSubtraction(),
              $(window)
                .off("debouncedresize.imageWithTextOverlaySection")
                .on(
                  "debouncedresize.imageWithTextOverlaySection",
                  _.checkForHeaderHeightSubtraction
                ));
          });
        }),
        (this.onSectionUnload = function (container2) {
          $(window).off(".imageWithTextOverlaySection");
        });
    })()),
    (theme.ListCollectionsTemplateSection = new (function () {
      (this.onSectionLoad = function (container2) {
        theme.ProductBlockManager.loadImages(container2);
      }),
        (this.onSectionUnload = function (container2) {
          theme.ProductBlockManager.unloadImages(container2);
        });
    })()),
    (theme.ProductTemplateSection = new (function () {
      (this.onSectionLoad = function (container2) {
        theme.classUpTextLinks(container2),
          $("[data-store-availability-container]", container2).length &&
            (this.storeAvailability = new theme.StoreAvailability(
              $("[data-store-availability-container]", container2)[0]
            )),
          $(".product-form", container2).trigger("load-product-form"),
          theme.initProductGallery(container2),
          theme.ProductBlockManager.loadImages(container2),
          $(".theme-product-reviews", container2).on("click", "a", function () {
            return (
              $("html,body").animate(
                { scrollTop: $($(this).attr("href")).offset().top },
                1e3
              ),
              !1
            );
          });
      }),
        (this.onSectionUnload = function (container2) {
          theme.ProductBlockManager.unloadImages(container2),
            theme.destroyProductGallery(container2),
            theme.OptionManager.unloadProductOptions(
              $(".product-form", container2)
            ),
            $(".theme-product-reviews", container2).off("click"),
            this.storeAvailability && this.storeAvailability.onSectionUnload();
        });
    })()),
    (theme.SlideshowSection = new (function () {
      var _ = this;
      (_.checkForHeaderHeightSubtraction = function () {
        $(".section-slideshow .height--full-minus-header-height").each(
          function () {
            var height = $(window).height() - $(".section-header").height();
            $(".rimage-outer-wrapper, .placeholder-image", this).height(height);
          }
        );
      }),
        (this.onSectionLoad = function (target) {
          $(".slideshow", target).each(function () {
            var slideshowSpeed =
                $(this).data("transition") === "instant" ? 0 : 800,
              autoplaySpeed = $(this).data("autoplay-speed") * 1e3;
            $(this).find(".height--full").length &&
              $(this).closest(".section-slideshow").index() == 0 &&
              ($(this).addClass("height--full-minus-header-height"),
              _.checkForHeaderHeightSubtraction(),
              $(window)
                .off("debouncedresize.slideshowSection")
                .on(
                  "debouncedresize.slideshowSection",
                  _.checkForHeaderHeightSubtraction
                )),
              $(this)
                .on("init", function () {
                  $(".lazyload--manual", this)
                    .removeClass("lazyload--manual")
                    .addClass("lazyload");
                })
                .slick({
                  autoplay: $(this).data("autoplay"),
                  fade: $(this).data("transition") !== "slide",
                  speed: slideshowSpeed,
                  autoplaySpeed,
                  arrows: $(this).data("navigation") === "arrows",
                  dots: $(this).data("navigation") === "dots",
                  pauseOnHover: !1,
                  infinite: !0,
                  useTransform: !0,
                  prevArrow:
                    '<button type="button" class="slick-prev" aria-label="' +
                    theme.strings.previous +
                    '">' +
                    theme.icons.chevronLeft +
                    "</button>",
                  nextArrow:
                    '<button type="button" class="slick-next" aria-label="' +
                    theme.strings.next +
                    '">' +
                    theme.icons.chevronRight +
                    "</button>",
                  customPaging: function (slider, i) {
                    return (
                      '<button class="custom-dot" type="button" data-role="none" role="button" tabindex="0"><svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="30px" height="30px" viewBox="0 0 30 30" xml:space="preserve"><circle class="circle-one" cx="15" cy="15" r="13" />' +
                      '<circle class="circle-two" cx="15" cy="15" r="13" style="animation-duration: '.concat(
                        autoplaySpeed + slideshowSpeed,
                        'ms" />'
                      ) +
                      "</svg></button>"
                    );
                  },
                  responsive: [
                    {
                      breakpoint: 768,
                      settings: {
                        arrows: !1,
                        dots: $(this).data("navigation") !== "none",
                      },
                    },
                  ],
                })
                .on("beforeChange", function (event, slick, currentSlide) {
                  if (
                    $(this).data("transition") === "slide_fade" ||
                    $(this).data("transition") === "zoom"
                  ) {
                    var $outgoingSlide = $(slick.$slides.get(currentSlide));
                    $outgoingSlide.addClass("slick--leaving");
                  }
                })
                .on("afterChange", function (event, slick) {
                  $(slick.$slides)
                    .filter(".slick--leaving")
                    .removeClass("slick--leaving");
                });
          });
        }),
        (this.onSectionUnload = function (target) {
          $(".slick-slider", target).slick("unslick").off("init"),
            $(window).off(".slideshowSection");
        }),
        (this.onBlockSelect = function (target) {
          $(target)
            .closest(".slick-slider")
            .slick("slickGoTo", $(target).data("slick-index"))
            .slick("slickPause");
        }),
        (this.onBlockDeselect = function (target) {
          $(target).closest(".slick-slider").slick("slickPlay");
        });
    })()),
    (theme.TestimonialsSection = new (function () {
      (this.onSectionLoad = function (container2) {
        (this.namespace = theme.namespaceFromSection(container2)),
          (this.$testimonialContainer = $(".testimonial-list", container2)),
          this.$testimonialContainer
            .find(".testimonial-list__inner")
            .on("init", function () {
              $(".lazyload--manual", this)
                .removeClass("lazyload--manual")
                .addClass("lazyload");
            })
            .slick({
              fade: this.$testimonialContainer.hasClass(
                "testimonial-list--with-images"
              ),
              slidesToShow: this.$testimonialContainer.hasClass(
                "testimonial-list--without-images"
              )
                ? 2
                : 1,
              dots: !1,
              arrows: !0,
              appendArrows: this.$testimonialContainer.find(
                ".testimonial-list__controls"
              ),
              prevArrow:
                '<button type="button" class="slick-prev" aria-label="' +
                theme.strings.previous +
                '">' +
                theme.icons.chevronLeft +
                "</button>",
              nextArrow:
                '<button type="button" class="slick-next" aria-label="' +
                theme.strings.next +
                '">' +
                theme.icons.chevronRight +
                "</button>",
              responsive: [
                { breakpoint: 768, settings: { fade: !1, slidesToShow: 1 } },
              ],
            });
      }),
        (this.onSectionUnload = function (container2) {
          $(".slick-slider", container2).each(function () {
            $(this).slick("unslick").off("init");
          });
        }),
        (this.onBlockSelect = function (block) {
          var blockSlideIndex = $(block).data("slick-index");
          $(block)
            .closest(".slick-slider")
            .each(function () {
              $(this).slick("slickGoTo", blockSlideIndex);
            });
        });
    })()),
    $(function ($2) {
      var $2 = $2;
      $2(document).on("keyup.themeTabCheck", function (evt) {
        evt.keyCode === 9 &&
          ($2("body").addClass("tab-used"),
          $2(document).off("keyup.themeTabCheck"));
      }),
        $2(document).on("click", "a[data-toggle-target]", function (e) {
          e.preventDefault();
          var $toggler = $2(this),
            $target = $2($2(this).data("toggle-target")),
            $transCont = $target.find(".toggle-target-container"),
            doCollapse = !$target.hasClass("toggle-target--hidden"),
            transitionDuration =
              $target.css("transition-duration").indexOf("ms") >= 0
                ? parseInt($target.css("transition-duration"))
                : parseFloat($target.css("transition-duration")) * 1e3;
          $target.data("toggle-in-progress") ||
            ($target.data("toggle-in-progress", !0),
            doCollapse
              ? ($toggler.addClass("toggle-target-toggler--is-hidden"),
                $target.css({
                  height: $transCont.outerHeight() + "px",
                  opacity: 1,
                }),
                setTimeout(function () {
                  $target.css({ height: 0, opacity: 0 }),
                    setTimeout(function () {
                      $target.addClass("toggle-target--hidden"),
                        $target.css({ height: "", opacity: "" }),
                        $target.data("toggle-in-progress", !1);
                    }, transitionDuration);
                }, 10))
              : ($toggler.removeClass("toggle-target-toggler--is-hidden"),
                $target.css({ height: 0, opacity: 0, display: "block" }),
                setTimeout(function () {
                  $target.css({
                    height: $transCont.outerHeight() + "px",
                    opacity: 1,
                  }),
                    setTimeout(function () {
                      $target.removeClass("toggle-target--hidden"),
                        $target.css({ height: "", opacity: "", display: "" }),
                        $target.data("toggle-in-progress", !1);
                    }, transitionDuration);
                }, 10)));
        }),
        $2(document).on("change", "select.navdrop", function () {
          window.location = $2(this).val();
        }),
        $2(document).on("click", ".mobile-nav-toggle", function (e) {
          e.preventDefault(),
            $2("body").hasClass("enable-mobile-nav-transition")
              ? ($2("body").removeClass("reveal-mobile-nav"),
                setTimeout(function () {
                  $2("body").removeClass("enable-mobile-nav-transition");
                }, 750))
              : ($2("body").addClass("enable-mobile-nav-transition"),
                setTimeout(function () {
                  $2("body").addClass("reveal-mobile-nav"),
                    $2(".mobile-navigation-drawer .disclosure").each(
                      function () {
                        var $list = $2(".disclosure-list", this),
                          listHeight = 0;
                        $list.children().each(function () {
                          listHeight += $2(this).height();
                        }),
                          $2(".disclosure-list", this).css(
                            "height",
                            listHeight + "px"
                          );
                      }
                    ),
                    $2(".mobile-navigation-drawer .product-list").each(
                      function () {
                        theme.ProductBlockManager.loadImages($2(this));
                      }
                    );
                }, 10));
        }),
        $2(
          '<a href="#" class="page-shade" aria-label="' +
            theme.strings.general_navigation_menu_toggle_aria_label +
            '"></a>'
        )
          .on("click", function () {
            return (
              $2("body").removeClass("reveal-mobile-nav show-search"),
              setTimeout(function () {
                $2("body").removeClass("enable-mobile-nav-transition");
              }, 750),
              !1
            );
          })
          .appendTo("body"),
        theme.settings.quickbuy_style != "off" && theme.loadQuickbuy(),
        $2(document).on("load-product-form", ".product-form", function (e) {
          $2(this).on("variantChanged", function (evt, variant2) {
            var $labelCont = $2(this)
              .closest(".product-detail")
              .find(".product-label-container");
            $labelCont.find(".product-label").remove(),
              $labelCont.append($2("#variant-label-" + variant2.id).html());
          }),
            theme.OptionManager.initProductOptions($2(this));
          var $clickies = $2(this)
            .find("[data-make-box]")
            .addClass("has-clickyboxes")
            .find("select")
            .clickyBoxes();
          if ($clickies.length > 0) {
            $2(this).closest(".quickbuy-container").trigger("changedsize");
            for (
              var productData = theme.OptionManager.getProductData($2(this)),
                optionIndex = 0;
              optionIndex < productData.options.length;
              optionIndex++
            ) {
              for (
                var optionValues = {}, variantIndex = 0;
                variantIndex < productData.variants.length;
                variantIndex++
              ) {
                var variant = productData.variants[variantIndex];
                typeof optionValues[variant.options[optionIndex]] > "u" &&
                  (optionValues[variant.options[optionIndex]] = !1),
                  variant.available &&
                    (optionValues[variant.options[optionIndex]] = !0);
              }
              for (var key in optionValues)
                optionValues[key] ||
                  $2(
                    ".selector-wrapper:eq(" +
                      optionIndex +
                      ") .clickyboxes li a",
                    this
                  )
                    .filter(function () {
                      return $2(this).attr("data-value") == key;
                    })
                    .addClass("unavailable");
            }
          }
          $2(this)
            .find(".selector-wrapper:not([data-make-box]) select")
            .each(function () {
              theme.select2.init($2(this));
            }),
            $2(this).on("unloading", function () {
              $2(this).off("unloading variantChanged"),
                $2(this)
                  .find(".selector-wrapper select.clickybox-replaced")
                  .clickyBoxes("destroy"),
                theme.select2.destroyAllIn($2(this).find(".selector-wrapper"));
            });
        }),
        $2(document).on("variantImageSelected", ".gallery", function (e, data) {
          var mediaId = data.featured_media.id;
          $2(this)
            .find('.thumbnails a[data-media-id="' + mediaId + '"]:first')
            .trigger("select");
        }),
        $2(document).on(
          "click",
          ".product-detail .gallery .main-image a.show-gallery",
          function () {
            var images = [],
              currentIndex = 0,
              $thumbs = $2(this)
                .closest(".gallery")
                .find(".thumbnails .thumbnail--media-image");
            if ($thumbs.length)
              $thumbs.each(function () {
                var $imgThumb2 = $2(this).find(".rimage-outer-wrapper").clone();
                $imgThumb2
                  .find(".lazyloaded")
                  .removeClass("lazyloaded")
                  .addClass("lazyload")
                  .parent()
                  .addClass("lazyload--placeholder"),
                  images.push({
                    thumbTag: $imgThumb2,
                    zoomUrl: $2(this).attr("href"),
                  });
              }),
                $thumbs.each(function (thisIndex) {
                  if ($2(this).hasClass("selected"))
                    return (currentIndex = thisIndex), !1;
                });
            else {
              var $imgThumb = $2(this).find(".rimage-outer-wrapper").clone();
              $imgThumb
                .find(".lazyloaded")
                .removeClass("lazyloaded")
                .addClass("lazyload")
                .parent()
                .addClass("lazyload--placeholder"),
                images.push({
                  thumbTag: $imgThumb,
                  zoomUrl: $2(this).attr("href"),
                });
            }
            return (
              theme.buildGalleryViewer({
                images,
                current: currentIndex,
                prev: theme.icons.chevronLeft,
                next: theme.icons.chevronRight,
                close: theme.icons.close,
              }),
              !1
            );
          }
        );
      var $nonSectionedProductLists = $2(
        ".product-list, .collection-listing"
      ).filter(function () {
        return $2(this).closest("[data-section-type]").length == 0;
      });
      $nonSectionedProductLists.length &&
        theme.ProductBlockManager.loadImages($nonSectionedProductLists),
        $2(window).on("debouncedresize", function () {
          setTimeout(function () {
            theme.ProductBlockManager.afterImagesResized();
          }, 100);
        }),
        theme.classUpTextLinks(document),
        $2("#template label").each(function () {
          var $sibinputs = $2(this).siblings(
            'input:not([type="submit"]), textarea'
          );
          $sibinputs.length == 1 &&
            $sibinputs.attr("id").length > 0 &&
            $2(this).attr("for", $sibinputs.attr("id"));
        }),
        $2(document).on(
          "click",
          ".quantity-wrapper [data-quantity]",
          function () {
            var adj = $2(this).data("quantity") == "up" ? 1 : -1,
              $qty = $2(this)
                .closest(".quantity-wrapper")
                .find("[name=quantity]");
            return (
              $qty.attr("step") && (adj *= parseInt($qty.attr("step"))),
              $qty
                .val(Math.max(1, parseInt($qty.val()) + adj))
                .trigger("change"),
              !1
            );
          }
        ),
        $2(".responsive-table").on(
          "click",
          ".responsive-table__cell-head",
          function () {
            if ($2(window).width() < 768)
              return $2(this).closest("tr").toggleClass("expanded"), !1;
          }
        ),
        $2(document).on("click", "#logoImg", function (e) {
          localStorage.setItem("last-active", "/");
        }),
        $2(document).on("click", "#parent-1", function (e) {
          localStorage.setItem("last-active", "/");
        }),
        $2(document).on("click", "#parent-2", function (e) {
          localStorage.setItem("last-active", "/pages/men-page");
        }),
        $2(document).on("click", "#parent-3", function (e) {
          localStorage.setItem("last-active", "/pages/tirajeans");
        }),
        $2(document).on("click", "#parent-4", function (e) {
          localStorage.setItem("last-active", "/pages/executiveactive");
        }),
        $2(document).on("click", "#menuMobile1", function (e) {
          localStorage.setItem("last-active", "/");
        }),
        $2(document).on("click", "#menuMobile2", function (e) {
          localStorage.setItem("last-active", "/pages/men-page");
        }),
        $2(document).on("click", "#menuMobile3", function (e) {
          localStorage.setItem("last-active", "/pages/tirajeans");
        }),
        $2(document).on("click", "#menuMobile4", function (e) {
          localStorage.setItem("last-active", "/pages/executiveactive");
        }),
        $2(document).on("click", ".drawer-mobile-nav-toggle", function (e) {
          e.preventDefault(),
            $2(".drawer-menu__list")
              .find(".drawer-menu__child.open")
              .removeClass("open"),
            $2(".drawer-menu__list")
              .find(".nav__item-group.active")
              .removeClass("active"),
            $2(".drawer-menu__mobile").toggleClass("show");
          var classList = document
            .getElementById("drawer_mobile")
            .className.split(/\s+/);
          const navbar = document.querySelector(".main_menu__mobile");
          for (var i = 0; i < classList.length; i++)
            classList[i] === "show"
              ? (navbar.classList.contains("visible") ||
                  navbar.classList.add("visible"),
                (document.getElementById("svgMenu").style.display = "none"),
                (document.getElementById("svgX").style.display = "block"),
                (document.getElementsByTagName("body")[0].style =
                  "overflow-y: hidden"))
              : ((document.getElementById("svgMenu").style.display = "block"),
                (document.getElementById("svgX").style.display = "none"),
                document
                  .getElementsByTagName("body")[0]
                  .removeAttribute("style"));
        }),
        $2(document).on("click", ".nav__item > .nav__item-group", function (e) {
          e.preventDefault();
          for (
            var classList = $2(this)
                .parent()[0]
                .children[1].className.split(/\s+/),
              i = 0;
            i < classList.length;
            i++
          )
            classList[i] === "open"
              ? ($2(".drawer-menu__list")
                  .find(".drawer-menu__child.open")
                  .removeClass("open"),
                $2(".drawer-menu__list")
                  .find(".nav__item-group.active")
                  .removeClass("active"))
              : ($2(".drawer-menu__list")
                  .find(".drawer-menu__child.open")
                  .removeClass("open"),
                $2(".drawer-menu__list")
                  .find(".nav__item-group.active")
                  .removeClass("active"),
                $2(this)[0].classList.add("active"),
                $2(this).parent()[0].children[1].classList.add("open"));
        }),
        $2(document).on("click", ".message-toggle", function (e) {
          e.preventDefault(),
            $2("#store-messages-mobile")
              .find(".message__container-detail.show")
              .removeClass("show");
          const toggle = $2(this).parent().find(".message__container-detail");
          toggle.toggleClass("show"),
            setTimeout(function () {
              toggle.removeClass("show");
            }, 5e3);
        }),
        (lastPath = localStorage.getItem("last-active")),
        (lastPath === null || lastPath === undefined) &&
          ($2("#parent-1").toggleClass("nav__item--active"),
          $2("#parent2").remove(),
          $2("#parent3").remove(),
          $2("#parent4").remove(),
          $2("#drawerList2").remove(),
          $2("#drawerList3").remove(),
          $2("#drawerList4").remove(),
          $2("#menuMobile1").attr("class").includes("active") ||
          $2("#menuMobile1").toggleClass("active")),
        (lastPath == "/pages/women-page" || lastPath == "/") &&
          ($2("#parent-1").toggleClass("nav__item--active"),
          $2("#parent2").remove(),
          $2("#parent3").remove(),
          $2("#parent4").remove(),
          $2("#drawerList2").remove(),
          $2("#drawerList3").remove(),
          $2("#drawerList4").remove(),
          $2("#menuMobile1").attr("class").includes("active") ||
            $2("#menuMobile1").toggleClass("active")),
        lastPath == "/pages/men-page" &&
          ($2("#parent-2").toggleClass("nav__item--active"),
          $2("#parent1").remove(),
          $2("#parent3").remove(),
          $2("#parent4").remove(),
          $2("#drawerList1").remove(),
          $2("#drawerList3").remove(),
          $2("#drawerList4").remove(),
          $2("#menuMobile2").attr("class").includes("active") ||
          $2("#menuMobile2").toggleClass("active")),
        lastPath == "/pages/tirajeans" &&
          ($2("#parent-3").toggleClass("nav__item--active"),
          $2("#parent1").remove(),
          $2("#parent2").remove(),
          $2("#parent4").remove(),
          $2("#drawerList1").remove(),
          $2("#drawerList2").remove(),
          $2("#drawerList4").remove(),
          $2("#menuMobile3").attr("class").includes("active") ||
          $2("#menuMobile3").toggleClass("active")),
          lastPath == "/pages/executiveactive" &&
          ($2("#parent-4").toggleClass("nav__item--active"),
          $2("#parent1").remove(),
          $2("#parent2").remove(),
          $2("#parent3").remove(),
          $2("#drawerList1").remove(),
          $2("#drawerList2").remove(),
          $2("#drawerList3").remove(),
          $2("#menuMobile4").attr("class").includes("active") ||
          $2("#menuMobile4").toggleClass("active")),
        theme.Sections.init(),
        theme.Sections.register("slideshow", theme.SlideshowSection),
        theme.Sections.register("gallery", theme.GallerySection),
        theme.Sections.register("testimonials", theme.TestimonialsSection),
        theme.Sections.register(
          "image-with-text-overlay",
          theme.ImageWithTextOverlaySection
        ),
        theme.Sections.register(
          "featured-collection",
          theme.FeaturedCollectionSection
        ),
        theme.Sections.register(
          "featured-collections",
          theme.FeaturedCollectionsSection
        ),
        theme.Sections.register("map", theme.MapSection),
        theme.Sections.register("background-video", theme.VideoManager, {
          deferredLoadViewportExcess: 800,
        }),
        theme.Sections.register("custom-row", theme.CustomRowSection),
        theme.Sections.register(
          "featured-product",
          theme.FeaturedProductSection
        ),
        theme.Sections.register("header", theme.HeaderSection, {
          deferredLoad: !1,
        }),
        theme.Sections.register(
          "announcement-bar",
          theme.AnnouncementBarSection,
          { deferredLoad: !1 }
        ),
        theme.Sections.register("footer", theme.FooterSection),
        theme.Sections.register("main-product", theme.ProductTemplateSection, {
          deferredLoad: !1,
        }),
        theme.Sections.register(
          "collection-template",
          theme.CollectionTemplateSection,
          { deferredLoad: !1 }
        ),
        theme.Sections.register("blog-template", theme.BlogTemplateSection, {
          deferredLoad: !1,
        }),
        theme.Sections.register("cart-template", theme.CartTemplateSection, {
          deferredLoad: !1,
        }),
        theme.Sections.register(
          "list-collections-template",
          theme.ListCollectionsTemplateSection,
          { deferredLoad: !1 }
        ),
        theme.Sections.register(
          "page-list-collections-template",
          theme.ListCollectionsTemplateSection,
          { deferredLoad: !1 }
        );
    }),
    $(function ($2) {
      cc.sections.length
        ? cc.sections.forEach(function (section) {
            try {
              theme.Sections.register(section.name, section.section);
            } catch (err) {
              console.error(
                "Unable to register section ".concat(section.name, "."),
                err
              );
            }
          })
        : console.warn("Barry: No common sections have been registered.");
    });
})(theme.jQuery);
function reloadPageProduct() {
  var elem = $(document).find("div.product-form");
  elem.on("variantChanged", function (evt, variant2) {
    var $labelCont = elem
      .closest(".product-detail")
      .find(".product-label-container");
    $labelCont.find(".product-label").remove(),
      $labelCont.append($("#variant-label-" + variant2.id).html());
  }),
    theme.OptionManager.initProductOptions(elem);
  var $clickies = elem
    .find("[data-make-box]")
    .addClass("has-clickyboxes")
    .find("select")
    .clickyBoxes();
  if ($clickies.length > 0) {
    elem.closest(".quickbuy-container").trigger("changedsize");
    for (
      var productData = theme.OptionManager.getProductData(elem),
        optionIndex = 0;
      optionIndex < productData.options.length;
      optionIndex++
    ) {
      for (
        var optionValues = {}, variantIndex = 0;
        variantIndex < productData.variants.length;
        variantIndex++
      ) {
        var variant = productData.variants[variantIndex];
        typeof optionValues[variant.options[optionIndex]] > "u" &&
          (optionValues[variant.options[optionIndex]] = !1),
          variant.available &&
            (optionValues[variant.options[optionIndex]] = !0);
      }
      for (var key in optionValues)
        optionValues[key] ||
          $(".selector-wrapper:eq(" + optionIndex + ") .clickyboxes li a", elem)
            .filter(function () {
              return $(this).attr("data-value") == key;
            })
            .addClass("unavailable");
    }
  }
  elem.find(".selector-wrapper:not([data-make-box]) select").each(function () {
    theme.select2.init($(this));
  }),
    elem.on("unloading", function () {
      $(this).off("unloading variantChanged"),
        $(this)
          .find(".selector-wrapper select.clickybox-replaced")
          .clickyBoxes("destroy"),
        theme.select2.destroyAllIn($(this).find(".selector-wrapper"));
    });
}
function generateScriptTagProduct() {
  var script_tag = document.createElement("script");
  (script_tag.type = "text/javascript"),
    (script_tag.text = `var containerSize = document.getElementsByClassName('container-size');

  var selectedSize = function () {
    var disabled = this.getAttribute('data-disabled');

    if(disabled == "true") {
      $(".button.button--large").html("Terjual Habis").attr("disabled", "disabled");
    } else {
      $(".button.button--large").html("Tambahkan Ke Keranjang").removeAttr("disabled");
    };

    for (var i = 0; i < containerSize.length; i++) {
      containerSize[i].classList.remove('selected');
    }

    var size = this.getAttribute('data-size');
    var variantId = this.getAttribute('data-variant');
    var sku = this.getAttribute('data-sku');
    this.classList.add('selected');

    $('#sizeLabel').html("Size : " + size.toUpperCase());
    $('.sku__value').html(sku);
  };

  for (var i = 0; i < containerSize.length; i++) {
    containerSize[i].addEventListener('click', selectedSize, false);
  }

  document.getElementById('product-form').addEventListener('submit', function (event) {
    event.preventDefault(); // Menghentikan pengiriman formulir default
    // Panggil fungsi untuk mengirim formulir
    submitForm();
  });`),
    script_tag.setAttribute("id", "tempScript"),
    script_tag.setAttribute("defer", "defer"),
    document.body.appendChild(script_tag);
}
function generateProduct(product) {
  $("#modalProductBody").empty();
  let html = `
  <div class="product-detail quickbuy-content container">
    <div
      class="gallery gallery-layout-beside gallery-size-medium product-column-left has-thumbnails cc-animate-init gallery-initialised -in cc-animate-complete"
      data-cc-animate=""
      data-cc-animate-delay="0.2s"
      style=""
    >
      <div class="gallery__inner">
        <div class="main-image desktop-only">
          <div
            class="slideshow product-slideshow slideshow--custom-initial slick-initialized slick-slider"
            data-slick="{&quot;adaptiveHeight&quot;:true,&quot;initialSlide&quot;:0}"
          >
            <div aria-live="polite" class="slick-list draggable">
              <div class="slick-track" aria-label="" role="listbox" style="opacity: 1; width: 1640px;">
                <div
                  class="slide slide--custom-initial slick-slide slick-current slick-active"
                  data-slick-index="0"
                  aria-hidden="false"
                  tabindex="-1"
                  role="option"
                  style="width: 284px; position: relative; left: 0px; top: 0px; z-index: 999; opacity: 1;"
                >
                  <div
                    id="FeaturedMedia-template--15155899367586__main-29749680144546-wrapper"
                    class="product-media-wrapper"
                    data-media-id="template--15155899367586__main-29749680144546"
                  >
                    <div class="product-media product-media--image">
                      <div class="rimage-outer-wrapper" style="max-width: 762px">
                        <div class="rimage-wrapper">
                          <picture>
                            <source
                              media="(max-width: 180px)"
                              srcset="${
                                product.images.edges[0].node.src.split(
                                  ".jpg"
                                )[0]
                              }_180x.jpg${
    product.images.edges[0].node.src.split(".jpg")[1]
  }"
                            >
                            <source
                              media="(max-width: 220px)"
                              srcset="${
                                product.images.edges[0].node.src.split(
                                  ".jpg"
                                )[0]
                              }_220x.jpg${
    product.images.edges[0].node.src.split(".jpg")[1]
  }"
                            >
                            <source
                              media="(max-width: 300px)"
                              srcset="${
                                product.images.edges[0].node.src.split(
                                  ".jpg"
                                )[0]
                              }_300x.jpg${
    product.images.edges[0].node.src.split(".jpg")[1]
  }"
                            >
                            <source
                              media="(max-width: 360px)"
                              srcset="${
                                product.images.edges[0].node.src.split(
                                  ".jpg"
                                )[0]
                              }_360x.jpg${
    product.images.edges[0].node.src.split(".jpg")[1]
  }"
                            >
                            <source
                              media="(max-width: 460px)"
                              srcset="${
                                product.images.edges[0].node.src.split(
                                  ".jpg"
                                )[0]
                              }_460x.jpg${
    product.images.edges[0].node.src.split(".jpg")[1]
  }"
                            >
                            <source
                              media="(max-width: 540px)"
                              srcset="${
                                product.images.edges[0].node.src.split(
                                  ".jpg"
                                )[0]
                              }_540x.jpg${
    product.images.edges[0].node.src.split(".jpg")[1]
  }"
                            >
                            <source
                              media="(max-width: 720px)"
                              srcset="${
                                product.images.edges[0].node.src.split(
                                  ".jpg"
                                )[0]
                              }_720x.jpg${
    product.images.edges[0].node.src.split(".jpg")[1]
  }"
                            >
                            <source
                              media="(max-width: 900px)"
                              srcset="${
                                product.images.edges[0].node.src.split(
                                  ".jpg"
                                )[0]
                              }_900x.jpg${
    product.images.edges[0].node.src.split(".jpg")[1]
  }"
                            >
                            <source
                              media="(max-width: 1080px)"
                              srcset="${
                                product.images.edges[0].node.src.split(
                                  ".jpg"
                                )[0]
                              }_1080x.jpg${
    product.images.edges[0].node.src.split(".jpg")[1]
  }"
                            >
                            <source
                              media="(max-width: 1296px)"
                              srcset="${
                                product.images.edges[0].node.src.split(
                                  ".jpg"
                                )[0]
                              }_1296x.jpg${
    product.images.edges[0].node.src.split(".jpg")[1]
  }"
                            >
                            <source
                              media="(max-width: 1512px)"
                              srcset="${
                                product.images.edges[0].node.src.split(
                                  ".jpg"
                                )[0]
                              }_1512x.jpg${
    product.images.edges[0].node.src.split(".jpg")[1]
  }"
                            >
                            <source
                              media="(max-width: 1728px)"
                              srcset="${
                                product.images.edges[0].node.src.split(
                                  ".jpg"
                                )[0]
                              }_1728x.jpg${
    product.images.edges[0].node.src.split(".jpg")[1]
  }"
                            >
                            <source
                              media="(max-width: 2048px)"
                              srcset="${
                                product.images.edges[0].node.src.split(
                                  ".jpg"
                                )[0]
                              }_2048x.jpg${
    product.images.edges[0].node.src.split(".jpg")[1]
  }"
                            >
                            <img
                              src="${
                                product.images.edges[0].node.src.split(
                                  ".jpg"
                                )[0]
                              }_1024x1024.jpg${
    product.images.edges[0].node.src.split(".jpg")[1]
  }"
                              alt="${product.title}"
                            >
                          </picture>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="thumbnails">`;
  product.images.edges.forEach((e) => {
    html += `<div class="rimage-outer-wrapper" style="max-width: 762px">
            <div class="rimage-wrapper resize">
              <picture>
                <source
                  media="(max-width: 180px)"
                  srcset="${e.node.src.split(".jpg")[0]}_180x.jpg${
      e.node.src.split(".jpg")[1]
    }"
                >
                <source
                  media="(max-width: 220px)"
                  srcset="${e.node.src.split(".jpg")[0]}_220x.jpg${
      e.node.src.split(".jpg")[1]
    }"
                >
                <source
                  media="(max-width: 300px)"
                  srcset="${e.node.src.split(".jpg")[0]}_300x.jpg${
      e.node.src.split(".jpg")[1]
    }"
                >
                <source
                  media="(max-width: 360px)"
                  srcset="${e.node.src.split(".jpg")[0]}_360x.jpg${
      e.node.src.split(".jpg")[1]
    }"
                >
                <img
                  src="${e.node.src.split(".jpg")[0]}_1024x1024.jpg${
      e.node.src.split(".jpg")[1]
    }"
                  alt="demon slayer executive"
                >
              </picture>
            </div>
          </div>`;
  }),
    (html += `
    </div>
    </div>
    </div>
    <div
      class="detail product-column-right cc-animate-init -in cc-animate-complete"
      data-cc-animate=""
      data-cc-animate-delay="0.2s"
      style=""
    >
      <div
        class="product-form theme-init"
        data-ajax-add-to-cart="true"
        data-product-id="${product.id.replace("gid://shopify/Product/", "")}"
        data-enable-history-state="true"
        data-show-sale-price-label="true"
        data-show-preorder-label="false"
      >
        <div class="vendor">
          <span class="product-detail-label">${product.vendor.replace(
            " Collabs",
            ""
          )}</span>
        </div>
        <div class="sku">
          <span class="barcode__value">${
            product.variants.edges[0].node.barcode
          } | </span>
          <span class="sku__value">${product.variants.edges[0].node.sku}</span>
        </div>
        <div class="title-row">
          <h3 class="title">${product.title}</h3>
        </div>
        <div class="price-container">
          <div>
            <div class="price-area">
              <div class="price "><span class="current-price theme-money">Rp ${parseInt(
                product.variants.edges[0].node.price.amount.replace(".0", "")
              ).toLocaleString("en-US")}</span></div>
            </div>
          </div>
        </div>
        <div class="input-row">
          <div class="option-selectors">
            <div class="selector-wrapper styled-select has-clickyboxes" data-make-box="">
              <label id="sizeLabel"> Size </label>
              <div class="group-size">`),
    product.variants.edges.forEach((e) => {
      html += `<div class="container-size ${
        e.node.quantityAvailable <= 0 ? "out-of-stock" : ""
      }" data-size="${
        e.node.selectedOptions.find((a) => a.name == "Size").value
      }" data-variant="${e.node.id.replace(
        "gid://shopify/ProductVariant/",
        ""
      )}" data-sku="${e.node.sku}" data-disabled=${
        e.node.quantityAvailable <= 0
      }>
                  <span>${
                    e.node.selectedOptions.find((a) => a.name == "Size").value
                  }</span>
                </div>`;
    }),
    (html += `
              </div>
            </div>
          </div>
        </div>
        <div class="buy-buttons-row">
          <form
            method="post"
            action="/cart/add"
            id="product-form"
            accept-charset="UTF-8"
            class="form product-purchase-form"
            enctype="multipart/form-data"
          >
            <input type="hidden" name="form_type" value="product">
            <input type="hidden" name="utf8" value="\u2713">
            <input type="hidden" name="id" value="${product.variants.edges[0].node.id.replace(
              "gid://shopify/ProductVariant/",
              ""
            )}">

            <div class="quantity-submit-row input-row ">
              <div class="quantity-submit-row__submit input-row">
                <div class="group-btn">
                  <button
                    class="button button--large"
                    type="submit"
                    data-add-to-cart-text="Tambahkan ke Keranjang"
                    ${
                      product.variants.edges[0].node.quantityAvailable <= 0
                        ? "disabled"
                        : ""
                    }
                  >
                    ${
                      product.variants.edges[0].node.quantityAvailable <= 0
                        ? "Terjual Habis"
                        : product.tags.includes("preorder")
                        ? "PRE ORDER"
                        : "Tambahkan ke Keranjang"
                    }
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>`),
    $("#modalProductBody").append(html),
    generateScriptTagProduct();
}
function submitForm() {
  openLoadingSection();
  var formData = new FormData(document.getElementById("product-form")),
    xhr = new XMLHttpRequest();
  xhr.open("POST", "/cart/add", !0),
    (xhr.onreadystatechange = function () {
      xhr.readyState === XMLHttpRequest.DONE &&
        (xhr.status === 200
          ? closeModalProduct()
          : console.error(xhr.statusText),
        closeLoadingSection());
    }),
    xhr.send(formData);
}
function modalProduct(handle) {
  var modal = document.getElementById("modalProduct");
  (modal.style.display = "block"),
    (document.getElementsByTagName("body")[0].style = "overflow-y: hidden;"),
    $.ajax({
      url: `https://widget.delamibrands.com/executive/executive_report/products/getProduct/${handle}`,
      type: "GET",
      success: function (result) {
        generateProduct(result.data.product);
      },
    });
}
function closeModalProduct() {
  var modal = document.getElementById("modalProduct");
  (document.getElementById("email").value = ""),
    (modal.style.display = "none"),
    (document.getElementsByTagName("body")[0].style = ""),
    $("#tempScript").remove();
}
function openLoadingSection() {
  let elements = document.getElementsByClassName("loading-section");
  elements[0].style = "display: block";
}
function closeLoadingSection() {
  let elements = document.getElementsByClassName("loading-section");
  elements[0].style = "";
}
function snk(e, page) {
  $("#promo-tnc_body").empty();
  let click_at_page = "";
  $(e).attr("data-page") == "collection"
    ? (click_at_page = "PCP")
    : $(e).attr("data-page") == "product" && (click_at_page = "PDP"),
    $.ajax({
      type: "POST",
      url: `https://widget.delamibrands.com/executive/executive_report/api/getPage/${page}`,
      success: function (result) {
        mixpanel.track("Click Promo", {
          "Promo Name": $.trim($(e).text()),
          "Click at Page": click_at_page,
        }),
          $(".cc-modal-window__content #promo-tnc_body").append(
            `${result.data.page.body}`
          );
      },
    });
}
function setCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1e3),
      (expires = "; expires=" + date.toUTCString());
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}
function getCookie(name) {
  for (
    var nameEQ = name + "=", cookies = document.cookie.split(";"), i = 0;
    i < cookies.length;
    i++
  ) {
    for (var cookie = cookies[i]; cookie.charAt(0) == " "; )
      cookie = cookie.substring(1, cookie.length);
    if (cookie.indexOf(nameEQ) == 0)
      return cookie.substring(nameEQ.length, cookie.length);
  }
  return null;
}
//# sourceMappingURL=/s/files/1/0584/9363/2674/t/5/assets/theme.js.map?v=1723625659
